import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, AfterViewInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { PwaService } from 'src/app/shared/services/pwa.service';
import { Subscription } from 'rxjs';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppTourService } from 'src/app/shared/services/app-tour.service';
import { AppRecipeTourService } from 'src/app/shared/services/app-recipe-tour.service';
import { AppCouponTourService } from 'src/app/shared/services/app-coupon-tour.service';
import { AppShoppinglistTourService } from '../services/app-shoppinglist-tour.service';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { GridStack } from 'gridstack';
import { ComponentService } from 'src/app/components/component.service';
declare var $: any;
let deferredPrompt: any;
declare var FB: any;
@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	providers: [DatePipe]
})
export class HeaderComponent implements OnInit, AfterViewInit, OnDestroy {
	@Input() store_data: any = [
		{
			theme_base_color: 'rgb(139, 195, 74)'
		}
	];
	@Input() branch_list: any;
	@Input() title_position: any;
	@Input() PositionValue: any;
	store_name_slug;
	innerWidth: number = window.innerWidth;
	item_name: any;
	printDisplay12 =false
	qr_elementType: 'url' | 'canvas' | 'img' = 'url';
	qr_value_main = ''
	current_list_id: any
	current_layout_id: any;
	showPrintOptions: boolean = false;
	is_list_view: any;
	@Input() cartItem: any
	@Input() past_item: any
	@Input() textColor: any
	@Input() current_layout_data: any
	@Input() store_category: any;
	@Input() featureRowArray: any;
	@Input() selectedMainCategory: any;
	@Input() store_main_category: any;
	@Input() serializedIds: any;
	@Input() cart_ids = []
	@Input() packDetails = []
	@Input() selected_cart_items = [];
	selected_past_cart_items = []
	@Input() serializedData: any
	@Input() serializedBundleData: any
	@Input() serializedMenuData: any
	@Input() serializedCommunityData: any
	@Input() serializedRestaurantData: any
	@Input() coupons_list: any;
	@Input() showHelpIcon: boolean = true;
	showTranslateWidget: boolean = true;
	current_list_data: any
	@Output() increaseProduct = new EventEmitter;
	@Output() decreaseProduct = new EventEmitter;
	@Output() categoryList = new EventEmitter;
	@Output() categoryMainList = new EventEmitter;
	show_add_item = false
	no_content_display = false
	@Input() all_items: any;
	@Output() addToList = new EventEmitter;
	@Output() productChange = new EventEmitter<{ event: any, type: any, product: any }>();
	@Input() categories_list: any
	@Input() totalAmount: any
	@Output() removeFilter = new EventEmitter;
	@Output() showLoader = new EventEmitter;
	@Output() closeRecipeboxPanel: EventEmitter<void> = new EventEmitter<void>();
    selectedCategory='All';
    // selectedMainCategory:any;
	tabName = ''
	onlyCoupon = false
	isRecipe = false
	onlyRecipe = false
	isAllSelected = false
	isAllPastSelected = false
	qr_value = ''
	urlParam: any;
	printCart = false;
	isCoupon = false
	filtered_items = []
	store_background_color = `#76b101`
	groupList: any;
	groupBranch: any = [];
	@ViewChild('widgetsContent', { read: ElementRef }) public widgetsContent: ElementRef<any>;
	@ViewChild('widgetsMainContent', { read: ElementRef }) public widgetsMainContent: ElementRef<any>;
	isIos_hide_button: any;
	isIos_hide_button_chIOS: any;
	setInstallable: boolean = false;
	subscription: Subscription
	isAndroid: boolean;
	isIos: boolean;
	showHeaderStore: boolean = false;
	showHeaderCoupon: boolean = false;
	showHeaderBundle: boolean = false;
	store_item: any;
	private tourSeenFlag = 'tourSeen';
	private recipeTourSeenFlag = 'RecipeTourSeen';
	private CouponTourSeenFlag = 'CouponTourSeen';
	private BundlesTourSeenFlag = 'BundleTourSeen';
	private MenuTourSeenFlag = 'MenuTourSeen';
	private shoppingTourSeenFlag = 'shoppingTourSeen';
	private authSubscription: Subscription;
	private isTranslateInitializing: boolean = false;
	currentCategory: any;
	list: any;
	apck: Subscription;
	gridItemsArray: Element[];
	gridContent: string;
	print: boolean = false;
	matching_items: any;
	grid: any;
	createdCart: any;
	printDisplay: string;
	notDisplayCheckOut = false;
	current_store_uid: any;
	store_data1: any;
	displayRecipePage: boolean = false;
	displayCouponPage: boolean = false;
	displayCircularPage: boolean = false;
	displayBundlePage: boolean = false;
	displayMenuPage: boolean = false;
	displayCommunityPage: boolean = false;
	displayRestaurantPage: boolean = false;
	combinedData: any = [];
	showCategory: boolean = false;
	isRestaurantRoute=false;
	merchantId: any = '';
	privateKey: any = '';
	current_menu_data: any
	current_community_data: any
	current_restaurant_data: any
	current_bundle_data: any
	current_onsale_data: any;
	current_noad_layout_data: any
	upcomingLink: boolean;
	stores_list: any = []
	users: any;
	user: any;
	isAdmin: boolean;
	filteredStores: any = [];
	searchTerm: any = '';
	storeAccess: boolean = false;
	searchStoreList: any;
	searchGroupTerm: string = '';
	groupSearchBranch: any = [];
	showGroupStore: boolean = false; stores_group_list: any;
	isLoggedIn: boolean
	cateGoryLoad: boolean;
	loadPage: string;
	printHeaderOption: any='logoAndBanner';
	headerViewOption: any='compact';
	// title_position: string = 'above';
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		public afs: AngularFirestore,
		private _snackBar: MatSnackBar,
		private cdr: ChangeDetectorRef,
		private datePipe: DatePipe,
		public dialog: MatDialog,
		private pwaService: PwaService,
		private appTourService: AppTourService,
		private appRecipeTourService: AppRecipeTourService,
		private appCouponTourService: AppCouponTourService,
		private appShoppingListTourService: AppShoppinglistTourService,
		private analytics: AngularFireAnalytics,
		private http: HttpClient,
		private afAuth: AngularFireAuth,
		private componentService: ComponentService,

	) { }

	// code for swipe right event (close shopping list)
	private startX: number;
	private startY: number;
	countRight: number = 0;

	@HostListener('document:mousemove', ['$event'])
	@HostListener('document:touchmove', ['$event'])
	onTouchMove(event: MouseEvent | TouchEvent) {
		if (document.documentElement.clientWidth <= 767) {
			if (this.startX === null || this.startY === null) {
				return;
			}

			const currentX = this.getCurrentX(event);
			const currentY = this.getCurrentY(event);
			const deltaX = currentX - this.startX;
			const deltaY = currentY - this.startY;

			if (Math.abs(deltaX) > 40) {
				const directionX = deltaX > 0 ? 'right' : 'left';
				if (directionX == 'right') {
					this.countRight = this.countRight + 1;
				}
				if (this.countRight > 15) {
					this.CloseShoppingList();
					this.countRight = 0;
				}
			}
		}
	}

	onTouchStart(event: MouseEvent | TouchEvent) {
		this.startX = this.getCurrentX(event);
		this.startY = this.getCurrentY(event);
		this.countRight = 0;
	}

	onTouchEnd(event: MouseEvent | TouchEvent) {
		this.startX = null;
		this.startY = null;
	}

	private getCurrentX(event: MouseEvent | TouchEvent): number {
		if (event instanceof MouseEvent) {
			return event.clientX;
		} else if (event instanceof TouchEvent) {
			return event.touches[0].clientX;
		}

		return 0;
	}

	private getCurrentY(event: MouseEvent | TouchEvent): number {
		if (event instanceof MouseEvent) {
			return event.clientY;
		} else if (event instanceof TouchEvent) {
			return event.touches[0].clientY;
		}

		return 0;
	}




private reApplyTranslate() {

  const frame = document.querySelector('.goog-te-menu-frame') as HTMLIFrameElement;


  if (frame) {
    const inner = frame.contentDocument || frame.contentWindow?.document;
    const selected = inner?.querySelector('.goog-te-menu2-item-selected');
    selected?.dispatchEvent(new Event('click'));
  }
}
	async ngOnInit() {
		console.log(this.cartItem,"carttem")
		this.applyDefaultColor();

		// Check initial route for translate widget visibility
		this.showTranslateWidget = !this.router.url.includes('/edit');

		// Fix body top immediately on init
		this.fixBodyTop();
		
			this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Check if current route includes /edit to hide translate widget
        this.showTranslateWidget = !event.url.includes('/edit');

        // Fix body top immediately on route change
        this.fixBodyTop();

        // Delay to ensure DOM is ready after route change
        setTimeout(() => {
          this.initializeGoogleTranslate();
          this.reApplyTranslate();
          this.fixBodyTop();
        }, 100);
      });
		this.authSubscription = this.afAuth.authState.subscribe(user => {
			this.isLoggedIn = !!user; // agar user exist karta hai to true, otherwise false
		});
		// selectedMainCategory =this.store_main_category[0]
		(window as any).openPWA = this.openPWA.bind(this);
		if (localStorage.getItem('showAppList') == 'true') {
			if (window.matchMedia('(display-mode: standalone)').matches || window.navigator['standalone'] || document.referrer.includes('android-app://')) {
				window.location.href = localStorage.getItem('appRedirectUrl');
				localStorage.setItem('showAppList', 'false');
				localStorage.removeItem('appRedirectUrl');
			} else {
			}
		} else {
			if (!(window.matchMedia('(display-mode: standalone)').matches || window.navigator['standalone'] || document.referrer.includes('android-app://'))) {
				this.route.data.subscribe(data => {
					if (data.showAppList === true) {
						localStorage.setItem('showAppList', 'true');
						localStorage.setItem('appRedirectUrl', window.location.href);
					} else {
						localStorage.setItem('showAppList', 'false');
						localStorage.removeItem('appRedirectUrl');
					}
				})
			}
		}

		// code for disable enable recipe page
		this.store_name_slug = this.route.snapshot.params.store_name;
		this.isRestaurantRoute = this.router.url == '/' + this.store_name_slug + '/restaurant' || this.router.url == '/' + this.store_name_slug + '/restaurant' + '/edit' || this.router.url.includes('/' + this.store_name_slug + '/restaurant?')
		if (this.router.url == '/' + this.store_name_slug + '/bundles' || this.router.url == '/' + this.store_name_slug + '/bundles' + '/edit') {
			this.showCategory = false
		} else if (this.router.url == '/' + this.store_name_slug + '/restaurant' || this.router.url == '/' + this.store_name_slug + '/restaurant' + '/edit' || this.router.url.includes('/' + this.store_name_slug + '/restaurant?')) {
			this.showCategory = false
		} else {
			this.showCategory = true
		}
		this.store_data1 = await this.afs.collection('/stores', ref => ref.where('company_name_slug', '==', this.store_name_slug)).get().toPromise()
			.then(storeData => {
				return storeData.docs.map(doc => doc.data());
			});
		this.qr_value_main =  window.location.origin + '/' + this.store_name_slug 
		if (this.store_data1[0]?.displayRecipePage) {
			this.displayRecipePage = true
		} else {
			this.displayRecipePage = false
		}
		if (this.store_data1[0]?.displayCouponPage) {
			this.displayCouponPage = true
		} else {
			this.displayCouponPage = false
		}
		if (this.store_data1[0]?.displayCircularPage) {
			this.displayCircularPage = true
		} else {
			this.displayCircularPage = false
		}
		if (this.store_data1[0]?.displayMenuPage) {
			this.displayMenuPage = true
		} else {
			this.displayMenuPage = false
		}
		if (this.store_data1[0]?.displayCommunityPage) {
			this.displayCommunityPage = true
		} else {
			this.displayCommunityPage = false
		}
		if (this.store_data1[0]?.displayRestaurantPage) {
			this.displayRestaurantPage = true
		} else {
			this.displayRestaurantPage = false
		}
		if (this.store_data1[0]?.displayBundlePage) {
			this.displayBundlePage = true
		} else {
			this.displayBundlePage = false
		}
		if (this.store_data1[0]?.merchantId) {
			this.merchantId = this.store_data1[0]?.merchantId
		}
		if (this.store_data1[0]?.apiToken) {
			this.privateKey = this.store_data1[0]?.apiToken
		}
		if (this.store_data1[0]?.printHeaderOption) {
			this.printHeaderOption = this.store_data1[0]?.printHeaderOption
		}
		if (this.store_data1[0]?.headerViewOption) {
			this.headerViewOption = this.store_data1[0]?.headerViewOption
		}
		if (this.router.url == '/' + this.store_name_slug + '/bundles' + '/edit' || this.router.url == '/' + this.store_name_slug + '/menu' + '/edit' || this.router.url == '/' + this.store_name_slug + '/edit') {
			this.privateKey = '';
			this.merchantId = '';
		}
		this.route.data.subscribe(data => {
			if (data.showHeaderStore) {
				this.showHeaderStore = data.showHeaderStore;
			}
			if (data.showHeaderCoupon) {
				this.showHeaderCoupon = data.showHeaderCoupon;
			}
			if (data.showHeaderBundle) {
				this.showHeaderBundle = data.showHeaderBundle;
			}
		})
		this.isAndroid = /Android/i.test(navigator.userAgent);
		this.isIos = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
		this.isIos_hide_button = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		this.isIos_hide_button_chIOS = /CriOS/i.test(navigator.userAgent);
		this.subscription = this.pwaService.isInstallable.subscribe((res: boolean) => {
			this.setInstallable = res
		})

		const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;
		if (this.isIos == true) {
			if(!isStandalone){
			this.setInstallable = true;
			}
		}
		this.current_store_uid = this.store_data[0]?.uid;
		if (localStorage.getItem('layout_uid')) {
			this.current_layout_id = localStorage.getItem('layout_uid')
		}
		const hostname = window.location.origin || "https://store-digitalcircular.web.app";
		const startURL = hostname + '/' + this.store_data[0]?.company_name_slug
		const obj = {
			"fileName": this.store_data[0]?.company_name_slug + ".json",
			"data": {
				"name": this.store_data[0]?.company_name,
				"short_name": this.store_data[0]?.company_name,
				"theme_color": "#026e00",
				"background_color": "#333",
				"display": "standalone",
				"scope": startURL,
				"start_url": startURL,
				"icons": [

					{
						"src": this.store_data[0].icons && this.store_data[0].icons[0] || environment.ServerURL + "/public/assets/icons/icon-192x192.png",
						"sizes": "192x192",
						"type": "image/png",
						"purpose": "maskable any"
					},
					{
						"src": this.store_data[0].icons && this.store_data[0].icons[1] || environment.ServerURL + "/public/assets/icons/icon-512x512.png",
						"sizes": "512x512",
						"type": "image/png",
						"purpose": "maskable any"
					}
				]
			}
		}
		this.pwaService.updateManifestFile(obj).subscribe((res) => {
			const linkURL = environment.ServerURL + res.url
			setTimeout(() => {
				this.pwaService.createLinkTag(linkURL)
				this.pwaService.chnageAppleTouchIcon(this.store_data[0].icons && this.store_data[0].icons[1] || environment.ServerURL + "/public/assets/icons/icon-512x512.png");
			}, 3000);

		})

		this.store_background_color = this.store_data[0]?.theme_base_color ? this.store_data[0]?.theme_base_color : `#76b101`
		if (this.route.snapshot.params?.list_id) {
			this.current_list_id = this.route.snapshot.params?.list_id
			this.is_list_view = true
		} else {
			if (localStorage.getItem('list_ids')) {
				const list_ids = JSON.parse(localStorage.getItem('list_ids'))
				if (list_ids.hasOwnProperty(this.store_data[0]?.company_name_slug)) {
					const value = list_ids[this.store_data[0]?.company_name_slug];
					localStorage.setItem('list_id', value)
					this.current_list_id = value
				} else {
					localStorage.removeItem('list_id')
					this.current_list_id = ''
				}
			} else {
				this.current_list_id = localStorage.getItem('list_id') ? localStorage.getItem('list_id') : ''
			}
		}

		const store_itemData = await this.afs.collection('/store-items', ref => ref.where('store_uid', '==', this.store_data[0].uid).orderBy('created_at', 'desc')).get().toPromise();
		const convertArrayToString = (value) => {
			return Array.isArray(value) ? value.join('') : value;
		};
		this.store_item = store_itemData.docs.map((e: any) => {
			return {
				upc_code: e.data()['upc_code'],
				product_description: e.data()['product_description'],
				product_name_slug: e.data().product_name_slug,
				pack: e.data()['pack'],
				price_label_format: e.data()['price_label_format'],
				price_label_value1: convertArrayToString(e.data()['price_label_value1'] ? e.data()['price_label_value1'] : ""),
				price_label_value2: convertArrayToString(e.data()['price_label_value2'] ? e.data()['price_label_value2'] : ""),
				price_label_value3: convertArrayToString(e.data()['price_label_value3'] ? e.data()['price_label_value3'] : ""),
				price_label_highlight: e.data()['price_label_highlight'] ? e.data()['price_label_highlight'] : "",
				product_url: e.data()['product_url'] ? e.data()['product_url'] : "",
				hide_price_label: e.data()['hide_price_label'] ? e.data()['hide_price_label'] : false,
				hide_addtolist_label: e.data()['hide_addtolist_label'] ? e.data()['hide_addtolist_label'] : false,
				hide_productname_label: e.data()['hide_productname_label'] ? e.data()['hide_productname_label'] : false,
				cost: e.data()['cost'] ? e.data()['cost'] : "",
				srp: e.data()['srp'] ? e.data()['srp'] : "",
				storeInMaster: e.data().storeInMaster ? e.data().storeInMaster : '',
				category: e.data()['category'] ? e.data()['category'] : "",
				offerLabel: e.data().offerLabel ? e.data().offerLabel : '',
				labelSide: e.data().labelSide ? e.data().labelSide : '',
				uid: e.id,
				product_image: e.data().product_image ? e.data().product_image : 'https://placehold.co/30/cecece/cecece',
				price_label_svg: e.data().price_label_svg ? e.data().price_label_svg : '',
				sale_price_label_format: e.data()['sale_price_label_format'] ? e.data()['sale_price_label_format'] : "",
				sale_price_label_value1: e.data()['sale_price_label_value1'] ? e.data()['sale_price_label_value1'] : "",
				sale_price_label_value2: e.data()['sale_price_label_value2'] ? e.data()['sale_price_label_value2'] : "",
				sale_price_label_value3: e.data()['sale_price_label_value3'] ? e.data()['sale_price_label_value3'] : "",
				final_price_label_format: e.data()['final_price_label_format'] ? e.data()['final_price_label_format'] : "",
				final_price_label_value1: e.data()['final_price_label_value1'] ? e.data()['final_price_label_value1'] : "",
				final_price_label_value2: e.data()['final_price_label_value2'] ? e.data()['final_price_label_value2'] : "",
				final_price_label_value3: e.data()['final_price_label_value3'] ? e.data()['final_price_label_value3'] : "",
				digital_coupon_price_label_format: e.data()['digital_coupon_price_label_format'] ? e.data()['digital_coupon_price_label_format'] : "",
				digital_coupon_price_label_value1: e.data()['digital_coupon_price_label_value1'] ? e.data()['digital_coupon_price_label_value1'] : "",
				digital_coupon_price_label_value2: e.data()['digital_coupon_price_label_value2'] ? e.data()['digital_coupon_price_label_value2'] : "",
				digital_coupon_price_label_value3: e.data()['digital_coupon_price_label_value3'] ? e.data()['digital_coupon_price_label_value3'] : "",
				note: e.data()['note'] ? e.data()['note'] : "",
				link: e.data()['link'] ? e.data()['link'] : "",
				usage_limit: e.data()['usage_limit'] ? e.data()['usage_limit'] : "",
				digital_coupon: e.data()['digital_coupon'] ? e.data()['digital_coupon'] : false,
				sale_price_label_svg: e.data().sale_price_label_svg ? e.data().sale_price_label_svg : '',
				sale_content_price_label_svg: e.data().sale_content_price_label_svg ? e.data().sale_content_price_label_svg : '',
				final_price_label_svg: e.data().final_price_label_svg ? e.data().final_price_label_svg : '',
				final_content_price_label_svg: e.data().final_content_price_label_svg ? e.data().final_content_price_label_svg : '',
				digital_coupon_price_label_svg: e.data().digital_coupon_price_label_svg ? e.data().digital_coupon_price_label_svg : '',
				digital_content_coupon_price_label_svg: e.data().digital_content_coupon_price_label_svg ? e.data().digital_content_coupon_price_label_svg : '',
				is_saved: e.data().is_saved ? e.data().is_saved : '',
				store_uid: e.data().store_uid ? e.data().store_uid : '',
				isVideo: e.data().isVideo ? e.data().isVideo : false,
				master_uid: e.data().master_uid ? e.data().master_uid : '',
			};
		});
		this.store_name_slug = this.route.snapshot.params.store_name;
		const url: any = this.route.url;
		this.urlParam = new URLSearchParams(window.location.search)
		let temp_url = url._value[1];
		if (temp_url != undefined) {
			if (url._value[1].path == 'coupons') {
				this.isCoupon = true
				this.tabName = 'coupons'
			}
			else if (url._value[1].path == 'recipes') {
				this.isRecipe = true
				this.tabName = 'recipes'
			} else if (url._value[1].path == 'bundles') {
				this.tabName = 'bundles'
			} else if (url._value[1].path == 'circular') {
				this.tabName = 'circular'
			} else if (url._value[1].path == 'menu') {
				this.tabName = 'menu'
			} else if (url._value[1].path == 'community') {
				this.tabName = 'community'
			} else if (url._value[1].path == 'restaurant') {
				this.tabName = 'restaurant'
			} else {
				this.tabName = 'circular'
			}
		}
		if (this.router.url == '/' + this.store_name_slug) {
			this.tabName = 'circular'
		}
		await this.afs.collection('/group_list', ref => ref.where('store', 'array-contains', this.store_data[0]?.company_name)).snapshotChanges().subscribe((data: any) => {
			this.groupList = data.map(e => {
				return {
					uid: e.payload.doc.id,
					groupName: e.payload.doc.data().groupName,
					store: e.payload.doc.data().store,
				};
			});

			this.groupList.forEach(i => {
				i.store.forEach(j => {
					this.groupBranch.push({ slug: j.replace(/\s/g, ''), name: j })
				})
			})
			this.groupBranch = [...new Map(this.groupBranch.map((item) =>
				[item["name"], item])).values()]
			this.groupSearchBranch = this.groupBranch
			if (this.groupSearchBranch?.length > 0) {
				this.showGroupStore = true
			} else {
				this.showGroupStore = false
			}
			this.afs
				.collection('/stores', ref =>
					ref.where('type', '==', 'main_store').orderBy('created_at', 'desc')
				)
				.get()
				.subscribe(querySnapshot => {
					let i = 0;
					this.stores_group_list = querySnapshot.docs.map((doc, index) => {
						i++;
						const data = doc.data();
						return {
							uid: doc.id,
							serial: i - 1,
							company_name: data['company_name'],
							company_name_slug: data['company_name_slug'],
							email: data['email'],
							group_id: data['group_id'],
							group_name: data['group_name'],
							phone: data['phone'],
							store_id: data['store_id'],
							store_owner_name: data['store_owner_name'],
							warehouse_id: data['warehouse_id'],
							warehouse_name: data['warehouse_name'],
							created_at: data['created_at'],
							can_login: data['can_login'] ? data['can_login'] : '1',
							status: data['status'],
							user_id: data['user_id'],
							zip_code: data['zip_code'] ? data['zip_code'] : '',
							branch_count: data['branch_count'],
							access_layout: data['access_layout'] ? data['access_layout'] : '-',
							access_recipe: data['access_recipe'] ? data['access_recipe'] : '-',
							access_coupon: data['access_coupon'] ? data['access_coupon'] : '-',
						};
					});
				});
		});

		setTimeout(() => {
			this.scrolldiv();
		}, 2000);
		$(window).resize(() => {
			this.scrolldiv();
		})

		this.currentCategory = this.route.snapshot.params['recipe_categories'];

		const url1 = this.router.url
		const parts = url1.split("/"); // Split the URL by "/"
		const Store_id = parts[parts.length - 1].split("?")[0];
		if (this.router.url == '/' + this.store_name_slug || this.router.url == '/' + this.store_name_slug + '/restaurant') {
			this.print = true;
			localStorage.setItem("printButton", 'Display')
		} else if (this.router.url == '/' + this.store_name_slug + '/' + Store_id + '?preview=true' ||this.router.url == '/' + this.store_name_slug + '/restaurant' +  '/' + Store_id + '?preview=true') {
			if (Store_id == 'coupons' || Store_id == 'recipes' || Store_id == 'menu' || Store_id == 'bundles') {
				this.print = false;
				localStorage.setItem("printButton", 'NotDisplay')
			} else {
				this.print = true;
				localStorage.setItem("printButton", 'Display')
			}
		} else if (this.router.url == '/' + this.store_name_slug + '/' + Store_id + '?preview=true' + '&type=noad' ||this.router.url == '/' + this.store_name_slug + '/restaurant' + '/' + Store_id + '?preview=true' + '&type=noad') {
			if (Store_id == 'coupons' || Store_id == 'recipes' || Store_id == 'menu' || Store_id == 'bundles') {
				this.print = false;
				localStorage.setItem("printButton", 'NotDisplay')
			} else {
				this.print = true;
				localStorage.setItem("printButton", 'Display')
			}
		}else if (this.router.url.includes('print=true')) {
		        this.print = true;
				localStorage.setItem("printButton", 'Display')
		} else {
			localStorage.setItem("printButton", 'NotDisplay')
			this.print = false;
		}
		this.printDisplay = localStorage.getItem('printButton')
		this.current_bundle_data = await this.getBundleData();
		this.current_onsale_data = await this.getLayoutData();
		this.current_menu_data = await this.getMenuData()
		this.current_community_data = await this.getCommunityData()
		this.current_restaurant_data = await this.getRestaurantData()
		await this.getNoadLayoutData();
		let temp_store_id = localStorage.getItem('current_store_id');
		let chkghost = localStorage.getItem('ghost_mode');
		if (this.router.url.includes('/edit')) {
			this.notDisplayCheckOut = true;
			if (chkghost) {
				this.user = JSON.parse(temp_store_id);
			} else {
				this.user = JSON.parse(localStorage.getItem('userrole'));
				this.isAdmin = this.user.role == "admin"
			}
			localStorage.setItem("currentPage", window.location.href);
			localStorage.setItem("currentStore", this.store_data1[0]?.company_name);
			this.afs.collection('/users', ref => ref.where('uid', '==', this.user.uid)).snapshotChanges().subscribe(data => {
				let i = 0
				this.users = data.map(e => {
					i++
					if (e.payload.doc.data()['role'] == "user" || e.payload.doc.data()['role'] == "store-manager") {
						return {
							uid: e.payload.doc.id,
							serial: i - 1,
							displayName: e.payload.doc.data()['displayName'],
							role: e.payload.doc.data()['role'],
							store: e.payload.doc.data()['store']?.map((x) => { return x.uid })
						};
					} else {
						return {
							uid: e.payload.doc.id,
							serial: i - 1,
							displayName: e.payload.doc.data()['displayName'],
							role: e.payload.doc.data()['role'],
							store: e.payload.doc.data()['store']
						};
					}
				});

				if (this.users[0]?.role == 'user' || this.users[0]?.role == 'store-manager') {
					const allStores = [];
					let i = 0;
					for (const storeId of this.users[0].store) {
						this.afs
							.collection('/stores', ref =>
								ref.where('type', '==', 'main_store')
									.where('uid', '==', storeId)
									.orderBy('created_at', 'desc')
							)
							.get()
							.subscribe(querySnapshot => {
								const stores = querySnapshot.docs.map((doc, index) => {
									i++;
									const data = doc.data();
									return {
										uid: doc.id,
										serial: i - 1,
										company_name: data['company_name'],
										company_name_slug: data['company_name_slug'],
										email: data['email'],
										group_id: data['group_id'],
										group_name: data['group_name'],
										phone: data['phone'],
										store_id: data['store_id'],
										store_owner_name: data['store_owner_name'],
										warehouse_id: data['warehouse_id'],
										warehouse_name: data['warehouse_name'],
										created_at: data['created_at'],
										can_login: data['can_login'] ? data['can_login'] : '1',
										status: data['status'],
										user_id: data['user_id'],
										zip_code: data['zip_code'] ? data['zip_code'] : '',
										branch_count: data['branch_count'],
										access_layout: data['access_layout'] ? data['access_layout'] : '-',
										access_recipe: data['access_recipe'] ? data['access_recipe'] : '-',
										access_coupon: data['access_coupon'] ? data['access_coupon'] : '-',
									};
								});

								allStores.push(...stores);
								this.stores_list = allStores
								// this.stores_list = this.stores_list?.filter(product =>
								// 	product?.company_name?.trim()?.toLowerCase() !== this.store_data1[0]?.company_name?.trim()?.toLowerCase()
								// );
								this.searchStoreList = this.stores_list
								if (this.searchStoreList?.length > 0) {
									this.storeAccess = true
								} else {
									this.storeAccess = false
								}
							});
					}
				} else {
					this.afs
						.collection('/stores', ref =>
							ref.where('type', '==', 'main_store').orderBy('created_at', 'desc')
						)
						.get()
						.subscribe(querySnapshot => {
							let i = 0;
							this.stores_list = querySnapshot.docs.map((doc, index) => {
								i++;
								const data = doc.data();
								return {
									uid: doc.id,
									serial: i - 1,
									company_name: data['company_name'],
									company_name_slug: data['company_name_slug'],
									email: data['email'],
									group_id: data['group_id'],
									group_name: data['group_name'],
									phone: data['phone'],
									store_id: data['store_id'],
									store_owner_name: data['store_owner_name'],
									warehouse_id: data['warehouse_id'],
									warehouse_name: data['warehouse_name'],
									created_at: data['created_at'],
									can_login: data['can_login'] ? data['can_login'] : '1',
									status: data['status'],
									user_id: data['user_id'],
									zip_code: data['zip_code'] ? data['zip_code'] : '',
									branch_count: data['branch_count'],
									access_layout: data['access_layout'] ? data['access_layout'] : '-',
									access_recipe: data['access_recipe'] ? data['access_recipe'] : '-',
									access_coupon: data['access_coupon'] ? data['access_coupon'] : '-',
								};
							});
							// this.stores_list = this.stores_list?.filter(product =>
							// 	product?.company_name?.trim()?.toLowerCase() !== this.store_data1[0]?.company_name?.trim().toLowerCase()
							// );
							this.searchStoreList = this.stores_list
							if (this.searchStoreList?.length > 0) {
								this.storeAccess = true
							} else {
								this.storeAccess = false
							}
						});
				}

			});
		} else {
			this.stores_list = []
		}
	}


	private preventGoogleTranslateNavigation() {
		const translateElement = document.getElementById('google_translate_element');
		
		// Function to clean up hash from URL
		const cleanupHash = () => {
			if (window.location.hash === '#' || window.location.hash === '') {
				window.history.replaceState('', document.title, window.location.pathname + window.location.search);
			}
		};

		// Function to fix all links with href="#"
		const fixHashLinks = () => {
			if (translateElement) {
				const links = translateElement.querySelectorAll('a[href="#"]');
				links.forEach((link) => {
					// Change href to javascript:void(0) to prevent navigation but allow clicks
					link.setAttribute('href', 'javascript:void(0)');
				});
			}
		};

		// Fix links immediately and periodically
		fixHashLinks();


		// Use MutationObserver to catch dynamically added links
		if (translateElement) {
			const observer = new MutationObserver(() => {
				fixHashLinks();
			});
			observer.observe(translateElement, {
				childList: true,
				subtree: true,
				attributes: true,
				attributeFilter: ['href']
			});
		}

		// Override history.pushState to prevent hash additions
		const originalPushState = history.pushState;
		history.pushState = function(state: any, title: string, url?: string | URL | null) {
			// If trying to push a state with just a hash, prevent it
			if (url && (url.toString() === '#' || url.toString().endsWith('/#'))) {
				const cleanUrl = url.toString().replace(/#$/, '');
				return originalPushState.call(history, state, title, cleanUrl || window.location.pathname + window.location.search);
			}
			return originalPushState.call(history, state, title, url);
		};

		// Override history.replaceState as well
		const originalReplaceState = history.replaceState;
		history.replaceState = function(state: any, title: string, url?: string | URL | null) {
			// If trying to replace with just a hash, prevent it
			if (url && (url.toString() === '#' || url.toString().endsWith('/#'))) {
				const cleanUrl = url.toString().replace(/#$/, '');
				return originalReplaceState.call(history, state, title, cleanUrl || window.location.pathname + window.location.search);
			}
			return originalReplaceState.call(history, state, title, url);
		};

		// Listen for hashchange events and clean up immediately
		window.addEventListener('hashchange', () => {
			cleanupHash();
		}, true);

		// Also monitor popstate events
		window.addEventListener('popstate', () => {
			cleanupHash();
		});

		// // Periodically check and clean up (as a fallback)
		// setInterval(() => {
		// 	fixHashLinks();
		// 	cleanupHash();
		// }, 500);
	}


ngAfterViewInit() {
    // Fix body top immediately to prevent layout shift
    this.fixBodyTop();
    
    setTimeout(() => {
      this.initializeGoogleTranslate();
      this.fixBodyTop();
    }, 100);
  }

  private initializeGoogleTranslate() {
    // Prevent multiple simultaneous initializations
    if (this.isTranslateInitializing) {
      return;
    }

    // Always clear the element first to ensure clean re-initialization
    const element = document.getElementById('google_translate_element');
    if (!element) {
      // Element not in DOM yet, try again after a short delay
      setTimeout(() => {
        this.initializeGoogleTranslate();
      }, 200);
      return;
    }

    // Check if script is already loaded
    if ((window as any).google?.translate) {
      this.isTranslateInitializing = true;
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        this.initTranslateElement();
        this.isTranslateInitializing = false;
      }, 50);
      return;
    }

    // Check if script is already being loaded
    const existingScript = document.querySelector('script[src*="translate.google.com"]');
    if (existingScript) {
      this.isTranslateInitializing = true;
      // Script is loading, wait for it
      let attempts = 0;
      const maxAttempts = 50;
      const check = setInterval(() => {
        attempts++;
        if ((window as any).google?.translate) {
          clearInterval(check);
          setTimeout(() => {
            this.initTranslateElement();
            this.isTranslateInitializing = false;
          }, 50);
        } else if (attempts >= maxAttempts) {
          clearInterval(check);
          console.warn('Google Translate script failed to load');
          this.isTranslateInitializing = false;
        }
      }, 100);
      return;
    }

    // Load the Google Translate script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    script.async = true;
    script.defer = true;

    this.isTranslateInitializing = true;

    // Set up callback function
    (window as any).googleTranslateElementInit = () => {
      if ((window as any).google?.translate) {
        setTimeout(() => {
          this.initTranslateElement();
          this.isTranslateInitializing = false;
        }, 50);
      }
    };

    script.onerror = () => {
      console.error('Failed to load Google Translate script');
      this.isTranslateInitializing = false;
    };

    document.head.appendChild(script);

    // Fallback: wait for script to load even if callback doesn't fire
    let attempts = 0;
    const maxAttempts = 50;
    const check = setInterval(() => {
      attempts++;
      if ((window as any).google?.translate) {
        clearInterval(check);
        setTimeout(() => {
          this.initTranslateElement();
          this.isTranslateInitializing = false;
        }, 50);
      } else if (attempts >= maxAttempts) {
        clearInterval(check);
        console.warn('Google Translate script failed to load');
        this.isTranslateInitializing = false;
      }
    }, 100);
  }

  private initTranslateElement() {
    const element = document.getElementById('google_translate_element');
    if (!element) {
      console.warn('Google Translate element not found in DOM');
      return;
    }

    // Check if translate element is already initialized
    const existingGadget = element.querySelector('.goog-te-gadget');
    if (existingGadget && (window as any).google?.translate) {
      // Element already exists, just ensure it's visible and fix body top
      element.style.display = 'inline-block';
      this.fixBodyTop();
      return;
    }

    // Clear the element before re-initializing
    element.innerHTML = '';

    // Ensure body top is reset before initialization
    this.fixBodyTop();

    try {
      const googleTranslate = (window as any).google?.translate;
      if (!googleTranslate || !googleTranslate.TranslateElement) {
        console.warn('Google Translate API not fully loaded yet');
        return;
      }

      // Use layout value 0 for SIMPLE layout (more reliable than InlineLayout.SIMPLE)
      const translateConfig: any = {
        pageLanguage: '',
        includedLanguages: 'es,en',
        layout: 0  // 0 = SIMPLE layout
      };

      // Try to use InlineLayout if available, otherwise use numeric value
      if (googleTranslate.TranslateElement.InlineLayout && 
          googleTranslate.TranslateElement.InlineLayout.SIMPLE !== undefined) {
        translateConfig.layout = googleTranslate.TranslateElement.InlineLayout.SIMPLE;
      }

      new googleTranslate.TranslateElement(
        translateConfig,
        'google_translate_element'
      );

      // Setup after Google Translate initializes - use multiple timeouts to catch banner
      setTimeout(() => {
        this.fixBodyTop();
        
        // Ensure element is visible
        if (element) {
          element.style.display = 'inline-block';
        }
        
        this.preventGoogleTranslateNavigation();
      }, 100);


    } catch (error) {
      console.error('Error initializing Google Translate element:', error);
    }
  }

  private fixBodyTop() {
    // Immediately fix body top to prevent layout shift
    if (document.body) {
      document.body.style.top = '0';
      document.body.style.position = 'static';
    }
    
    // Also fix html element if needed
    if (document.documentElement) {
      document.documentElement.style.top = '0';
    }
  }

  private hideTranslateBanner() {
    // Hide Google Translate banner
    const banner = document.querySelector('.goog-te-banner-frame');
    if (banner) {
      (banner as HTMLElement).style.display = 'none';
    }
    
    // Hide skiptranslate banner
    // const skipBanner = document.querySelector('.skiptranslate');
    // if (skipBanner) {
    //   (skipBanner as HTMLElement).style.display = 'none';
    // }
  }

	/**
	 * Setup language persistence - simple and clean implementation
	 */


	onSearchChange() {
		if (this.searchTerm != '') {
			this.stores_list = this.searchStoreList.filter(store =>
				store?.zip_code !== '' &&  // Ensure zip_code is not empty
				store?.zip_code?.toString().includes(this.searchTerm.toString())
			);
		} else {
			this.stores_list = this.searchStoreList
		}
	}
	onSearchGroupChange() {
		if (this.searchGroupTerm !== '') {
			const filter = this.groupSearchBranch.flatMap(store => {
				// Filtering stores that match the given name
				const matchingStores = this.stores_group_list.filter(storeList => {
					const isMatch = storeList.company_name === store.name;
					return isMatch;
				});
				// Filtering stores by zip_code
				const filteredStores = matchingStores.filter(branch => {
					const zipMatch = branch?.zip_code !== '' &&
						branch?.zip_code?.toString().includes(this.searchGroupTerm.toString());
					return zipMatch;
				});
				return filteredStores;
			});
			this.groupBranch = filter.flatMap(store =>
				this.groupSearchBranch.filter(groupStore => groupStore.name === store.company_name)
			);
		} else {
			this.groupBranch = this.groupSearchBranch; // Reset to original
		}
	}
	async getLayoutData() {
		const start_date = new Date();
		const layout_data = await this.afs.collection('/layouts', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();
		const layouts = layout_data.docs.map(doc => doc.data());
		const current_layout :any= layouts.filter((docs: any) => {
			const layout_start_date = docs.start_date.toDate();
			const endDate = docs.end_date.toDate();
			return layout_start_date <= start_date && endDate > start_date;
		});
		// if (current_layout[0]?.title_position == 'above') {
		// 	this.title_position = 'above'
		// } else if (current_layout[0]?.title_position == 'below') {
		// 	this.title_position = 'below'
		// }
		return current_layout;
	}
	async getBundleData() {
		const start_date = new Date();
		const layout_data = await this.afs.collection('/bundles', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();
		const layouts = layout_data.docs.map(doc => doc.data());
		return layouts;
	}
	async getMenuData() {
		const start_date = new Date();
		const layout_data = await this.afs.collection('/menus', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();
		const layouts = layout_data.docs.map(doc => doc.data());
		return layouts;
	}
	async getCommunityData() {
		const start_date = new Date();
		const layout_data = await this.afs.collection('/community', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();
		const layouts = layout_data.docs.map(doc => doc.data());
		return layouts;
	}
	async getRestaurantData() {
		const start_date = new Date();
		const layout_data = await this.afs.collection('/restaurant', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();
		const layouts = layout_data.docs.map(doc => doc.data());
		return layouts;
	}
	async getNoadLayoutData() {
		try {
			const layoutSnapshot = await this.afs.collection('/layouts-noad', ref => ref.where('store_uid', '==', this.current_store_uid).orderBy('start_date', 'desc')).get().toPromise();

			this.current_noad_layout_data = layoutSnapshot.docs.map((doc: any) => {
				return doc.data();
			}).filter(data => data !== null);
			// if (this.current_noad_layout_data[0]?.title_position == 'above') {
			// 	this.title_position = 'above'
			// } else if (this.current_noad_layout_data[0]?.title_position == 'below') {
			// 	this.title_position = 'below'
			// }
			console.log("No-ad Circular Id :- ", this.current_layout_data[0]?.uid,)
		} catch (error) {
			// Handle errors here
			console.error("Error fetching layout data:", error);
		}
	}
	openSignPage() {
		localStorage.setItem("currentPage", window.location.href);
		localStorage.setItem("currentStore", this.store_data[0]?.company_name);
		this.router.navigate(['/login']);
	}
	QrModelClick() {
		this.analytics.logEvent('@shoppingList_qr_click_count', {
			store_name: this.store_data[0]?.company_name,
			message: 'ShoppingList Qr Button  Clicked.'
		});
		if (this.store_data[0]?.googleMeasurementId) {
			(window as any).gtag('event', "@shoppingList_qr_click_count", {
				send_to: this.store_data[0]?.googleMeasurementId,
				store_name: this.store_data[0]?.company_name,
				message: 'ShoppingList Qr Button  Clicked.'
			});
		}
	}
	applyDefaultColor() {
		const root = document.documentElement;
		root.style.setProperty('--theme-base-color', this.store_data[0]?.theme_base_color || 'rgb(139, 195, 74)');
		root.style.setProperty('--branch-name-color', this.store_data[0]?.branch_name_color || 'rgb(139, 195, 74)');
	}

	openPWA() {
		if (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone) {
			alert('App already installed on your device.');
			return;
		}
		if (/iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase())) {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				this.openDialog_ios();
				this.analytics.logEvent('@pwa_mobile_icon_install_click_count', {
					store_name: this.store_data[0]?.company_name,
					message: 'PWA install successfully.'
				  });
				if (this.store_data[0]?.googleMeasurementId) {
					(window as any).gtag('event', "@pwa_mobile_icon_install_click_count'", {
						send_to: this.store_data[0]?.googleMeasurementId,
						store_name: this.store_data[0]?.company_name,
					message: 'PWA install successfully.'
				});
				}
			}
		} else {
			this.setInstallable = false;
			this.pwaService.isInstallable.next(false)
			// Show the install prompt
			this.pwaService.deferredPrompt.prompt();
			// Wait for the user to respond to the prompt
			this.pwaService.deferredPrompt.userChoice.then((choiceResult: any) => {
				if (choiceResult.outcome === 'accepted') {
					this.analytics.logEvent('@pwa_mobile_icon_install_click_count', {
						store_name: this.store_data[0]?.company_name,
						outcome: choiceResult.outcome, // 'accepted' or 'dismissed'
						platform: choiceResult.platform, // Platform used to accept or dismiss
					  });
					if (this.store_data[0]?.googleMeasurementId) {
						(window as any).gtag('event', "@pwa_mobile_icon_install_click_count", {
							send_to: this.store_data[0]?.googleMeasurementId,
							store_name: this.store_data[0]?.company_name,
						outcome: choiceResult.outcome, // 'accepted' or 'dismissed'
						platform: choiceResult.platform, // Platform used to accept or dismiss
					});
					}
				}
			});
		}
	}

	async logout() {
		try {
			await this.afAuth.signOut();
			let currentUrl = this.router.url;
			if (currentUrl.includes('/edit')) {
				currentUrl = currentUrl.replace('/edit', '');
			}
			this.router.navigateByUrl(currentUrl);
		} catch (error) {
			console.error("Logout Error: ", error);
		}
	}

	startTour() {
		const url1 = this.router.url
		const parts = url1.split("/"); // Split the URL by "/"
		const Store_id = parts[parts.length - 1].split("?")[0];
		const recipe_categories = ['All', 'main%20course', 'Bread', 'Marinade', 'Side%20Dish', 'Breakfast', 'Fingerfood', 'Dessert', 'Soup', 'Snack', 'Appetizer', 'Beverage', 'Drink', 'Salad', 'Sauce'];

		if (Store_id !== 'coupons' && Store_id !== 'recipes' && !Store_id.includes(Store_id)) {
			if (this.router.url == '/' + this.store_name_slug || this.router.url == '/' + this.store_name_slug + '/' + Store_id + '?preview=true' + '&type=noad' || this.router.url == '/' + this.store_name_slug + '/' + Store_id + '?preview=true') {
				this.CloseShoppingList();
				this.appTourService.cancelTour();
				localStorage.setItem(this.tourSeenFlag, 'false');
				this.appTourService.startTour();
			}
		} else if (url1.includes('/recipes') || this.router.url == '/' + this.store_name_slug + '/recipes' || this.router.url == '/' + this.store_name_slug + '/recipes?preview=true' || this.router.url == '/' + this.store_name_slug + '/recipes/' + this.currentCategory || this.router.url == '/' + this.store_name_slug + '/recipes?preview=true' + '&type=noad') {
			this.closeRecipeboxPanel.emit();
			this.CloseShoppingList();
			this.appRecipeTourService.cancelTour();
			localStorage.setItem(this.recipeTourSeenFlag, 'false');
			this.appRecipeTourService.startTour();
		}
		else if (this.router.url == '/' + this.store_name_slug + '/coupons' || this.router.url == '/' + this.store_name_slug + '/coupons?preview=true' || this.router.url == '/' + this.store_name_slug + '/coupons?preview=true' + '&type=noad') {
			this.CloseShoppingList();
			this.appCouponTourService.cancelTour();
			localStorage.setItem(this.CouponTourSeenFlag, 'false');
			this.appCouponTourService.startTour();
		}
		// else if (this.router.url == '/' + this.store_name_slug + '/bundles' || this.router.url == '/' + this.store_name_slug + '/bundles?preview=true' ){
		// 	this.CloseShoppingList();
		// 	this.appCouponTourService.cancelTour();
		// 	localStorage.setItem(this.BundlesTourSeenFlag, 'false');
		// 	this.appCouponTourService.startTour();
		// }else if (this.router.url == '/' + this.store_name_slug + '/menu' || this.router.url == '/' + this.store_name_slug + '/menu?preview=true' ) {
		// 	this.CloseShoppingList();
		// 	this.appCouponTourService.cancelTour();
		// 	localStorage.setItem(this.MenuTourSeenFlag, 'false');
		// 	this.appCouponTourService.startTour();
		// }

	}
	startShoppingListTour() {
		this.appShoppingListTourService.cancelTour();
		localStorage.setItem(this.shoppingTourSeenFlag, 'false');
		this.appShoppingListTourService.startTour();
	}

	openDialog_ios() {
		this.dialog.open(DialogAnimationsExampleDialog, {
			width: "500px",
		});
	}

	openDialog_android() {
		this.dialog.open(DialogAnimationsExampleDialogAndroid, {
			width: "500px",
		});
	}

	addtohomeScreen() {
		if (/iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase())) {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				this.openDialog_ios();
			}
		} else {
			if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				this.openDialog_android();
			}
		}
	}

	// ngOnChanges() {
	// }

	scrolldiv() {
		var div = document.getElementById('food_menu');
		var hasHorizontalScrollbar = div?.scrollWidth > div?.clientWidth;
		if (hasHorizontalScrollbar) {
			$('.scroll-arrow').show();
			$('.scroll-main-arrow').show();
		} else {
			$('.scroll-arrow').hide();
			$('.scroll-main-arrow').hide();
		}
	}
	public scrollRight(): void {
		// this.widgetsContent.nativeElement.scrollBy({ left: 150, behavior: 'smooth' });
		const el = this.widgetsContent.nativeElement;
		el.scrollBy({ left: 150, behavior: 'smooth' });
		setTimeout(() => console.log('after:', el.scrollLeft), 300);
	}
	public scrollLeft(): void {
		// this.widgetsContent.nativeElement.scrollBy({ left: -150, behavior: 'smooth' });
		const el = this.widgetsContent.nativeElement;
		el.scrollBy({ left: -150, behavior: 'smooth' });
		setTimeout(() => console.log('after:', el.scrollLeft), 300);
	}

	public scrollMainRight(): void {
		const el = this.widgetsMainContent.nativeElement;
		el.scrollBy({ left: 150, behavior: 'smooth' });
		setTimeout(() => console.log('after:', el.scrollLeft), 300);
	}
	public scrollMainLeft(): void {
		const el = this.widgetsMainContent.nativeElement;
		el.scrollBy({ left: -150, behavior: 'smooth' });
		setTimeout(() => console.log('after:', el.scrollLeft), 300);
	}
	add_to_list(item) {
		if (!this.isCoupon) {
			this.addToList.emit(item)
		}
		else if (this.isCoupon) {
			this.addToList.emit(item)
		}
		setTimeout(() => {
			this.show_add_item = false
			this.filtered_items = []
			this.item_name = ''
		}, 0);
	}

	// Helper function to calculate free quantity based on paid count for format6
	calculateFreeQuantity(priceLabelFormat, priceLabelValue1, priceLabelValue2, paidCount) {
		if (priceLabelFormat === 'format6') {
			const buyQty = parseInt(priceLabelValue1, 10) || 1;
			const freeQty = parseInt(priceLabelValue2, 10) || 0;
			if (buyQty === 0) return 0;
			// Calculate how many complete groups we have
			const completeGroups = Math.floor(paidCount / buyQty);
			// Calculate free items from complete groups
			return completeGroups * freeQty;
		}
		return 0; // No free items for other formats
	}

	// Helper function to calculate total display count (paid + free) for format6
	calculateTotalCount(priceLabelFormat, priceLabelValue1, priceLabelValue2, paidCount) {
		if (priceLabelFormat === 'format6') {
			const freeCount = this.calculateFreeQuantity(priceLabelFormat, priceLabelValue1, priceLabelValue2, paidCount);
			return paidCount + freeCount;
		}
		return paidCount; // For other formats, count = paid count
	}

	// Helper function to get buy quantity for format6
	getBuyQuantity(priceLabelFormat, priceLabelValue1) {
		if (priceLabelFormat === 'format6') {
			return parseInt(priceLabelValue1, 10) || 1;
		}
		return 1; // Default for other formats
	}

	// Helper function to get quantity for format5 (X for $Y.Z)
	getFormat5Quantity(priceLabelFormat, priceLabelValue1) {
		if (priceLabelFormat === 'format5') {
			return parseInt(priceLabelValue1, 10) || 1;
		}
		return 1; // Default for other formats
	}

	async increase_product(i) {
		let main_item
		let layout_product_qnt
		const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
		if (view == "listView" && window.innerWidth < 768) {
			if (i?.product?.isBundleProduct) {
				if (i?.product?.id) {
					main_item = document.getElementById(i?.product?.id)?.parentElement?.parentElement?.parentElement;
				} else {
					main_item = document.getElementById(i?.product?.uid)?.parentElement?.parentElement?.parentElement;
				}
			} else {
				if (i?.product?.id) {
					main_item = document.getElementById(i?.product?.id)?.parentElement?.parentElement;
				} else {
					main_item = document.getElementById(i?.product?.uid)?.parentElement?.parentElement;
				}
			}
			layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
		} else {
			if (i?.product?.isBundleProduct) {
				if (i?.product?.id) {
					if (document.getElementById(i?.product?.id)) {
						if (document.getElementById(i?.product?.id).tagName != 'VIDEO') {
							main_item = document.getElementById(i?.product?.id)?.parentElement
						} else {
							main_item = document.getElementById(i?.product?.id)?.parentElement
						}
					}
				} else {
					if (document.getElementById(i?.product?.uid)) {
						if (document.getElementById(i?.product?.uid).tagName != 'VIDEO') {
							main_item = document.getElementById(i?.product?.uid)?.parentElement
						} else {
							main_item = document.getElementById(i?.product?.uid)?.parentElement
						}
					}
				}
			} else {
				if (i?.product?.id) {
					if (document.getElementById(i?.product?.id)) {
						if (document.getElementById(i?.product?.id).tagName != 'VIDEO') {
							main_item = document.getElementById(i?.product?.id)
						} else {
							main_item = document.getElementById(i?.product?.id)?.parentElement
						}
					}
				} else {
					if (document.getElementById(i?.product?.uid)) {
						if (document.getElementById(i?.product?.uid).tagName != 'VIDEO') {
							main_item = document.getElementById(i?.product?.uid)
						} else {
							main_item = document.getElementById(i?.product?.uid)?.parentElement
						}
					}
				}
			}
			layout_product_qnt = main_item?.parentElement.getElementsByClassName("layout_product_qnt")[0]
		}
		let temp_itm = this.cartItem[this.cartItem.indexOf(i)]
		
		// Use sale_price_label_format for digital coupons, otherwise use price_label_format
		const formatToUse = i?.product?.digital_coupon ? i?.product?.sale_price_label_format : i?.product?.price_label_format;
		const value1ToUse = i?.product?.digital_coupon ? i?.product?.sale_price_label_value1 : i?.product?.price_label_value1;
		const value2ToUse = i?.product?.digital_coupon ? i?.product?.sale_price_label_value2 : i?.product?.price_label_value2;
		
		if (formatToUse === 'format5') {
			// For format5: increment by the quantity specified in value1 (e.g., "3 for $5.99" adds 3)
			const format5Qty = this.getFormat5Quantity(formatToUse, value1ToUse);
			const currentCount = temp_itm.count || format5Qty;
			temp_itm.count = currentCount + format5Qty;
			temp_itm.paidCount = temp_itm.count; // For format5, paidCount equals count
		} else if (formatToUse === 'format6') {
			// For format6: increment paid count by 1, then recalculate total with free items
			const currentPaidCount = temp_itm.paidCount || temp_itm.count || 1;
			const buyQty = this.getBuyQuantity(formatToUse, value1ToUse);
			const newPaidCount = currentPaidCount + 1;
			temp_itm.paidCount = newPaidCount;
			
			if (newPaidCount >= buyQty) {
				// Calculate total count including free items
				temp_itm.count = this.calculateTotalCount(formatToUse, value1ToUse, value2ToUse, newPaidCount);
			} else {
				// If paid count is still below buyQty, show only paid items (no free items)
				temp_itm.count = newPaidCount;
			}
		} else {
			// For other formats: just increment by 1
			temp_itm.count += 1;
		}
		
		this.cartItem[this.cartItem.indexOf(i)] = temp_itm
		if (!this.current_list_id) {
			this.current_list_id = localStorage.getItem('list_id')
		}
		const totalAmount = this.cartItem.reduce((total, item) => {
			// Remove the '$' symbol and convert to a floating-point number
			const amount = parseFloat(item.Amount) * item.count;
			return total + amount;;
		}, 0); // 
		this.totalAmount = totalAmount;
		await this.afs.doc('/list/' + this.current_list_id).set({ items: this.cartItem }, { merge: true }).then(docRef => {
		});
		if (layout_product_qnt?.innerHTML) {
			layout_product_qnt.innerHTML = temp_itm.count
		}
		if (i?.product?.id) {
			const store_item: any = await this.store_item.find(item => item?.uid == i?.product?.id)
			const eventName = `@Product_clicks`;
			if (this.store_data[0]?.googleMeasurementId) {
				if (store_item) {
					(window as any).gtag('event', eventName, {
						send_to: this.store_data[0]?.googleMeasurementId,
						store_name: this.store_data[0]?.company_name,
						product_name: store_item.product_description,
					});
					(window as any).gtag('event', "@product_quantity_added_to_shopping_list", {
						send_to: this.store_data[0]?.googleMeasurementId,
						store_name: this.store_data[0]?.company_name,
						product_name: store_item.product_description,
					});
				}
			}
			this.analytics.logEvent(eventName, {
				store_name: this.store_data[0]?.company_name,
				product_name: store_item.product_description,
			});
			this.analytics.logEvent("@product_quantity_added_to_shopping_list", {
				store_name: this.store_data[0]?.company_name,
				product_name: store_item.product_description,
			});
		} else {
			const store_item: any = await this.store_item.find(item => item.uid == i?.product?.uid)
			const eventName = `@Product_clicks`;
			if (this.store_data[0]?.googleMeasurementId) {
				if (store_item) {
					(window as any).gtag('event', eventName, {
						send_to: this.store_data[0]?.googleMeasurementId,
						store_name: this.store_data[0]?.company_name,
						product_name: store_item.product_description,
					});
					(window as any).gtag('event', "@product_quantity_added_to_shopping_list", {
						send_to: this.store_data[0]?.googleMeasurementId,
						store_name: this.store_data[0]?.company_name,
						product_name: store_item.product_description,
					});
				}
			}
			this.analytics.logEvent(eventName, {
				store_name: this.store_data[0]?.company_name,
				product_name: store_item.product_description,
			});
			this.analytics.logEvent("@product_quantity_added_to_shopping_list", {
				store_name: this.store_data[0]?.company_name,
				product_name: store_item.product_description,
			});
		}
	}

	async decrease_product(i) {
		let main_item
		let delete_icon
		let layout_product_qnt
		let layout_count_product: HTMLElement
		const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
		if (view == "listView" && window.innerWidth < 768) {
			if (i?.product?.isBundleProduct) {
				if (i?.product?.id) {
					main_item = document.getElementById(i?.product?.id)?.parentElement?.parentElement?.parentElement;
				} else {
					main_item = document.getElementById(i?.product?.uid)?.parentElement?.parentElement?.parentElement;
				}
			} else {
				if (i?.product?.id) {
					main_item = document.getElementById(i?.product?.id)?.parentElement?.parentElement;
				} else {
					main_item = document.getElementById(i?.product?.uid)?.parentElement?.parentElement;
				}
			}
			delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
			layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
			layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
		} else {
			if (i?.product?.isBundleProduct) {
				if (i?.product?.id) {
					if (document.getElementById(i?.product?.id)) {
						if (document.getElementById(i?.product?.id).tagName != 'VIDEO') {
							main_item = document.getElementById(i?.product?.id)?.parentElement
						} else {
							main_item = document.getElementById(i?.product?.id)?.parentElement
						}
					}
				} else {
					if (document.getElementById(i?.product?.uid)) {
						if (document.getElementById(i?.product?.uid).tagName != 'VIDEO') {
							main_item = document.getElementById(i?.product?.uid)?.parentElement
						} else {
							main_item = document.getElementById(i?.product?.uid)?.parentElement
						}
					}
				}
			} else {
				if (i?.product?.id) {
					if (document.getElementById(i?.product?.id)) {
						if (document.getElementById(i?.product?.id).tagName != 'VIDEO') {
							main_item = document.getElementById(i?.product?.id)
						} else {
							main_item = document.getElementById(i?.product?.id)?.parentElement
						}
					}
				} else {
					if (document.getElementById(i?.product?.uid)) {
						if (document.getElementById(i?.product?.uid).tagName != 'VIDEO') {
							main_item = document.getElementById(i?.product?.uid)
						} else {
							main_item = document.getElementById(i?.product?.uid)?.parentElement
						}
					}
				}
			}
			layout_product_qnt = main_item?.parentElement?.getElementsByClassName("layout_product_qnt")[0]
			layout_count_product = main_item?.parentElement?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
			delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
		}
		let temp_itm = this.cartItem[this.cartItem.indexOf(i)]
		
		// Use sale_price_label_format for digital coupons, otherwise use price_label_format
		const formatToUse = i?.product?.digital_coupon ? i?.product?.sale_price_label_format : i?.product?.price_label_format;
		const value1ToUse = i?.product?.digital_coupon ? i?.product?.sale_price_label_value1 : i?.product?.price_label_value1;
		const value2ToUse = i?.product?.digital_coupon ? i?.product?.sale_price_label_value2 : i?.product?.price_label_value2;
		
		if (formatToUse === 'format5') {
			// For format5: decrement by the quantity specified in value1 (e.g., "3 for $5.99" subtracts 3)
			const format5Qty = this.getFormat5Quantity(formatToUse, value1ToUse);
			const currentCount = temp_itm.count || format5Qty;
			const newCount = currentCount - format5Qty;
			
			if (newCount <= 0) {
				// If count reaches 0 or below, remove the item
				if (!this.serializedIds && this.serializedIds == undefined) {
					this.serializedIds = this.combinedData?.flatMap(s => {
						if (s?.subGridOpts?.children?.length) {
							return s.subGridOpts.children.map(child => child.id);
						} else {
							return [s.id];
						}
					});
				}
				this.cartItem.splice(this.cartItem.indexOf(i), 1)
				if (i?.product?.id) {
					if (!temp_itm.static && this.serializedIds.includes(i?.product?.id)) {
						let title_bar: any = main_item?.parentElement.childNodes[1]
						title_bar?.classList?.remove("test")
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.id), 1)
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
					}
				} else {
					if (!temp_itm.static && this.serializedIds.includes(i?.product?.uid)) {
						let title_bar: any = main_item?.parentElement.childNodes[1]
						title_bar?.classList?.remove("test")
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.uid), 1)
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
					}
				}
			} else {
				temp_itm.count = newCount;
				temp_itm.paidCount = newCount; // For format5, paidCount equals count
				this.cartItem[this.cartItem.indexOf(i)] = temp_itm
				if (layout_product_qnt?.innerHTML) {
					layout_product_qnt.innerHTML = temp_itm.count
				}
			}
		} else if (formatToUse === 'format6') {
			// For format6: decrement paid count by 1, then recalculate total with free items
			const currentPaidCount = temp_itm.paidCount || temp_itm.count || 1;
			const buyQty = this.getBuyQuantity(formatToUse, value1ToUse);
			const newPaidCount = currentPaidCount - 1;
			
			if (newPaidCount <= 0) {
				// If paid count reaches 0 or below, remove the item
				if (!this.serializedIds && this.serializedIds == undefined) {
					this.serializedIds = this.combinedData?.flatMap(s => {
						if (s?.subGridOpts?.children?.length) {
							return s.subGridOpts.children.map(child => child.id);
						} else {
							return [s.id];
						}
					});
				}
				this.cartItem.splice(this.cartItem.indexOf(i), 1)
				if (i?.product?.id) {
					if (!temp_itm.static && this.serializedIds.includes(i?.product?.id)) {
						let title_bar: any = main_item?.parentElement.childNodes[1]
						title_bar?.classList?.remove("test")
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.id), 1)
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
					}
				} else {
					if (!temp_itm.static && this.serializedIds.includes(i?.product?.uid)) {
						let title_bar: any = main_item?.parentElement.childNodes[1]
						title_bar?.classList?.remove("test")
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.uid), 1)
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
					}
				}
			} else if (newPaidCount < buyQty) {
				// If paid count is below buyQty, show only paid items (no free items)
				temp_itm.paidCount = newPaidCount;
				temp_itm.count = newPaidCount; // Just the paid items, no free items
				this.cartItem[this.cartItem.indexOf(i)] = temp_itm
				if (layout_product_qnt?.innerHTML) {
					layout_product_qnt.innerHTML = temp_itm.count
				}
			} else {
				// Recalculate total count with new paid count (includes free items)
				temp_itm.paidCount = newPaidCount;
				temp_itm.count = this.calculateTotalCount(formatToUse, value1ToUse, value2ToUse, newPaidCount);
				this.cartItem[this.cartItem.indexOf(i)] = temp_itm
				if (layout_product_qnt?.innerHTML) {
					layout_product_qnt.innerHTML = temp_itm.count
				}
			}
		} else {
			// For other formats: standard decrement logic
			if (temp_itm.count > 1) {
				temp_itm.count -= 1
				this.cartItem[this.cartItem.indexOf(i)] = temp_itm
				if (layout_product_qnt?.innerHTML) {
					layout_product_qnt.innerHTML = temp_itm.count
				}
			} else if (temp_itm.count === 1) {
				if (!this.serializedIds && this.serializedIds == undefined) {
					// this.serializedIds = this.combinedData.map(s => s.id)
					this.serializedIds = this.combinedData?.flatMap(s => {
						if (s?.subGridOpts?.children?.length) {
							return s.subGridOpts.children.map(child => child.id);
						} else {
							return [s.id];
						}
					});
				}
				this.cartItem.splice(this.cartItem.indexOf(i), 1)
				if (i?.product?.id) {
					if (!temp_itm.static && this.serializedIds.includes(i?.product?.id)) {
						let title_bar: any = main_item?.parentElement.childNodes[1]
						title_bar?.classList?.remove("test")
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.id), 1)
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
					}
				} else {
					if (!temp_itm.static && this.serializedIds.includes(i?.product?.uid)) {
						let title_bar: any = main_item?.parentElement.childNodes[1]
						title_bar?.classList?.remove("test")
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.uid), 1)
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
					}
				}
			}
		}
		const totalAmount = this.cartItem.reduce((total, item) => {
			// Remove the '$' symbol and convert to a floating-point number
			const amount = parseFloat(item.Amount) * item.count;
			return total + amount;;
		}, 0); // 
		this.totalAmount = totalAmount;
		await this.afs.doc('/list/' + this.current_list_id).set({ items: this.cartItem }, { merge: true }).then(docRef => {
		});
	}
	categoryProd(val) {
		sessionStorage.setItem('is_all_clicked', 'true');
		this.categoryList.emit(val)
		 this.selectedCategory = val;
	}
	categoryMainProd(val) {
		sessionStorage.setItem('is_all_clicked', 'true');
		this.categoryMainList.emit(val)
		 this.selectedMainCategory = val;
		 this.selectedCategory = 'All';
	}
	product_select_change(event, type, product) {
		if (!this.serializedIds) {
			// this.serializedIds = this.combinedData.map(s => s.id)
			this.serializedIds = this.combinedData?.flatMap(s => {
				if (s?.subGridOpts?.children?.length) {
					return s.subGridOpts.children.map(child => child.id);
				} else {
					return [s.id];
				}
			});
		}
		if (event.target.checked && (type === 'all')) {
			this.selected_cart_items = this.cartItem
			this.isAllSelected = true
		} else if (!event.target.checked && (type === 'all')) {
			this.selected_cart_items = []
			this.isAllSelected = false
		} else if (event.target.checked && (type === 'single') && (this.serializedIds.includes(product.product.uid) || product.isCoupon || this.isCoupon)) {
			this.selected_cart_items.push(product)
			if (!product.isCoupon && !this.isCoupon) {
				let a = document.getElementById(product.product.uid)?.parentElement?.lastElementChild?.getElementsByTagName('img')[0].src
				a = "../../../assets/imgs/right.png"
			}
		} else if (!event.target.checked && (type === 'single') && this.serializedIds.includes(product.product.uid)) {
			this.selected_cart_items.splice(this.selected_cart_items.indexOf(product), 1)
			this.cart_ids.splice(this.cart_ids.indexOf(product.product.uid), 1)
			let a = document.getElementById(product.product.uid)?.parentElement?.lastElementChild?.getElementsByTagName('img')[0].src
			a = "../../../assets/imgs/plus.png"
		} else if (event.target.checked && (type === 'single') && (this.serializedIds.includes(product.product.id) || product.isCoupon || this.isCoupon)) {
			this.selected_cart_items.push(product)
			if (!product.isCoupon && !this.isCoupon) {
				let a = document.getElementById(product.product.id)?.parentElement?.lastElementChild?.getElementsByTagName('img')[0]?.src
				a = "../../../assets/imgs/right.png"
			}
		} else if (!event.target.checked && (type === 'single') && this.serializedIds.includes(product.product.id)) {
			this.selected_cart_items.splice(this.selected_cart_items.indexOf(product), 1)
			this.cart_ids.splice(this.cart_ids.indexOf(product.product.id), 1)
			let a = document.getElementById(product.product.id)?.parentElement?.lastElementChild?.getElementsByTagName('img')[0].src
			a = "../../../assets/imgs/plus.png"
		}
	}

	product_past_select_change(event, type, product) {
		if (!this.serializedIds) {
			// this.serializedIds = this.combinedData.map(s => s.id)
			this.serializedIds = this.combinedData?.flatMap(s => {
				if (s?.subGridOpts?.children?.length) {
					return s.subGridOpts.children.map(child => child.id);
				} else {
					return [s.id];
				}
			});
		}
		if (event.target.checked && (type === 'all')) {
			this.selected_past_cart_items = this.past_item
			this.isAllPastSelected = true
		} else if (!event.target.checked && (type === 'all')) {
			this.selected_past_cart_items = []
			this.isAllPastSelected = false
		} else if (event.target.checked && (type === 'single')) {
			this.selected_past_cart_items.push(product)
		} else if (!event.target.checked && (type === 'single')) {
			this.selected_past_cart_items.splice(this.selected_past_cart_items.indexOf(product), 1)
			this.cart_ids.splice(this.cart_ids.indexOf(product.product.uid), 1)
		} else if (event.target.checked && (type === 'single')) {
			this.selected_past_cart_items.push(product)
		} else if (!event.target.checked && (type === 'single')) {
			this.selected_past_cart_items.splice(this.selected_past_cart_items.indexOf(product), 1)
			this.cart_ids.splice(this.cart_ids.indexOf(product.product.id), 1)
		}
	}

	async remove_from_past_cart(i, type) {
		if (type === 'one') {
			this.past_item.splice(this.past_item.indexOf(i), 1);
			if (!i.static && this.serializedIds.includes(i?.product?.uid) && !this.isCoupon && !this.isRecipe) {
				let main_item
				let title_bar
				let delete_icon
				let layout_product_qnt
				let layout_count_product: HTMLElement
				const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
				if (view == "listView" && window.innerWidth < 768) {
					if (i?.product?.isBundleProduct) {
						main_item = document.getElementById(i?.product?.uid)?.parentElement?.parentElement?.parentElement;
					} else {
						main_item = document.getElementById(i?.product?.uid)?.parentElement?.parentElement;
					}
					delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
					layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
				} else {
					if (i?.product?.isBundleProduct) {
						if (document.getElementById(i?.product?.uid)) {
							if (document.getElementById(i?.product?.uid).tagName != 'VIDEO') {
								if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
									main_item = document.getElementById(i?.product?.uid)?.parentElement
								} else {
									main_item = document.getElementById(i?.product?.uid)?.parentElement
								}
							} else {
								main_item = document.getElementById(i?.product?.uid)?.parentElement
							}
						}
					} else {
						if (document.getElementById(i?.product?.uid)) {
							if (document.getElementById(i?.product?.uid).tagName != 'VIDEO') {
								if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
									main_item = document.getElementById(i?.product?.uid)?.parentElement
								} else {
									main_item = document.getElementById(i?.product?.uid)
								}
							} else {
								main_item = document.getElementById(i?.product?.uid)?.parentElement
							}
						}
					}

					layout_product_qnt = main_item.parentElement.getElementsByClassName("layout_product_qnt")[0]
					layout_count_product = main_item.parentElement.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
					title_bar = main_item?.parentElement?.childNodes[1]
					title_bar?.classList?.remove("test")
				}
				if (layout_product_qnt?.innerHTML) {
					layout_product_qnt.innerHTML = ''
				}
				if (layout_count_product?.style?.visibility) {
					layout_count_product.style.visibility = 'hidden'
				}
				this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.uid), 1)
				if (delete_icon) {
					delete_icon.src = "../../../assets/imgs/plus.png"
				}
			} else if (!i.static && this.serializedIds.includes(i?.product?.id) && !this.isCoupon && !this.isRecipe) {
				let main_item
				let title_bar
				let delete_icon
				let layout_product_qnt
				let layout_count_product: HTMLElement
				const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
				if (view == "listView" && window.innerWidth < 768) {
					if (i?.product?.isBundleProduct) {
						main_item = document.getElementById(i?.product?.id)?.parentElement?.parentElement?.parentElement;
					} else {
						main_item = document.getElementById(i?.product?.id)?.parentElement?.parentElement;
					}
					delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
					layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
				} else {
					if (i?.product?.isBundleProduct) {
						if (document.getElementById(i?.product?.id)) {
							if (document.getElementById(i?.product?.id).tagName != 'VIDEO') {
								if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
									main_item = document.getElementById(i?.product?.id)?.parentElement
								} else {
									main_item = document.getElementById(i?.product?.id)?.parentElement
								}
							} else {
								main_item = document.getElementById(i?.product?.id)?.parentElement
							}
						}
					} else {
						if (document.getElementById(i?.product?.id)) {
							if (document.getElementById(i?.product?.id).tagName != 'VIDEO') {
								if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
									main_item = document.getElementById(i?.product?.id)?.parentElement
								} else {
									main_item = document.getElementById(i?.product?.id)
								}
							} else {
								main_item = document.getElementById(i?.product?.id)?.parentElement
							}
						}
					}
					layout_product_qnt = main_item.parentElement.getElementsByClassName("layout_product_qnt")[0]
					layout_count_product = main_item.parentElement.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
					title_bar = main_item?.parentElement?.childNodes[1]
					title_bar?.classList?.remove("test")
				}
				if (layout_product_qnt?.innerHTML) {
					layout_product_qnt.innerHTML = ''
				}
				if (layout_count_product?.style?.visibility) {
					layout_count_product.style.visibility = 'hidden'
				}
				this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.id), 1)
				if (delete_icon) {
					delete_icon.src = "../../../assets/imgs/plus.png"
				}
			}
		}
		if (type == 'selected') {
			this.past_item = this.past_item?.filter(itm => {
				if (!this.selected_past_cart_items.includes(itm)) {
					return true
				} else {
					if (this.serializedIds.includes(itm?.product?.uid) && !this.isCoupon) {
						let main_item
						let title_bar
						let count_icon_plus: HTMLElement
						let count_icon_minus: HTMLElement
						let delete_icon
						let layout_product_qnt
						let layout_count_product: HTMLElement
						const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
						if (view == "listView" && window.innerWidth < 768) {
							if (itm?.product?.isBundleProduct) {
								main_item = document.getElementById(itm?.product?.uid)?.parentElement?.parentElement?.parentElement;
							} else {
								main_item = document.getElementById(itm?.product?.uid)?.parentElement?.parentElement;
							} delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
							layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
							layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
							count_icon_plus = main_item?.getElementsByClassName("count-products")[0]?.firstChild as HTMLElement;
							count_icon_minus = main_item?.getElementsByClassName("count-products")[0]?.lastChild as HTMLElement;
						} else {
							if (itm?.product?.isBundleProduct) {
								if (document.getElementById(itm?.product?.uid)) {
									if (document.getElementById(itm?.product?.uid).tagName != 'VIDEO') {
										if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
											main_item = document.getElementById(itm?.product?.uid)?.parentElement
										} else {
											main_item = document.getElementById(itm?.product?.uid)?.parentElement
										}
									} else {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									}
								}
							} else {
								if (document.getElementById(itm?.product?.uid)) {
									if (document.getElementById(itm?.product?.uid).tagName != 'VIDEO') {
										if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
											main_item = document.getElementById(itm?.product?.uid)?.parentElement
										} else {
											main_item = document.getElementById(itm?.product?.uid)
										}
									} else {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									}
								}
							}
							layout_product_qnt = main_item.parentElement.getElementsByClassName("layout_product_qnt")[0]
							layout_count_product = main_item.parentElement.getElementsByClassName("layout_count_product")[0] as HTMLElement;
							delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
							title_bar = main_item?.parentElement?.childNodes[1]
							title_bar?.classList.remove("test")
						}
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						this.cart_ids.splice(this.cart_ids.indexOf(itm?.product?.id), 1)
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						return false
					} else if (this.serializedIds.includes(itm?.product?.id) && !this.isCoupon) {
						let main_item
						let title_bar
						let count_icon_plus: HTMLElement
						let count_icon_minus: HTMLElement
						let delete_icon
						let layout_product_qnt
						let layout_count_product: HTMLElement
						const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
						if (view == "listView" && window.innerWidth < 768) {
							if (itm?.product?.isBundleProduct) {
								main_item = document.getElementById(itm?.product?.id)?.parentElement?.parentElement?.parentElement;
							} else {
								main_item = document.getElementById(itm?.product?.id)?.parentElement?.parentElement;
							}
							delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
							layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
							layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
							count_icon_plus = main_item?.getElementsByClassName("count-products")[0]?.firstChild as HTMLElement;
							count_icon_minus = main_item?.getElementsByClassName("count-products")[0]?.lastChild as HTMLElement;
						} else {
							if (itm?.product?.isBundleProduct) {
								if (document.getElementById(itm?.product?.id)) {
									if (document.getElementById(itm?.product?.id).tagName != 'VIDEO') {
										if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
											main_item = document.getElementById(itm?.product?.id)?.parentElement
										} else {
											main_item = document.getElementById(itm?.product?.id)?.parentElement
										}
									} else {
										main_item = document.getElementById(itm?.product?.id)?.parentElement
									}
								}
							} else {
								if (document.getElementById(itm?.product?.id)) {
									if (document.getElementById(itm?.product?.id).tagName != 'VIDEO') {
										if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
											main_item = document.getElementById(itm?.product?.id)?.parentElement
										} else {
											main_item = document.getElementById(itm?.product?.id)
										}
									} else {
										main_item = document.getElementById(itm?.product?.id)?.parentElement
									}
								}
							}
							layout_product_qnt = main_item.parentElement.getElementsByClassName("layout_product_qnt")[0]
							layout_count_product = main_item.parentElement.getElementsByClassName("layout_count_product")[0] as HTMLElement;
							delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
							title_bar = main_item?.parentElement?.childNodes[1]
							title_bar?.classList.remove("test")
						}
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						this.cart_ids.splice(this.cart_ids.indexOf(itm?.product?.id), 1)
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						return false
					}
				}
			})
		}

		this.current_list_id = localStorage.getItem('list_id') ? localStorage.getItem('list_id') : ''
		await this.afs.doc('/list/' + this.current_list_id).set({ past_items: this.past_item }, { merge: true });
	}

	initializeFB(item) {
		const initParams = {
			appId: '317808808064170',
			xfbml: true,
			version: 'v20.0'
		};
		FB.init(initParams);

		let myVideoPlayers = {};

		FB.Event.subscribe('xfbml.ready', (msg) => {
			if (msg.type === 'video' && msg.id == item.id) {
				const videoPlayer = msg.instance;
				const videoId = msg.id;

				myVideoPlayers[videoId] = videoPlayer;

				if (videoId === item.id) {
					if (item.autoplay) {
						videoPlayer.play();
					}
					videoPlayer.subscribe('finishedPlaying', () => {
						// this.restartVideo(videoPlayer);
					});
				}
			}
		});

		FB.XFBML.parse();
	}
	selectPrintSize(){
		this.showPrintOptions = !this.showPrintOptions;
	}
	async frontend_print() {
		// Check if current route includes /restaurant
		
		if (this.isRestaurantRoute) {
			await this.printRestaurantMenu();
			return;
		}

		const printBannerTitle = this.store_data[0]?.PrintBannerTitle || '';
        const shouldShowSection = printBannerTitle.trim() !== '';
		this.analytics.logEvent('@Circular_print_click_count', {
			store_name: this.store_data[0]?.company_name,
			message: 'Circular Print Button Clicked.'
		})
		if (this.store_data[0]?.googleMeasurementId) {
			(window as any).gtag('event', "@Circular_print_click_count", {
				send_to: this.store_data[0]?.googleMeasurementId,
				store_name: this.store_data[0]?.company_name,
				message: 'Circular Print Button Clicked.'
			});
		}
		var printWindow = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
		var loader = document.createElement('div');
		loader.classList.add('loader');
		loader.innerHTML = '<img src="assets/imgs/loading2.gif" alt="Loading....">';
		loader.style.position = 'fixed';
		loader.style.top = '50%';
		loader.style.left = '50%';
		loader.style.transform = 'translate(-50%, -50%)';
		// Append loader to print window document
		printWindow.document.body.appendChild(loader);

		// Function to remove loader
		function removeLoader() {
			loader.remove();
		}

		// Event listener to remove loader when content is loaded
		printWindow.onload = removeLoader;
		var gridItems = document.querySelectorAll('.grid-stack-item');
		var gridContent = '';
		var DIGITalCoupon = '';
		var bannerImg = this.store_data[0]?.banner_image;
		const headerEl = document.querySelector('.dcp-logo-print') as HTMLElement | null;
		var header = headerEl ? headerEl.innerHTML : '';
		const printBannerTitleEl = document.querySelector('.PrintBannerTitle') as HTMLElement | null;
		var PrintBannerTitleDiv = printBannerTitleEl ? printBannerTitleEl.innerHTML : '';

		var footer: any = document.querySelector('.price-goods')
		if (footer) {
			footer = footer.innerHTML
		}else{
			footer = ''
		}
		var gridItemsArray = gridItems

		// Create an array to store promises
		const promises = [];


		// Wait for all promises to resolve
		await Promise.all(promises);

		// Concatenate grid content
		gridItemsArray.forEach((item: Element) => {
			if (!item.classList.contains('grid-stack-sub-grid')) {
				const digitalCoupon = item.querySelector('.Digital_price_main');
				const div = item.querySelector('.grid-stack-item-content') as HTMLElement | null;
				if (digitalCoupon) {
					div.classList.add('digital_coupon_div');
					DIGITalCoupon += item.innerHTML;
				} else {
					var fbVideos = item.getElementsByClassName("fb-video");
					if (fbVideos.length == 0) {
						gridContent += item.innerHTML;
					}
				}
			}
		});

		printWindow.document.write(`
       <html>
          <head>
	          <link rel="stylesheet" href="https://gridstackjs.com/demo/demo.css"/>
	          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/gridstack.js/10.1.0/gridstack-extra.min.css"/>
	          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/gridstack.js/10.1.0/gridstack.css"/>
	     <title>Print Preview</title>
         <style>
		         .grid-stack{
			       background-color:white !important;
			       margin-left:75px ;
		         }
				 .wrapper-main{
					visibility:visible !important;
					display:none !important;
				 }
				 .banner-img-width{
	               height:auto !important;
				 }
				.fb-video >span >iframe{
				   width:203px !important;
				   height:133px !important;
				   }
				.banner-text{
                     position: absolute;
                     top: 50%;
                     left: 50%;
                     width: 100%;
                     -ms-transform: translate(-50%, -50%);
                     transform: translate(-50%, -50%);
					}
				 .digital_coupon_section >.digital_title{
					text-align:center;
					margin-top: 20px;
					margin-bottom: 20px;
					font-size:17px !important;
				  }
				 .grid-stack-item-content.digital_coupon_div { 
					width:290px !important ;
					height:290px !important;
				 }
				//  .digital_coupon_section{
				// 	page-break-before :always !important;
				//  }
				 .grid-stack-item-content.digital_coupon_div >.product-title{
					top: -335px !important;
					height:50px !important;
					padding-left:25px !important;
					display:flex !important;
					flex-direction: column !important;
					justify-content: center !important;
				  }
				  .grid-stack-item-content.digital_coupon_div >.product-title p{
				   font-size:13px !important;
				  }
				  .grid-stack-item-content.digital_coupon_div >.product-title >.packDetailsName{
					font-size:13px !important;
				   }
				  .grid-stack-item-content.digital_coupon_div >.pack-info-container {
					bottom: 18px !important;
					font-size: 14px !important;
				   }
			    .grid-stack-item-content { 
				  background-color: white; 
				  border: 1px solid #ccc; 
				  position:relative !important;		
				  text-align: center; 
				  width:120px;
	              height:130px;
				  padding:40px 0px  !important;
				  overflow:hidden !important;

			   }

			  .grid-stack-item-content img{
				width:60px;
                height:50px;
			  }

			  .product-title{
				background-size: cover;
				position: relative !important;
				top: -179px !important;
				background-color: #fff;
				color: #000 !important;
				font-weight: 2 !important;
                height: 40px !important;
				color: #000;
				padding-left:0 !important;
				padding-right: 0 !important;
				left:0 !important;
				background-color:transparent !important;
				align-items:center !important;
			  }
            .product-title p {
                font-size: 12.5px !important;
                -webkit-line-clamp: 3 !important;
                line-height: unset !important;
                margin-bottom: 0 !important;
                font-weight: 800 !important;
				padding-right:10px !important;
            }
			 .packTitleProName{
                font-size: 10.5px !important;
             }
			  .packDetailsName{
				color: black !important;
				font-size:10px !important;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical;
				overflow: hidden;
				line-height:1 !important;
				margin-bottom:0 !important;
					}
			  .pricelabel {
				position: relative !important;
				bottom: 145px !important;
				left: 0px !important;
				width: 6vw !important;
                height: 6vw !important;
				font-size: 2.5vw !important;
			  }

		     .grid-stack > .grid-stack-item > .grid-stack-item-content {
			   margin: 0;
			   position: absolute;
			//    width: auto;
			   overflow-x: hidden;
			   overflow-y: auto;
			  inset: 2px !important;
		     }

		     .grid-stack-item-content > img {
			 object-fit: cover !important;
			 max-width: 100% !important;
			 height: 100% !important;
			//  cursor: pointer;
		     }
			 .grid-stack-item-content >.fill_video >video{
				object-fit: cover !important;
				max-width: 100% !important;
				height: 100% !important;
			   //  cursor: pointer;
				}
			 .grid-stack-item-content.digital_coupon_div > img {
				object-fit: cover !important;
				max-width: 100% !important;
				height: 100% !important;
			   //  cursor: pointer;
				}
   

		     .banner-img-width{
			   width: 100% !important;
		     }

		     .grid-stack-item-content {
			   padding-top: 36px;
			   background-color: #fff !important;
		     }
		  
		  
		    //  .test {
			//    background-color: #76b101 !important;
			//    color: white !important;
		    //  }
		  
		     .label .pricelabel svg {
               height: 150px !important;
			   width: 150px !important;
		     }
		  
		     .gifImg {
		 	   width: 100% !important;
			   object-position: center !important;
		     }

		     .count-products i {
			   font-size: 19px;
			   color: #000;
			   cursor: pointer;
		     }
         
             .count-products span {
	           color: black;
	           font-weight: 600;
             }  

             .add_cart_icon, .deleteicon {
	           display:none !important;
             }

             .layout_product_qnt.product_qnt{
               display:none !important;
             }

             .circular-card-deal {
		       width: 5.5vw !important;
		       height: 5.5vw !important;
		       font-size: 3vw !important;
	           padding: 12%;
	           z-index: 300;
	           border: 4px solid ${this.store_data[0]?.theme_base_color || 'rgb(139, 195, 74)'};
	           border-radius: 50%;
	           background-color: #fff;
	           color: ${this.store_data[0]?.theme_base_color || 'rgb(139, 195, 74)'};
	           font-weight: 700;
	           line-height: 1;
	           font-family: "Oswald", sans-serif;
	           text-transform: uppercase;
             }
  
             .circular-card.size-11 .circular-card-deal {
	           padding: 5% 8%;
             }
  
             .circular-card.standard .circular-card-deal {
	           background-color: #fff;
	           color: rgb(139, 195, 74);
	           border-color: rgb(139, 195, 74);
             }
  
             .price-container {
	           display: -webkit-box;
	           display: -webkit-flex;
	           display: -ms-flexbox;
	           display: flex;
	           width: 100%;
	           height: 100%;
	           max-width: 100%;
	           max-height: 100%;
	           -webkit-box-pack: center;
	           -webkit-justify-content: center;
	           -ms-flex-pack: center;
	           justify-content: center;
	           -webkit-box-align: center;
	           -webkit-align-items: center;
	           -ms-flex-align: center;
	           align-items: center;
	           -webkit-box-orient: vertical;
	           -webkit-box-direction: normal;
	           -webkit-flex-direction: column;
	           -ms-flex-direction: column;
	           flex-direction: column;
             }

             .deleteicon{
	           display:none !important;
             }
  
             .circular-card-deal-content {
               display: -webkit-box;
               display: -webkit-flex;
               display: -ms-flexbox;
               display: flex;
	           -webkit-box-orient: vertical;
	           -webkit-box-direction: normal;
	           -webkit-flex-direction: column;
	           -ms-flex-direction: column;
	           flex-direction: column;
	           -webkit-box-align: center;
	           -webkit-align-items: center;
	           -ms-flex-align: center;
	           align-items: center;
	           -webkit-box-pack: center;
	           -webkit-justify-content: center;
	           -ms-flex-pack: center;
	           justify-content: center;
	           height: 100%;
             }
  
             .circular-card-price {
	           display: -webkit-box;
	           display: -webkit-flex;
	           display: -ms-flexbox;
	           display: flex;
	           -webkit-box-orient: vertical;
	           -webkit-box-direction: normal;
	           -webkit-flex-direction: column;
	           -ms-flex-direction: column;
	           flex-direction: column;
	           -webkit-box-align: center;
	           -webkit-align-items: center;
	           -ms-flex-align: center;
	           align-items: center;
             }
  
             .circular-card-price .top-line,
             .circular-card-price .bottom-line {
	           display: -webkit-box;
	           display: -webkit-flex;
	           display: -ms-flexbox;
	           display: flex;
             }
  
             .circular-card-price .dollar-sign,
             .circular-card-price .bignum,
             .circular-card-price .price-unit {
	           position: relative;
             }
  
             .dollar-sign,
             .percent-sign {
	          font-size: 50%;
             }
  
             .dollar-amount,
             .big-cents {
	          line-height: 85%;
             }
			 .pack-info-container {
				FONT-VARIANT: JIS04;
				position: relative !important;
				bottom: 120px !important;
				font-size: 14px !important;
				line-height:1 !important;
				left: 7%;	
				word-wrap: break-word;
				width: 80%;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: visible;
				z-index:9999 !important;
			 }
			
             .circular-card-price .price-unit-wrapper {
	           display: -webkit-box;
	           display: -webkit-flex;
	           display: -ms-flexbox;
	           display: flex;
	           -webkit-box-orient: vertical;
	           -webkit-box-direction: normal;
	          -webkit-flex-direction: column;
	          -ms-flex-direction: column;
	          flex-direction: column;
             }
  
             .price-unit-wrapper,
              .paint-green .circular-card-price {
	            -webkit-align-self: flex-start;
	            -ms-flex-item-align: start;
	            align-self: flex-start;
              }
  
              .cents-sign,
              .cents-amount,
              .bottom-line {
             	font-size: 60%;
              }
  
              #format3 .price-unit,
              #format4 .price-unit {
             	font-size: 30%;
              }
  
              #format5 .num-to-cart,
              #format6 .num-to-cart {
	           -webkit-box-pack: center;
	           -webkit-justify-content: center;
	           -ms-flex-pack: center;
	           justify-content: center;
	           display: -webkit-box;
	           display: -webkit-flex;
	           display: -ms-flexbox;
	           display: flex;
             }
  
              #format5 .dollar-amount,
              #format5 .pricing-num-for,
              #format6 .pricing-num-to-cart,
              #format6 .pricing-num-for {
	            padding-right: 2px;
	            padding-bottom: 2px;
              }
  
              #format5 .dollar-amount,
              #format5 .third-amount,
              #format5 .pricing-for,
              #format6 .pricing-buy-get,
              #format6 .dollar-amount,
              #format6 .cents-amount,
              #format6 .third-amount {
	            font-size: 36%;
             }
  
             .pricing-buy-get,
             .pricing-num-for {
	           padding-right: 4px;
	           padding-bottom: 0px;
             }   
               
            .grid-stack {
	          display: flex; 
	          flex-wrap: wrap; 
	          width: 100%; 
             } 

            .grid-stack.simple_pro >.grid-stack-item-content { 
              flex: 0 0 15%; 
             } 


             .price-goods{
	           display:flex;
	           justify-content:end;
	           background-color:${this.store_data[0]?.theme_base_color || 'rgb(139, 195, 74)'};
	           margin-top: 10px;
               margin-left: 10px;
	           margin-right:10px;
             }

             .price-goods span {
	           padding: 0px 5px;
	           color: #fff;
	           font-weight: 500;
              }




             .gs-id-0 > .grid-stack-item > .grid-stack-item-content {
               inset: 10px;
             }

             .grid-stack > .grid-stack-item > .grid-stack-item-content {
               margin: 0;
               position: absolute;
               width: auto;
               overflow-x: hidden;
               overflow-y: auto;
             }

              .grid-stack-item-content:has(.hide_bar) {
                padding-top: 36px !important;
              }
		      .grid-stack-item-content > img.hide_bar {
				object-fit: fill !important;
				max-width: 95% !important;
				height: 95% !important;
				    position:absolute !important;
				   top:-5px !important;
				   left:5px !important;
				}
			 .grid-stack-item-content >.fill_video >video.hide_bar{
				object-fit: fill !important;
				max-width: 95% !important;
				height: 95% !important;
			    position:absolute !important;
				top:-5px !important;
				left:5px !important;
				}
			   	.grid-stack-item-content >iframe.hide_bar{
				object-fit: fill !important;
				max-width: 95% !important;
				height: 100% !important;
				}
			   	.grid-stack-item-content >.iframe >iframe.hide_bar{
				object-fit: fill !important;
				max-width: 100% !important;
				height: 100% !important;
				}
			  hr{
				margin-bottom:5px !important;
				margin-top:1px !important;
				margin-left:11px !important;
				margin-right:18px !important;
				width:98% !important;
			 }
			   .grid-stack.simple_pro {
				   margin-top:7px ;
		         } 
			 .offerLabel{
				width: auto !important;
				height:auto !important;
				top: 34px !important;
				display:unset !important;
				right:0px !important;
				left:0px !important;

			 }
			 .offerLabel span {   
				display: -webkit-box;
			   -webkit-line-clamp: 1;
			   -webkit-box-orient: vertical;
				overflow: hidden;
				word-wrap: normal;
				  font-size: 11px !important;
				line-height: -1px !important;
				right:0 !important;
				padding-top: 4px !important;
				width: 60% !important;
				left: 10px !important;
			   }

			 .offerLabel img{
			   width:70% !important;
			  }
			 .sell-price{
				display: flex;
			  }
			  .price_format_1,.price_format_2,.digital_coupon{
				display: flex;
				position: relative;
			  }
			  /* .price_format_1{
				align-items: center;
			  } */
			  .price_format_wrapper,.final_price_format_wrapper{
				display: flex;
				flex-direction: column;
			  }
			  /* .price_format_wrapper{
			  padding-left: 14px;
			  } */
			  .price_format_data_2{
				margin-top: -4px;
			  }
			  .for_title,.price_cutout{
				display: flex;
				flex-direction: column;
			  }
			  .digital_coupon_data{
				display: flex;
				position: relative;
			  }
			  .Digital_price_main{
			   border: 3px solid black;
			  width: fit-content;
			  position: absolute;
			  right: 12px;
			  bottom: 5px;
			  
			  border-top-left-radius: 10px;
			  border-bottom-right-radius: 10px;
			  }
			  .scissors_img{
				width: 50px !important;
			  }
			  .use_up_to_wrapper{
				border: 3px solid black;
			  width: fit-content;
			  border-top-left-radius: 10px;
			  border-bottom-right-radius: 10px;
			  position: absolute;
			  bottom: 5px;
			  left: 5px;
			  max-width: 112px;
			  }
			  .use_up_to_wrapper h2{
				background: #ffcf16;
				color: red;
				font-size: 16px;
				line-height: 1.5;
				margin: 0;
				text-align: center;
				font-weight: 700;
				border-top-left-radius: 10px;
			  }
			  .price_main_wrapper_cut{
				background-color: #d82027;
			  }
			  .price_main_wrapper_cut{
				display: flex;
			  gap: 5px;
			  justify-content: center;
			  align-items: center;
			  }
			  .price_main_wrapper_cut h3{
				font-size: 50px;
				line-height: 50px;
				color: white;
				margin: 0;
			  font-weight: 800;
			  }
			  .price_cutout span{
				font-size: 14px;
				line-height: 1;
				color: white;
				font-weight: 500;
				padding-top: 2px;
			  
			  }
			  .price_format_1.final_price_value_wrapper{
				justify-content: center;
				padding-top: 4px;
			  }
			  /* .price_format_1.final_price_value_wrapper .price_format_data_1{
				font-size: 19px;
				line-height: 20px;
			  } */
			  .use_up_to_wrapper h6{
				background-color: #d82027;
				color: white;
				margin: 0;
				font-size:13px;
				font-weight: 600;
				line-height: 15px;
				padding: 2px;
				text-align: center;
				border-bottom-right-radius: 10px;
			  }
			  .price_link_data svg{ 
				width: 30px !important;
				fill: white;
				/* background-color: #f04451; */
				/* padding: 5px; */
				border-radius: 50%;
				height: 17px;
				line-height: 10px;
				margin-top: 5px;
			  }
			  .price_link_data{
				position: absolute;
				top: 2px;
				left: 11px;
				width: 34px;
				height: 32px;
				border-radius: 50px;
				background:  #d82027;}
			  .sell_title_wrapper{
				display: flex;
				background-color: white;
				justify-content: space-between;
				padding: 5px;
				border-top-left-radius: 10px;
			  
			  }
			  .digital_coupon{
				background: #ffcf16;
			  align-items: center;
				justify-content: space-between;
				padding: 0 2px;
			  max-height: 35px;
			  }
			  .sell_title {
				font-size: 11px;
				font-weight: 600;
				text-align: left;
				color: black;
				line-height: 1;
				text-transform: uppercase;
			  }
			  .sale_condition_change_format_2 .for_title, .sale_condition_change_format_2  .price_Format_2_dataprice, .sale_condition_change_format_2  .format_2_offer_value, .sale_condition_change_format_2  .format_2_doller_symbol, .sale_condition_change_format_2 .format_2_price_value{
				color: black;
			  }
			  .sale_condition_change_format_2 {
				padding: 0 !important; 
			  }
			  .sale_condition_change_format_2 .format_2_doller_symbol {
			   margin-top: 3px;
			   padding-left: 5px;
			  }
			  .sale_condition_change_format_2 .format_2_offer_value{
				margin-top: 3px !important;
			  }
			  .sale_condition_change_format_2 .for_title{
				font-size: 9px;
				line-height: 0.9;
			  }
			  .sell_price_format2_wrapper{
				max-height: 35px;
			  }
			  
			  .digital_coupon_title{
				font-size: 10px;
				font-weight: 400;
				text-transform: uppercase;
				text-align: left;
				line-height: 1;
				color: black;
			  }
			  .price_format_data_1 ,.price_format_data_3,.digital_coupon_doller, .off2_offer > div,.format_2_doller_symbol,.format_2_offer_value{
				font-size: 13px;
				font-weight: 700;
				color: black;
				line-height: 14px;
			  }
			  .price_format_data_2 ,.digital_coupon_price_value{
				font-size: 32px;
				color: black;
				line-height: 40px;
				font-weight: 800;}
				/* .price_format_data_3{
			  margin-left: -3px;
				} */
				.price_format_data_1,.price_format_data_3{margin-top: 4px;}
				.digital_coupon_dess{
			  display: flex;
			  align-items: center;
			  font-size: 210%;
			  font-weight: 400;
			  color: black;
			  
				}
				.off2_offer{
				  display: flex;
				  flex-direction: column;
				  align-items: baseline;
				  justify-content: center;
				}
				.off2_offer:last-child{
				  margin-top: 4px;
				}
				.final_price, .digital-note {
				  background: #d82027;
				  color: white;
			  }
			   .digital-note{
				font-weight: 600;
				font-size: 13px;
				line-height: 15px;
				border-bottom-right-radius:10px;
				padding-bottom: 3px;
				text-transform: uppercase;
			   }
			   .price_format_1.final_price_value_wrapper .price_format_data_2{
				font-size: 32px;
				line-height: 40px;
			   }
			  .final_price_title{
				color: white;
				font-weight: 700;
				font-size: 18px;
				  line-height: 24px;
			  }
			  .with_digital_coupon_sub {
				font-size: 12px;
				padding: 0 5px;
				color: white;
				line-height: 1;
				font-weight: 600;
				text-transform: capitalize;
			  }
			  .price_format_2 {
				padding: 5px;
				margin: 0 auto;
			  }
			  .for_title{
				font-size: 10px;
				color: white;
				font-weight: 600;
				line-height: 0.9;
				display: flex;
				align-items: center;
				justify-content: center;
				padding-left: 4px;
			  padding-right: 4px;
			  }
			  .price_Format_2_dataprice,.format_2_price_value{
				color: white;
				font-size: 29px;
				line-height: 1;
				font-weight: 700;
			  
			  }
			  .sell_price_format2_wrapper
			  .price_format_1.final_price_value_wrapper {
				justify-content: center;
				padding-top: 5px;
			  }
			  .price_format_1.final_price_value_wrapper .price_format_data_1,.price_format_1.final_price_value_wrapper .price_format_data_2,.price_format_1.final_price_value_wrapper .price_format_data_3{
				color: white !important;
			  }
			  /* .price_format_1.final_price_value_wrapper .price_format_data_3{
				margin-left: 1px !important;
			  } */
			  
			  .format_2_doller_symbol, .format_2_offer_value{
				color: white;
				font-size: 14px;
				line-height:14px;
				margin-top: 2px;
			  }
			  .format_2_doller_symbol{
				padding-left: 10px;
			  }
			  
			  .price_cutout svg{
				fill: white;
				width: 30px;
			  }
			  /* .off2_offer:last-child{
				margin-top: -5px;
			  } */
			  .digital_coupon_price_value{
				font-size: 34px;
				display: flex;
				align-items: center;
				line-height: 35px;
			  }
			  .digital_coupon_doller{
			  display: flex;
			  align-items: center;
			  margin-top: -5px;
			  }
			  .sell_wrapper_format_1 .price_format_data_1,.sell_wrapper_format_1 .price_format_data_3{
				margin-top: 0;
				font-size: 16px;
			  }
			  
			  .offer_text_value .digital_coupon_doller{
				font-size: 15px;
				line-height: 15px;
			  }
			  .final_sale_value{
				align-items: normal;
			  }
			  
			  .offer_text_value {
				display: flex;
				align-items: baseline;
				gap: 2px;
			  }
			  .final_sale_value .price_format_data_2, .final_sale_value .price_format_data_1, .final_sale_value .price_format_data_3{
				margin-top: 0 !important;
			  }
			  .sell_wrapper_format_2 .format_2_doller_symbol{
				padding-left: 0;
			  }
			  .sell_wrapper_format_2{
				padding: 3px;
			  }
			  .final_price_wrraper_format2 .format_2_doller_symbol{    padding-left: 1px;
				padding-left: 1px;
				font-size: 17px;
				line-height: 22px;
				margin: 0;
				display: flex;
				align-items: center;}
				.final_price_wrraper_format2 .format_2_price_value, .final_price_wrraper_format2 .price_Format_2_dataprice{
				  font-size: 36px;
				  line-height: 40px;
				  font-weight: bolder;
				}
				.final_sale_value .price_format_data_3{
				  font-size: 36px;
				  line-height: 40px;
				}
				.off2_offer > div{
				  display: flex;
				  text-transform: uppercase;
				}
				.final_sale_value .price_format_data_1{
				  font-size: 18px;
				  line-height: 18px;
				  margin-top: -3px !important;
				  align-items: center;
				  display: flex;
				}
				.linkSymbol{
				  position: absolute;
				  top: 3px;
				}
				.digital_coupon_section{
					text-align:center;
				}
				.digital_coupon_section{
					text-align:center;
					margin-top: 10px;
					margin-bottom: 10px;
					font-weight: 540 !important
				  }

           .circular-card-deal-wrapperknife {
               font-weight: 700 !important;
               line-height: 1  !important;
               font-family: Oswald, sans-serif !important;
               text-transform: uppercase !important;
           	position: relative !important;
               bottom: 7 !important;
           }
           .circular-card-deal-wrapperknife{
               width:  8vw !important ; /* Minimum 50px, adjusts with screen, max 150px */
               height:  8vw  !important;
           }
           
           #format2.circular-card-deal-wrapperknife .price-unit-wrapper{top:0 !important;left: 0px !important;}
           #format2.circular-card-deal-wrapperknife .price-container{left: 45% !important;}
           .top-line {
             display: -webkit-box;
             display: -webkit-flex;
             display: -ms-flexbox;
             display: flex;
           }
           
           
           #format2.circular-card-deal-wrapperknife,
           #format1.circular-card-deal-wrapperknife,
           #format3.circular-card-deal-wrapperknife,
           #format4.circular-card-deal-wrapperknife,
           #format5.circular-card-deal-wrapperknife,
           #format7.circular-card-deal-wrapperknife,
           #format1.circular-card-deal-wrapperknife .price-container span #dollar,
           #format3.circular-card-deal-wrapperknife .price-container #dollar,
           #format4.circular-card-deal-wrapperknife .price-container #dollar,
           #format7.circular-card-deal-wrapperknife .price-container .dollar-amount,
           #format4.circular-card-deal-wrapperknife .price-container  .dollar-amount {
             font-size: 2vw 
           }
           .circular-card-deal-wrapperknife{
             font-size: 2vw 
           }
           .circular-card-deal-wrapperknife.largeDigit{
             font-size: 1.5vw 
             }
           #format5.circular-card-deal-wrapperknife.extraSmall .cents-amount {
             font-size: 2vw !important;
           }
           #format6.circular-card-deal-wrapperknife. .price-container .pricing-buy-get, .pricing-num-for {
               padding-right: 4px;
               padding-bottom: 4px;
           }
           #format6.circular-card-deal-wrapperknife. .price-container .pricing-buy-get, #format6.circular-card-deal-wrapperknife. .price-container .dollar-amount, #format6.circular-card-deal-wrapperknife. .price-container .cents-amount, #format6.circular-card-deal-wrapperknife. .price-container .third-amount {
               font-size: clamp(10px, 1vw, 30px) !important;
           }
           #format6.circular-card-deal-wrapperknife .price-container {
               line-height: 0.8 !important;
           }
           .circular-card-deal-wrapperknife#format3 .price-unit,
           .circular-card-deal-wrapperknife#format4 .price-unit {
             font-size: 30%;
           }
             #format5.circular-card-deal-wrapperknife .dollar-amount, #format5.circular-card-deal-wrapperknife .third-amount, #format5.circular-card-deal-wrapperknife .pricing-for {
             font-size: 60%;
           }
           #format1.circular-card-deal-wrapperknife .price-container .dollar-sign,
           #format1.circular-card-deal-wrapperknife .price-container .cent-sign,
           #format2.circular-card-deal-wrapperknife .price-container .cent-sign,
           #format3.circular-card-deal-wrapperknife .price-container .cent-sign,
           #format4.circular-card-deal-wrapperknife .price-container .cent-sign,
           #format2.circular-card-deal-wrapperknife .price-container .dollar-sign,
           #format3.circular-card-deal-wrapperknife .price-container .dollar-sign,
           #format7.circular-card-deal-wrapperknife .price-container .dollar-sign,
           #format7.circular-card-deal-wrapperknife .price-container .cent-sign,
           #format4.circular-card-deal-wrapperknife .price-container .dollar-sign {
             font-size: 60% !important;
             margin-right: 0px !important;  
           }
             circular-card-deal-wrapperknife .price-container .dollar-sign {
             font-size: 60% !important;
             margin-right: 0px !important;  
           }
           
           #format2.circular-card-deal-wrapperknife .price-container .cents-sign,#format2.circular-card-deal-wrapperknife .price-container .cents-amount,
           #format7.circular-card-deal-wrapperknife .price-container .cents-amount,
           #format7.circular-card-deal-wrapperknife .price-container .bottom-line {
             font-size: 60% !important;
           }
           
           
           
           #format6.circular-card-deal-wrapperknife .price-container .pricing-buy-get,
           #format6.circular-card-deal-wrapperknife .price-container .dollar-amount,
           #format6.circular-card-deal-wrapperknife .price-container .cents-amount,
           #format6.circular-card-deal-wrapperknife .price-container .third-amount {      
             font-size: clamp(10px, 1vw, 30px) !important;
           }
           #format6.circular-card-deal-wrapperknife .price-container .pricing-buy-get, .pricing-num-for {
             padding-right: 4px;
             padding-bottom: 4px;
           }
           .cent-sign,
           .bottom-line {
             font-size: 60% !important;
           }
           .circular-card-deal-wrapperknife .dollar-amount, .big-cents {
               line-height: 80% !important; 
           }
           #format5.circular-card-deal-wrapperknife .cents-amount {
             line-height: 77% !important;
           }
           #format5.circular-card-deal-wrapperknife .dollar-amount, .big-cents {
               line-height: 86% !important;
           }
           .top-line {
             display: -webkit-box;
             display: -webkit-flex;
             display: -ms-flexbox;
             display: flex;
           }
            .hot-sheet-container {
              max-width: 900px;
              margin: auto;
              font-family: 'Segoe UI', sans-serif;
              background-color: #fff;
              padding-left :1rem;
              padding-right :1rem;
              padding-top:0;
              padding-bottom:0;
              text-align: center;
            }
             
			h1 {
                font-size: 24px;
                margin: 0;
                font-weight: bold;
                color: #000;
              }

            .date-range {
              display: inline-block;
        	  background-color:${this.store_data[0]?.theme_base_color || 'rgb(139, 195, 74)'};
              color: #fff;
              padding: 0.3rem 0.7rem;
              border-radius: 20px;
              margin-top: 0.4rem;
              font-weight: 600;
              font-size: 0.95rem;
            }
			  
            .date-range span {
              padding: 0px 5px;
              color: #fff;
              font-weight: 500;
             }
			  								  .both-banner-image-home{
display:block !important;

}

.both-banner-image-home img{
 max-height: unset !important;
    max-width: 100% !important;
    width: 100% !important;
    object-fit: unset !important;
    height: 100% !important;
}
	
            			  			  		${this.title_position === 'below' ? `
			.grid-stack-item-content {
				padding-top: 40px !important;
				padding-bottom: 40px !important;
			}
			.product-title {
				top: 0 !important;
				bottom: 0 !important;
			}
			.product-title p {
			margin:0 !important;
			-webkit-line-clamp:3 !important;
			line-height:unset !important;

			}
			.grid-stack-item-content .pricelabel {
				bottom: 185px !important;
			}
					  .grid-stack-item-content.digital_coupon_div >.product-title{
			  				position: relative !important;
				bottom: 0px !important;
				top: 0px !important;
			    align-items:center !important;
				padding-left:0 !important;
		}
				.grid-stack-item-content.digital_coupon_div >.product-title p{
							margin:0 !important;
			line-height:unset !important;
			-webkit-line-clamp:2 !important;
			}
			.grid-stack-item-content:has(.hide_bar) .pricelabel {
				position: relative !important;
				bottom: 0px !important;
				top:auto !important;
				}

		` : ''}
		${this.headerViewOption === 'large' ? `
.dcp-logo {
    height: 130px !important;
  
}
	.only-banner-image-home {
    height:100% !important;
	
	width: 100% !important;
    display: unset !important;
    align-items: unset !important;
    justify-content: unset !important;
}
.only-banner-image-home img {
    // border-bottom:2px solid black !important;
  height: 100% !important;
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 auto;
	    max-height: unset !important;
		position:relative !important;
}


.both-banner-image-home{
display:block !important;

}

.both-banner-image-home img{
 max-height: unset !important;
    max-width: 100% !important;
    width: 100% !important;
    object-fit: unset !important;
    height: 100% !important;
}
.bothbannerlogo{
height: 130px !important;}

.onlylogo{
height:100% !important;
display: unset !important;
align-items: unset !important;
justify-content: unset !important;
}
.onlylogo img{

    max-height: unset !important;
    width: 100% !important;
    object-fit: unset !important;
    height: 100% !important;
}
` : ''}
              @media print { 
			      @page {
        size: Letter; /* Change to A4 if needed */
    }
		
		        @page{
					margin-left:1px !important;
					margin-right:14px !important;
					margin-top:30px !important;
					margin-bottom:0px !important ;
				   }

				@page :first{
					margin:1px !important;
					margin-right:14px !important;
					margin-bottom:0px !important;
					margin-top:0px !important;
					padding-bottom:0 !important;
				}

				body {
					-webkit-print-color-adjust: exact; /* Chrome, Safari */
					color-adjust: exact; /* Firefox */
				}
				
		         .button.ytp-large-play-button.ytp-button.ytp-large-play-button-red-bg{
		           display:none !important;
		         }
		
		         .grid-stack.simple_pro {
		           display: grid;
 			       grid-template-columns: repeat(4, 1fr);
			       gap: 0px !important; 
				   margin-top:10px ;
		         } 
				   .break-bef{
				   page-break-inside:avoid !important;
				   }
				 .grid-stack{
					background-color:white !important;
					margin-left:7px ;
				  }
				 .digital_coupon_section{
					text-align:center;
				}
				 .grid-stack.digital_coupon_section {
					display: grid;
					 grid-template-columns: repeat(3, 1fr);
					gap: 0px; 
					margin-top:35px ;
				  } 
	             .grid-stack-item-content { 
		           width: 100%;
	             } 

				 .banner-img-width{
	               height:auto !important;
				 }
				 
				 .pack-info-container {
					FONT-VARIANT: JIS04;
					position: relative !important;
					bottom: 65px !important;
					font-size: 14px !important;
					line-height:1 !important;
					left: 10%;  
					word-wrap: break-word;
					width: 80%;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
				   }
			      

		         .pricelabel {
			       position: relative !important;
				   bottom: 81px !important;
				   left: 2px !important;
			       width: 4vw !important;
	               height: 4vw !important;
			       font-size: 2.5vw !important;
		         }

		         .grid-stack-item-content { 
			       background-color: white; 
			       border: 1px solid #ccc; 
			       text-align: center; 
			       width:192px;
	               height:160px;
				   padding-top:3px !important;
				 padding-bottom:00px !important;
				  padding-left:0px !important
				  padding-right:0px !important;
				   position:relative !important;
				}
				.grid-stack-item-content.digital_coupon_div{ 
					background-color: white; 
					border: 1px solid #ccc; 
					position:relative !important;		
					text-align: center; 
				    width:355px !important;
					height:280px !important;
					padding:25px 0px  !important;
					overflow:hidden !important;
				 }
				.grid-stack-item-content > img {
					object-fit: fill !important;
					max-width: 100% !important;
					height: 100% !important;
				   //  cursor: pointer;
			   height:125px !important;
			   width:100% !important;
			   padding-top:40px;
					}

					.grid-stack-item-content >.fill_video >video{
						object-fit: fill !important;
						max-width: 100% !important;
						height: 100% !important;
					   //  cursor: pointer;
				   height:125px !important;
				   width:100% !important;
				   padding-top:40px;
						}
				.grid-stack-item-content.digital_coupon_div > img {
				object-fit: fill !important;
				max-width: 100% !important;
				height: 100% !important;
				}
			    .grid-stack-item-content.digital_coupon_div  >.fill_video >video{
				object-fit: fill !important;
				max-width: 100% !important;
				height: 100% !important;
			   //  cursor: pointer;
				}
			     .packDetailsName{
			     color: black !important;
			     font-size:14.5px !important;
			     display: -webkit-box;
			     -webkit-line-clamp: 1;
			     -webkit-box-orient: vertical;
			     overflow: hidden;
			     line-height:1.1 !important;
			     margin-bottom:0 !important;
			    }
  
			// .fb-video >span >iframe{
			// 	   width:200px !important;
			// 	   height:150px !important;
			// 	   }
		         .product-title{
			       background-size: cover;
			    
			       top: -17px !important;
			       color: #000 !important;
			       font-weight: 2 !important;
	               height: 64px !important;
				   z-index: 9999 !important;
				position:absolute!important;
				   color: black !important;
			       color: #000;
			       padding-left:4px !important;
			       padding-right: 4px !important;
			       left:0 !important;
				   right:0 !important;
			       background-color:transparent !important;
				   overflow:visible !important;
				   	display:flex !important;
					flex-direction:column !important;
					justify-content:center !important;
					align-items:unset !important;
		         }

		         .product-title p{
			      font-size:12px !important;
                  line-height: 1.1 !important;
			       -webkit-line-clamp:3 !important;
				   font-weight:800 !important;
				   padding-right:7px !important;
		         }

			   .packTitleProName{
                 font-size: 9.5px !important;
				font-family:Roboto !important;
				font-weight:normal !important;
                }
				 .digital_coupon_section{
				 break-inside:avoid !important;
				 }
				 .digital_coupon_section >.digital_title{
					text-align:center;
					margin-top: 40px !important;
					margin-bottom: 30px;
					font-size:17px !important;
				  }
			  
				//  .grid-stack-item-content.digital_coupon_div { 
				// 	width:355px !important;
				// 	height:320px !important;
				//  }

				 .grid-stack-item-content.digital_coupon_div >.product-title{
					padding-left:30px !important;
					padding-right:0 !important;
					top: -10px !important;
					height:40px !important;
					width:88% !important;
					display:flex !important;
					flex-direction:column !important;
					justify-content:center !important;
				  }
 
				  .grid-stack-item-content.digital_coupon_div >.product-title p{
					font-size:15px !important;
					display: -webkit-box;
                    -webkit-box-orient: vertical;
                     overflow: hidden;
					 margin-left:1px !important;
					-webkit-line-clamp:2 !important;
				   }
				   .grid-stack-item-content.digital_coupon_div >.product-title >.packDetailsName{
				     line-height:1.1 !important;
					 font-size:18px !important;
					   display: -webkit-box;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
					-webkit-line-clamp:2 !important;

					}
				  .grid-stack-item-content.digital_coupon_div >.pack-info-container {
					bottom: 18px !important;
					font-size: 15px !important;
				   }
				   .price_link_data{
					top: 5px !important;
					left: 2px !important;
				}

		         .extraSmall {
		           width: 4vw;
	               height: 4vw;
			       font-size: 2.5vw;
		         }

								
				hr{
				    margin-bottom:3px !important;
					margin-top:0.5px !important;
    margin-left: 0px !important;   /* ← auto center karega */
    margin-right: -11px !important;  /* ← auto center karega */
    width: 99% !important;
				 }
				 
	             .price-goods{
	               margin-top: 0px;
                   margin-left: 15px;
		           margin-right:0px;
		           display: flex;
		           justify-content: flex-end;	
	               background-color:${this.store_data[0]?.theme_base_color || 'rgb(139, 195, 74)'};
		           align-items: flex-end; /* Align items at the bottom */

	             }	

	             .price-goods span {
		          padding: 0px 5px;
		          color: #fff;
		          font-weight: 500;
	             }

			   .grid-stack-item-content > img.hide_bar {
				object-fit: fill !important;
				max-width: 100% !important;
				height: 100% !important;
				position:absolute !important;
				top:-40px !important;
				left:0px !important;
				}
			   .grid-stack-item-content >.fill_video >video.hide_bar{
				object-fit: fill !important;
				max-width: 100% !important;
				height: 100% !important;
			    position:absolute !important;
				top:-40px !important;
				left:0px !important;
				}
			   	.grid-stack-item-content >.iframe >iframe.hide_bar{
				object-fit: fill !important;
				max-width: 90%!important;
				height: 60% !important;
			    position:absolute !important;
				top:38px !important;
				left:10px !important;
		        background-color:transparent !important;;
				}

	             .grid-stack-item-content:has(.hide_bar) {
		           padding-top: 3px !important;
	             }
				 .offerLabel{
					width: auto!important;
	                height:auto !important;
					top:40px !important;
					display:unset !important;
					right:0px !important;
					left:0px !important;
			     }
			     .offerLabel span {     
			    	display: -webkit-box;
			       -webkit-line-clamp: 1;
			       -webkit-box-orient: vertical;
			    	overflow: hidden;
			    	word-wrap: normal;
					  font-size: 12px !important;
			    	font-size: 25px !important;
			    	line-height: -1px !important;
			    	right:0 !important;
					  padding-top:7px !important;
					  width:55% !important;
					  left:5px !important;
					  font-weight:200 !important;
				   }

			     .offerLabel img{
			       width:70% !important;
			     }
	
                 .offerLabel span{
                    font-size:12px !important;
                 }
				 .wrapper-main{
					display:none !important;
				 }
			.circular-card-deal {
		       width: 7.5vw !important;
		       height: 7.5vw !important;
		       font-size: 4vw !important;
             }

            .circular-card-deal-wrapperknife {
                font-weight: 700 !important;
                line-height: 1  !important;
                font-family: Oswald, sans-serif !important;
                text-transform: uppercase !important;
            	position: relative !important;
                bottom: 23 !important;
            }
            .circular-card-deal-wrapperknife{
                width:  12vw !important ; /* Minimum 50px, adjusts with screen, max 150px */
                height:  12vw  !important;
            }
            
            #format2.circular-card-deal-wrapperknife .price-unit-wrapper{top:0 !important;left: 0px !important;}
            #format2.circular-card-deal-wrapperknife .price-container{left: 45% !important;}
            #format2.circular-card-deal-wrapperknife,
            #format1.circular-card-deal-wrapperknife,
            #format3.circular-card-deal-wrapperknife,
            #format4.circular-card-deal-wrapperknife,
            #format5.circular-card-deal-wrapperknife,
            #format7.circular-card-deal-wrapperknife,
            #format1.circular-card-deal-wrapperknife .price-container span #dollar,
            #format3.circular-card-deal-wrapperknife .price-container #dollar,
            #format4.circular-card-deal-wrapperknife .price-container #dollar,
            #format7.circular-card-deal-wrapperknife .price-container .dollar-amount,
            #format4.circular-card-deal-wrapperknife .price-container  .dollar-amount {
              font-size: 2.5vw 
            }
              .circular-card-deal-wrapperknife{
              font-size: 2.5vw 
            }
            .circular-card-deal-wrapperknife.largeDigit{
              font-size: 2vw 
            }
            #format5.circular-card-deal-wrapperknife .cents-amount {
              font-size: 2.5vw !important;
            }
            #format6.circular-card-deal-wrapperknife. .price-container .pricing-buy-get, .pricing-num-for {
                padding-right: 4px;
                padding-bottom: 4px;
            }
            #format6.circular-card-deal-wrapperknife. .price-container .pricing-buy-get, #format6.circular-card-deal-wrapperknife. .price-container .dollar-amount, #format6.circular-card-deal-wrapperknife. .price-container .cents-amount, #format6.circular-card-deal-wrapperknife. .price-container .third-amount {
                font-size: clamp(10px, 1vw, 30px) !important;
            }
            #format6.circular-card-deal-wrapperknife .price-container {
                line-height: 0.8 !important;
            }
            .circular-card-deal-wrapperknife#format3 .price-unit,
            .circular-card-deal-wrapperknife#format4 .price-unit {
              font-size: 30%;
            }
            #format1.circular-card-deal-wrapperknife .price-container .dollar-sign,
            #format1.circular-card-deal-wrapperknife .price-container .cent-sign,
            #format2.circular-card-deal-wrapperknife .price-container .cent-sign,
            #format3.circular-card-deal-wrapperknife .price-container .cent-sign,
            #format4.circular-card-deal-wrapperknife .price-container .cent-sign,
            #format2.circular-card-deal-wrapperknife .price-container .dollar-sign,
            #format3.circular-card-deal-wrapperknife .price-container .dollar-sign,
            #format7.circular-card-deal-wrapperknife .price-container .dollar-sign,
            #format7.circular-card-deal-wrapperknife .price-container .cent-sign,
            #format4.circular-card-deal-wrapperknife .price-container .dollar-sign {
              font-size: 60% !important;
              margin-right: 0px !important;  
            }
              circular-card-deal-wrapperknife .price-container .dollar-sign {
              font-size: 60% !important;
              margin-right: 0px !important;  
            }
            
            #format2.circular-card-deal-wrapperknife .price-container .cents-sign,#format2.circular-card-deal-wrapperknife .price-container .cents-amount,
            #format7.circular-card-deal-wrapperknife .price-container .cents-amount,
            #format7.circular-card-deal-wrapperknife .price-container .bottom-line {
              font-size: 60% !important;
            }
            
            #format5.circular-card-deal-wrapperknife .dollar-amount, #format5.circular-card-deal-wrapperknife .third-amount, #format5.circular-card-deal-wrapperknife .pricing-for {
              font-size: 60%;
            }
            #format6.circular-card-deal-wrapperknife .price-container .pricing-buy-get,
            #format6.circular-card-deal-wrapperknife .price-container .dollar-amount,
            #format6.circular-card-deal-wrapperknife .price-container .cents-amount,
            #format6.circular-card-deal-wrapperknife .price-container .third-amount {      
              font-size: clamp(10px, 1vw, 30px) !important;
            }
            #format6.circular-card-deal-wrapperknife .price-container .pricing-buy-get, .pricing-num-for {
              padding-right: 4px;
              padding-bottom: 4px;
            }
            .cent-sign,
            .bottom-line {
              font-size: 60% !important;
            } 
            
            .circular-card-deal-wrapperknife .dollar-amount{
                line-height: 88% !important; 
            }
            #format5.circular-card-deal-wrapperknife .cents-amount {
              line-height: 88% !important;
            }
            #format5.circular-card-deal-wrapperknife  #cent.cents-amount {
              line-height: 80% !important;
            }
            #format5.circular-card-deal-wrapperknife .dollar-amount{
                line-height: 99% !important;
            }
            #format5.circular-card-deal-wrapperknife .dollar-amount, #format5.circular-card-deal-wrapperknife .pricing-num-for, #format6.circular-card-deal-wrapperknife .pricing-num-to-cart, #format6.circular-card-deal-wrapperknife .pricing-num-for {
                padding-right: 2px;
                padding-bottom: 1px;
            }
            #format7.circular-card-deal-wrapperknife .dollar-amount {
              line-height: 86% !important;
            }
            #format3.circular-card-deal-wrapperknife .price-container .cent-sign, #format4.circular-card-deal-wrapperknife .price-container .cent-sign {
                font-size: 60% !important;
                margin-right: 0px !important;
                margin-bottom: -2;
            }
			.hot-sheet-container {
             max-width: 900px;
             margin: auto;
             background-color: #fff;
             padding-left :1rem;
             padding-right :1rem;
             padding-top:0;
             padding-bottom:0;
             text-align: center;
           }
           
           h1 {
             font-size: 24px;
             margin: 0;
             font-weight: bold;
             color: #000;
           }
         
           .date-range {
             display: inline-block;
         	 background-color:${this.store_data[0]?.theme_base_color || 'rgb(139, 195, 74)'};
             color: #fff;
             padding: 0.3rem 0.7rem;
             border-radius: 20px;
             margin-top: 0.5rem;
             font-weight: 600;
             font-size: 0.95rem;
           }
		   .date-range span {
		     padding: 0px 5px;
		     color: #fff;
		     font-weight: 500;
	        }
		}
		${this.title_position === 'below' ? `
		@media print {
			.grid-stack-item-content {
				padding-top: 3px !important;
				padding-bottom: 0px !important;
				position: relative !important;
			}
				.grid-stack-item-content > img {
				padding-top: 0 !important;
				padding-bottom: 40px !important;
				position: relative !important;
				}
				.grid-stack-item-content >.fill_video >video{
								padding-top: 0 !important;
				padding-bottom: 40px !important;
				}
			.product-title {
				position: relative !important;
				bottom: 0px !important;
				top: -56px !important;
			    align-items:center !important;
			}
							.product-title p {
			margin:0 !important;
			-webkit-line-clamp:3 !important;
			line-height:unset !important;
			}
            .pricelabel {
				position: relative !important;
				bottom: -64px !important;
				top:auto !important;
			}
							.grid-stack-item-content:has(.hide_bar) {
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              }
								.grid-stack-item-content > img.hide_bar {
padding-top: 0 !important;
				padding-bottom: 0px !important;
				position: relative !important;
				top:0 !important;
				}
			   .grid-stack-item-content >.fill_video >video.hide_bar{
				padding-top: 0 !important;
				padding-bottom: 0px !important;
				position: relative !important;
				top:0px !important;
				}
			   	.grid-stack-item-content >.iframe >iframe.hide_bar{
				padding-top: 0 !important;
				padding-bottom: 0px !important;
				position: relative !important;
				top:38px !important;
		}

		
			  .grid-stack-item-content.digital_coupon_div >.product-title{
			  				position: relative !important;
				bottom: 0px !important;
				top: -56px !important;
			    align-items:center !important;
		}
				.grid-stack-item-content.digital_coupon_div >.product-title p{
							margin:0 !important;
			line-height:unset !important;
			}
.grid-stack-item-content:has(.hide_bar) .pricelabel {
				position: relative !important;
				bottom: 114px !important;
				// top:auto !important;
				}
		}
		` : ''}
				${this.headerViewOption === 'large' ? `
@media print {
					.dcp-logo {
    height: 130px !important;
  
}
	.only-banner-image-home {
    height:100% !important;
	
	width: 100% !important;
    display: unset !important;
    align-items: unset !important;
    justify-content: unset !important;
}
.only-banner-image-home img {
    // border-bottom:2px solid black !important;
  height: 100% !important;
    width: 100% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 auto;
	    max-height: unset !important;
		position:relative !important;
}


.both-banner-image-home{
display:block !important;

}

.both-banner-image-home img{
 max-height: unset !important;
    max-width: 100% !important;
    width: 100% !important;
    object-fit: unset !important;
    height: 100% !important;
}
.bothbannerlogo{
height: 130px !important;}

.onlylogo{
height:100% !important;
display: unset !important;
align-items: unset !important;
justify-content: unset !important;
}
.onlylogo img{

    max-height: unset !important;
    width: 100% !important;
    object-fit: unset !important;
    height: 100% !important;
}
				}
` : ''}
            </style>
             </head>
            <body  onload="window.print();" style='font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";'>
	        <div class="break-bef">
			<div class="dcp-logo">${header}</div>
				  <hr>
				  <div class="hot-sheet-container">
                   ${shouldShowSection ? `<h1>${PrintBannerTitleDiv}</h1>` : ''}                   
                   ${footer && footer?.trim() !== "" ? `<div class="date-range">${footer}</div>` : ""}
	               </div>
				    <div class="grid-stack simple_pro"> ${gridContent} </div>
					<div class="digital_coupon_section" ${DIGITalCoupon ? '' : 'style="display: none;"'}>
					<div class="digital_title"><h2> DIGITAL COUPON SECTION</h2> </div>
					<div class="grid-stack digital_coupon_1">${DIGITalCoupon}</div> </div>
					</div>
					</div>
					<script>
                window.onafterprint = function() {
                    window.close();
                };
					(function() {
						function applyStyles() {
							const title_position = "${this.title_position}";
							if (title_position === 'below') {
								const elements = document.querySelectorAll('.grid-stack-item-content');
								elements.forEach((el) => {
									// Apply padding-top value to padding-bottom instead
									el.style.setProperty('padding-bottom', '40px');
									el.style.setProperty('padding-top', '40px');
									// Apply styling to product-title elements and get height
									const productTitles = el.querySelectorAll('.product-title');
									let productTitleHeight = 0;
									productTitles.forEach((productTitle) => {
										productTitle.style.setProperty('top', '0');
										productTitle.style.setProperty('bottom', '0');
									});
									// Get product-title height (use the first one if multiple exist)
									// Apply pricelabel bottom with product-title height added
									const priceLabel = el.querySelectorAll('.pricelabel');
									priceLabel.forEach((plabel) => {
										const bottomValue = 185;
										plabel.style.setProperty('bottom', bottomValue + 'px');
									});
								});
							}
						}
						// Try to apply styles immediately
						applyStyles();
						// Also apply after DOM is ready
						if (document.readyState === 'loading') {
							document.addEventListener('DOMContentLoaded', applyStyles);
						} else {
							setTimeout(applyStyles, 0);
						}
						// Also apply on window load
						window.addEventListener('load', function() {
							applyStyles();
						});
					})();
					</script>
              </body>
        </html>` );
		printWindow.document.close();
	}

	async printRestaurantMenu() {
		// Log analytics
		this.analytics.logEvent('@Restaurant_print_click_count', {
			store_name: this.store_data[0]?.company_name,
			message: 'Restaurant Menu Print Button Clicked.'
		});
		
		if (this.store_data[0]?.googleMeasurementId) {
			(window as any).gtag('event', "@Restaurant_print_click_count", {
				send_to: this.store_data[0]?.googleMeasurementId,
				store_name: this.store_data[0]?.company_name,
				message: 'Restaurant Menu Print Button Clicked.'
			});
		}

		// Find the restaurant iframe
		let iframe = document.querySelector('iframe[src*="customize_menu.html"]') as HTMLIFrameElement;
		if (!iframe) {
			iframe = document.querySelector('iframe') as HTMLIFrameElement;
		}
		
		if (!iframe) {
			alert('Restaurant menu not found. Please ensure the menu is loaded.');
			return;
		}

		// Create print window
		const printWindow = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
		if (!printWindow) {
			alert('Please allow popups to print the menu.');
			return;
		}

		try {
			// Wait for iframe to be ready
			await new Promise((resolve, reject) => {
				const timeout = setTimeout(() => reject(new Error('Iframe load timeout')), 5000);
				
				if (iframe.contentDocument?.readyState === 'complete') {
					clearTimeout(timeout);
					resolve(true);
				} else {
					iframe.onload = () => {
						clearTimeout(timeout);
						resolve(true);
					};
					iframe.onerror = () => {
						clearTimeout(timeout);
						reject(new Error('Iframe failed to load'));
					};
				}
			});

			// Get iframe content
			const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
			if (!iframeDoc) {
				throw new Error('Cannot access iframe content');
			}

			const iframeBody = iframeDoc.body;
			const iframeHead = iframeDoc.head;

			// Extract styles from iframe
			const styles = Array.from(iframeHead.querySelectorAll('style, link[rel="stylesheet"]'))
				.map(el => el.outerHTML)
				.join('\n');

			// Get the main container content
			let mainContainer = iframeBody.querySelector('.container') || 
							   iframeBody.querySelector('.menu-container') ||
							   iframeBody.querySelector('.restaurant-menu') ||
							   iframeBody.querySelector('main') ||
							   iframeBody;
			
			const menuContent = mainContainer.innerHTML;

			// Extract theme colors from iframe
			const menuPreview = iframeBody.querySelector('#menuPreview');
			let primaryColor = this.store_data[0]?.theme_base_color || '#ff6b35';
			let currentFont = 'Arial, sans-serif';

			if (menuPreview) {
				const computedStyle = iframeDoc.defaultView?.getComputedStyle(menuPreview);
				primaryColor = computedStyle?.getPropertyValue('--primary-color')?.trim() || primaryColor;
				
				// Detect current font
				if (menuPreview.classList.contains('font-elegant')) {
					currentFont = 'Georgia, serif';
				} else if (menuPreview.classList.contains('font-modern')) {
					currentFont = 'Arial, sans-serif';
				} else if (menuPreview.classList.contains('font-casual')) {
					currentFont = 'Comic Sans MS, cursive';
				} else if (menuPreview.classList.contains('font-professional')) {
					currentFont = 'Times New Roman, serif';
				}
			}

			// Create print content that matches screen display exactly
			const printContent = `
				<!DOCTYPE html>
				<html lang="en">
				<head>
					<meta charset="UTF-8">
					<meta name="viewport" content="width=device-width, initial-scale=1.0">
					<title>Restaurant Menu - Print</title>
					${styles}
<style>
.menu-grid.cols-1 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.cols-2 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.cols-3 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-left-wide {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-right-wide {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-alternate-wide {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-1-2-1 {
    grid-template-columns: 1fr 1fr !important;
}
	 .menu-grid.grid-layout-1-2-1 > .menu-section:nth-child(3n+1){
            grid-column: auto !important; 
	 }
        .menu-grid.grid-layout-1-2-1 > .menu-section:nth-child(3n+2){
            grid-column: auto !important; 
		}
        .menu-grid.grid-layout-1-2-1 > .menu-section:nth-child(3n) { 
            grid-column: auto !important; 
        }
.menu-grid.grid-layout-2-1-2 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-3-1-3 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-1-3-1 {
    grid-template-columns: 1fr 1fr !important;
}
	.menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n+1) { grid-column:auto !important; }
        .menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n+2) { grid-column: auto !important; }
        .menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n+3) { grid-column: auto !important; }
        .menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n+4) { grid-column: auto !important; }
        .menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n) { grid-column:auto !important; }
.menu-grid.grid-layout-2-1-2 > .menu-section:nth-child(3n+1),
.menu-grid.grid-layout-2-1-2 > .menu-section:nth-child(3n+2) {
  grid-column: auto !important; 
}

.menu-grid.grid-layout-2-1-2 > .menu-section:nth-child(3n) {
  grid-column: auto !important; 
		}
        .menu-grid.grid-layout-3-1-3 > .menu-section:nth-child(4n+1) { grid-column: auto !important;  }
        .menu-grid.grid-layout-3-1-3 > .menu-section:nth-child(4n+2) { grid-column: auto !important;  }
        .menu-grid.grid-layout-3-1-3 > .menu-section:nth-child(4n+3) { grid-column: auto !important;  }
        .menu-grid.grid-layout-3-1-3 > .menu-section:nth-child(4n) { grid-column: auto !important;  }

/* ===========================================
   TEMPLATE STYLES FOR PRINT
   =========================================== */

/* Classic Template - Traditional restaurant style */
.template-classic .menu-header {
    background: linear-gradient(135deg, var(--primary-color), var(--secondary-color)) !important;
    border-radius: 0 !important;
}

.template-classic .menu-item {
    border-left: 5px solid var(--accent-color) !important;
    border-radius: 8px !important;
}

.template-classic .section-title {
    text-transform: uppercase !important;
    letter-spacing: 2px !important;
    border-bottom: 3px solid var(--accent-color) !important;
}

/* Modern Template - Contemporary design */
.template-modern .menu-header {
    background: var(--primary-color) !important;
    clip-path: polygon(0 0, 100% 0, 100% 85%, 0% 100%) !important;
    padding-bottom: 70px !important;
}

.template-modern .menu-item {
    border-radius: 15px !important;
    border: none !important;
    box-shadow: 0 6px 25px rgba(0,0,0,0.1) !important;
}

.template-modern .section-title {
    background: linear-gradient(90deg, var(--primary-color), var(--secondary-color)) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    background-clip: text !important;
    border: none !important;
    font-weight: 800 !important;
}

.template-modern .item-image {
    border-radius: 15px !important;
}

/* Elegant Template - Sophisticated fine dining */
.template-elegant .menu-header {
    background: var(--primary-color) !important;
    position: relative !important;
    overflow: hidden !important;
}

// .template-elegant .menu-header::before {
//     content: '' !important;
//     position: absolute !important;
//     top: 0 !important;
//     left: 0 !important;
//     right: 0 !important;
//     bottom: 0 !important;
//     background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" patternUnits="userSpaceOnUse" x="0" y="0" width="100" height="100"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>') repeat !important;
//     opacity: 0.3 !important;
// }

.template-elegant .section-title {
    position: relative !important;
    text-align: center !important;
    font-family: 'Georgia', serif !important;
    font-style: italic !important;
}

.template-elegant .section-title::before {
    content: '✦' !important;
    position: absolute !important;
    left: -20px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    color: var(--accent-color) !important;
    font-size: 1.5rem !important;
}

.template-elegant .section-title::after {
    content: '✦' !important;
    position: absolute !important;
    right: -20px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    color: var(--accent-color) !important;
    font-size: 1.5rem !important;
}

.template-elegant .menu-item {
    border: 2px solid var(--accent-color) !important;
    border-radius: 0 !important;
    background: linear-gradient(145deg, #ffffff, #fafafa) !important;
}

/* Casual Template - Fun and relaxed */
.template-casual .menu-header {
    background: var(--primary-color) !important;
    transform: rotate(-1deg) !important;
    margin: 20px !important;
    border-radius: 20px !important;
    box-shadow: 0 10px 30px rgba(0,0,0,0.2) !important;
}

.template-casual .menu-content {
    transform: rotate(1deg) !important;
    margin: 20px !important;
}

.template-casual .menu-item {
    transform: rotate(-0.5deg) !important;
    margin: 15px 5px !important;
    border-radius: 20px !important;
    box-shadow: 0 6px 20px rgba(0,0,0,0.15) !important;
    background: #fff !important;
}

.template-casual .menu-item:nth-child(even) {
    transform: rotate(0.5deg) !important;
}

.template-casual .section-title {
    font-family: 'Comic Sans MS', cursive, sans-serif !important;
    color: var(--primary-color) !important;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.1) !important;
    border: none !important;
    background: var(--accent-color) !important;
    color: white !important;
    padding: 15px 25px !important;
    border-radius: 30px !important;
    display: inline-block !important;
    transform: rotate(-2deg) !important;
}

/* Fine Dining Template - Upscale restaurant */
.template-fine-dining .menu-header {
    background: linear-gradient(45deg, var(--primary-color), var(--secondary-color)) !important;
    color: var(--header-text-color, #fff) !important;
    position: relative !important;
}

// .template-fine-dining .menu-header::after {
//     content: '' !important;
//     position: absolute !important;
//     bottom: -15px !important;
//     left: 50% !important;
//     transform: translateX(-50%) !important;
//     width: 0 !important;
//     height: 0 !important;
//     border-left: 25px solid transparent !important;
//     border-right: 25px solid transparent !important;
//     border-top: 15px solid #333 !important;
// }

.template-fine-dining .section-title {
    font-family: 'Playfair Display', serif !important;
    font-weight: 400 !important;
    font-size: 2.5rem !important;
    text-align: center !important;
    color: #333 !important;
    border: none !important;
    margin-bottom: 40px !important;
    position: relative !important;
}

// .template-fine-dining .section-title::after {
//     content: '' !important;
//     position: absolute !important;
//     bottom: -15px !important;
//     left: 50% !important;
//     transform: translateX(-50%) !important;
//     width: 80px !important;
//     height: 3px !important;
//     background: var(--accent-color) !important;
// }

.template-fine-dining .menu-item {
    border: none !important;
    border-bottom: 2px solid #eee !important;
    border-radius: 0 !important;
    padding: 25px 0 !important;
    background: transparent !important;
    box-shadow: none !important;
}

.template-fine-dining .item-name {
    font-family: 'Playfair Display', serif !important;
    font-size: 1.5rem !important;
}

.template-fine-dining .item-price {
    font-family: 'Playfair Display', serif !important;
    font-size: 1.4rem !important;
}

/* Cafe Template - Cozy coffee shop style */
.template-cafe .menu-header {
    background: linear-gradient(135deg, ${primaryColor}, var(--secondary-color)) !important;
    border-radius: 0 0 50% 50% / 0 0 30px 30px !important;
}

.template-cafe .section-title {
    background: ${primaryColor} !important;
    color: white !important;
    padding: 6px 15px !important;
    border-radius: 25px !important;
    display: inline-block !important;
    font-size: 1.6rem !important;
    margin-bottom: 25px !important;
    border: none !important;
}

.template-cafe .menu-item {
    background: #f9f9f9 !important;
    border: 3px dashed var(--accent-color) !important;
    border-radius: 15px !important;
    margin-bottom: 20px !important;
}

.template-cafe .item-image {
    border: 4px solid var(--accent-color) !important;
    border-radius: 50% !important;
}

/* Minimalist Template - Clean and simple */
.template-minimalist .menu-header {
    background: var(--background-color, #fff) !important;
    color: var(--primary-color, #333) !important;
    border-bottom: 2px solid var(--accent-color, #eee) !important;
}

.template-minimalist .menu-content {
    background: #fff !important;
}

.template-minimalist .section-title {
    font-weight: 300 !important;
    font-size: 2rem !important;
    color: var(--primary-color, #333) !important;
    border: none !important;
    border-bottom: 2px solid var(--accent-color, #eee) !important;
    padding-bottom: 15px !important;
}

.template-minimalist .menu-item {
    background: transparent !important;
    border: none !important;
    border-bottom: 2px solid var(--accent-color, #f5f5f5) !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 20px 0 !important;
}

.template-minimalist .item-image {
    border: none !important;
    border-radius: 0 !important;
}

/* Bold Template - Eye-catching design */
.template-bold .menu-header {
    background: var(--primary-color) !important;
    transform: skew(-2deg) !important;
    margin: 0 -20px !important;
    padding: 50px 60px !important;
}

.template-bold .menu-content {
    background: var(--background-color) !important;
}

.template-bold .section-title {
    background: var(--primary-color) !important;
    color: white !important;
    padding: 20px 30px !important;
    margin: 0 -50px 40px -50px !important;
    transform: skew(2deg) !important;
    font-weight: 900 !important;
    font-size: 2.5rem !important;
    text-transform: uppercase !important;
    letter-spacing: 3px !important;
    border: none !important;
}

.template-bold .menu-item {
    background: white !important;
    border: 4px solid var(--accent-color) !important;
    border-radius: 0 !important;
    box-shadow: 8px 8px 0 var(--primary-color) !important;
    margin-bottom: 25px !important;
}

.template-bold .item-name {
    font-weight: 900 !important;
    text-transform: uppercase !important;
}

.template-bold .item-price {
    background: var(--accent-color) !important;
    color: white !important;
    padding: 8px 15px !important;
    border-radius: 20px !important;
    font-weight: 900 !important;
}

/* Professional Template - Clean business style */
.template-professional .menu-header {
    background: var(--primary-color) !important;
    border-bottom: 3px solid var(--accent-color) !important;
}

.template-professional .section-title {
    font-size: 1.4rem !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
    border-bottom: 2px solid var(--accent-color) !important;
    padding-bottom: 8px !important;
    margin-bottom: 15px !important;
}

.template-professional .menu-item {
    border-left: 3px solid var(--accent-color) !important;
    border-radius: 0 !important;
    background: white !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
}

/* Font Style Options */
.font-serif {
    font-family: 'Times New Roman', 'Georgia', serif !important;
}

.font-sans-serif {
    font-family: 'Arial', 'Helvetica', sans-serif !important;
}

.font-modern {
    font-family: 'Segoe UI', 'Roboto', sans-serif !important;
}

.font-elegant {
    font-family: 'Playfair Display', 'Georgia', serif !important;
}

.font-casual {
    font-family: 'Comic Sans MS', 'Trebuchet MS', sans-serif !important;
}

.font-monospace {
    font-family: 'Courier New', 'Monaco', monospace !important;
}

.font-handwriting {
    font-family: 'Brush Script MT', 'Lucida Handwriting', cursive !important;
}

.font-condensed {
    font-family: 'Arial Narrow', 'Helvetica Condensed', sans-serif !important;
}

@media print {
  /* --- Global print color control --- */
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
    box-sizing: border-box !important;
    line-height: 1.3 !important;
  }

  /* --- Page setup --- */
  @page {
    size: Letter !important;
    margin: 0.3in !important;
    margin-top: 0.2in !important;
    margin-bottom: 0.2in !important;
  }

  /* --- Body --- */
  body {
    background: white !important;
    font-size: 12px !important;
    font-family: ${currentFont} !important;
    margin: 0 !important;
    padding: 0 !important;
    position: relative !important;
  }

  /* --- Hide non-printable elements --- */
  .sidebar, .preview-header, .action-buttons, .loading, .spinner, 
  .btn-action, .iframe-header, .search-section, .search-container,
  .search-input, .search-filters, .filter-buttons, .search-results,
  .no-print, .print-hide, .controls, .toolbar, .menu-controls,
  button, .btn, input, select, textarea, .form-control,
  .dropdown, .dropdown-menu, .modal, .popup, .overlay {
    display: none !important;
  }

  /* --- Core layout containers --- */
  .main-content, .preview-content, .menu-preview, .container {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    background: white !important;
    position: relative !important;
  }

  /* --- Header --- */
  .menu-header {
    padding: 15px 10px !important;
    margin: 0 !important;
    text-align: center !important;
    background: ${primaryColor} !important;
    color: white !important;
    font-family: ${currentFont} !important;
    border-radius: 1px !important;
    page-break-after: avoid !important;
	height:150px !important;
  }
.menu-preview {
    page-break-before: avoid !important;

}
  /* Template-specific header overrides for print */
  .template-elegant .menu-header {
    background: ${primaryColor} !important;
    // position: relative !important;
    overflow: hidden !important;
    padding: 20px 15px !important;
  }

  .template-fine-dining .menu-header {
    background: linear-gradient(45deg, ${primaryColor}, var(--secondary-color)) !important;
    color: white !important;
    // position: relative !important;
    padding: 25px 20px !important;
  }

  .template-cafe .menu-header {
    background: linear-gradient(135deg, ${primaryColor}, var(--secondary-color)) !important;
    border-radius: 0 0 50% 50% / 0 0 30px 30px !important;
    padding: 20px 15px !important;
  }

  .template-minimalist .menu-header {
    background: white !important;
    color: ${primaryColor} !important;
    border-bottom: 2px solid #eee !important;
    padding: 20px 15px !important;
  }

  .template-bold .menu-header {
    background: ${primaryColor} !important;
    transform: skew(-2deg) !important;
    margin: 0 -20px !important;
    padding: 40px 50px !important;
  }

  .template-professional .menu-header {
    background: ${primaryColor} !important;
    border-bottom: 3px solid var(--accent-color) !important;
    padding: 20px 15px !important;
  }

  .restaurant-name {
    font-size: 24px !important;
    font-weight: 700 !important;
    margin-bottom: 6px !important;
    color: white !important;
  }

  .restaurant-tagline {
    font-size: 14px !important;
    margin-bottom: 8px !important;
    color: white !important;
    font-style: italic !important;
  }

  .restaurant-info {
    font-size: 11px !important;
    color: white !important;
  }

  /* --- Meal Periods --- */
  .meal-period-section {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    margin-bottom: 8px !important;
    orphans: 3 !important;
    widows: 3 !important;
  }

  /* --- Menu Items Layout --- */
  .menu-item {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    margin-bottom: 6px !important;
    padding: 4px 0 !important;
    display: flex !important;
    align-items: flex-start !important;
    gap: 8px !important;
  }

  .item-image {
    width: 40px !important;
    height: 40px !important;
    object-fit: cover !important;
    border-radius: 4px !important;
    flex-shrink: 0 !important;
  }

  .item-details {
    flex: 1 !important;
    min-width: 0 !important;
  }

  .item-name {
    font-size: 14px !important;
    font-weight: 600 !important;
    margin-bottom: 2px !important;
    color: #333 !important;
  }

  .item-description {
    font-size: 12px !important;
    color: #666 !important;
    margin-bottom: 2px !important;
    line-height: 1.3 !important;
  }

  .item-price {
    font-size: 14px !important;
    font-weight: 700 !important;
    color: ${primaryColor} !important;
    text-align: right !important;
    flex-shrink: 0 !important;
  }

  /* --- Section Headers --- */
  .section-title {
    font-size: 18px !important;
    font-weight: 700 !important;
    color: ${primaryColor} !important;
    margin: 12px 0 8px 0 !important;
    padding-bottom: 4px !important;
    border-bottom: 2px solid ${primaryColor} !important;
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  /* Template-specific section title overrides for print */
  .template-elegant .section-title {
    font-size: 20px !important;
    font-family: 'Georgia', serif !important;
    font-style: italic !important;
    text-align: center !important;
    border-bottom: none !important;
    margin: 15px 0 10px 0 !important;
  }

  .template-fine-dining .section-title {
    font-size: 22px !important;
    font-family: 'Playfair Display', serif !important;
    font-weight: 400 !important;
    text-align: center !important;
    color: #333 !important;
    border-bottom: none !important;
    margin-bottom: 25px !important;
  }

  .template-cafe .section-title {
    font-size: 16px !important;
    background: ${primaryColor} !important;
    color: white !important;
    padding: 8px 20px !important;
    border-radius: 20px !important;
    display: inline-block !important;
    border-bottom: none !important;
    margin-bottom: 15px !important;
  }

  .template-minimalist .section-title {
    font-size: 20px !important;
    font-weight: 300 !important;
    color: #333 !important;
    border-bottom: 2px solid #eee !important;
    padding-bottom: 10px !important;
  }

  .template-bold .section-title {
    font-size: 20px !important;
    background: ${primaryColor} !important;
    color: white !important;
    padding: 15px 25px !important;
    text-transform: uppercase !important;
    letter-spacing: 2px !important;
    border-bottom: none !important;
    margin-bottom: 20px !important;
  }

  .template-professional .section-title {
    font-size: 16px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
    border-bottom: 2px solid ${primaryColor} !important;
    padding-bottom: 6px !important;
    margin-bottom: 12px !important;
  }

  /* --- Hide empty sections --- */
  .menu-section:empty,
  .menu-section:has(.menu-items:empty) {
    display: none !important;
  }

  .meal-period-header {
    background: ${primaryColor} !important;
    color: white !important;
    padding: 2px 4px !important;
    margin: 0 0 2px 0 !important;
    font-size: 9px !important;
    font-weight: 600 !important;
    text-align: center !important;
    page-break-after: avoid !important;
    break-after: avoid !important;
    border-radius: 1px !important;
    orphans: 3 !important;
    widows: 3 !important;
  }

  .meal-section-title {
    font-size: 0.9rem !important;
    font-weight: 600 !important;
    page-break-after: avoid !important;
    break-after: avoid !important;
    margin-bottom: 3px !important;
    orphans: 2 !important;
    widows: 2 !important;
  }

  .meal-period-category {
    background: #f8f9fa !important;
    color: #495057 !important;
    border: 1px solid #e9ecef !important;
    padding: 1px 3px !important;
    margin: 0.3px 0 !important;
    font-size: 7px !important;
    font-weight: 600 !important;
    border-radius: 1px !important;
    page-break-inside: auto !important;
  }

  .meal-period-category.active {
    background: ${primaryColor} !important;
    color: white !important;
    border-color: ${primaryColor} !important;
  }

  /* --- Menu Content and Grid --- */
  .menu-content {
    padding: 0 !important;
    margin: 0 !important;
    page-break-inside: auto !important;
  }

  .menu-grid {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 3px !important;
    page-break-inside: auto !important;
  }

  /* --- Meal Period Categories Container --- */
  .meal-periods-layout .menu-grid {
    // display: block !important;
    page-break-inside: auto !important;
  }
.menu-grid.cols-1 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.cols-2 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.cols-3 {
    grid-template-columns: 1fr 1fr !important;
}

.menu-grid.grid-layout-left-wide {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-right-wide {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-alternate-wide {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-1-2-1 {
    grid-template-columns: 1fr 1fr !important;
}
	 .menu-grid.grid-layout-1-2-1 > .menu-section:nth-child(3n+1) { 
            grid-column:auto !important; 
        }
        .menu-grid.grid-layout-1-2-1 > .menu-section:nth-child(3n+2) { 
            grid-column: auto !important; 
        }
        .menu-grid.grid-layout-1-2-1 > .menu-section:nth-child(3n) { 
            grid-column: auto !important; 
        }
.menu-grid.grid-layout-2-1-2 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-3-1-3 {
    grid-template-columns: 1fr 1fr !important;
}
.menu-grid.grid-layout-1-3-1 {
    grid-template-columns: 1fr 1fr !important;
}
	.menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n+1) { grid-column: auto !important; }
        .menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n+2) { grid-column: auto !important; }
        .menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n+3) { grid-column: auto !important; }
        .menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n+4) { grid-column: auto !important; }
        .menu-grid.grid-layout-1-3-1 > .menu-section:nth-child(5n) { grid-column:auto !important; }
.menu-grid.grid-layout-2-1-2 > .menu-section:nth-child(3n+1),
.menu-grid.grid-layout-2-1-2 > .menu-section:nth-child(3n+2) {
  grid-column: auto !important; 
}

/* 3rd item of each cycle → full width */
.menu-grid.grid-layout-2-1-2 > .menu-section:nth-child(3n) {
  grid-column: auto !important; 
		}
        /* 3-1-3: three columns, then full width, then three again */
        .menu-grid.grid-layout-3-1-3 > .menu-section:nth-child(4n+1) { grid-column: auto !important;  }
        .menu-grid.grid-layout-3-1-3 > .menu-section:nth-child(4n+2) { grid-column: auto !important;  }
        .menu-grid.grid-layout-3-1-3 > .menu-section:nth-child(4n+3) { grid-column: auto !important;  }
        .menu-grid.grid-layout-3-1-3 > .menu-section:nth-child(4n) { grid-column: auto !important;  }


  /* --- Menu Sections (Categories within meal periods) --- */
  .menu-section {
    margin-bottom: 6px !important;
    page-break-inside: auto !important;
    break-inside: auto !important;
    orphans: 2 !important;
    widows: 2 !important;
  }

  .section-title {
    font-size: 13px !important;
    font-weight: 600 !important;
    color: ${primaryColor} !important;
    border-bottom: 1px solid ${primaryColor} !important;
    margin-bottom: 3px !important;
    padding-bottom: 2px !important;
    page-break-after: avoid !important;
    break-after: avoid !important;
    orphans: 2 !important;
    widows: 2 !important;
  }

  /* --- Menu Items --- */
  .menu-item {
    display: flex !important;
    align-items: stretch !important;
    margin-bottom: 4px !important;
    padding: 4px !important;
    border: 1px solid #e9ecef !important;
    background: white !important;
    border-radius: 2px !important;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05) !important;
    min-height: 60px !important;
    gap: 8px !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    orphans: 1 !important;
    widows: 1 !important;
  }

  /* Template-specific menu item overrides for print */
  .template-elegant .menu-item {
    border: 2px solid var(--accent-color) !important;
    border-radius: 0 !important;
    background: linear-gradient(145deg, #ffffff, #fafafa) !important;
    padding: 8px !important;
    margin-bottom: 6px !important;
  }

  .template-fine-dining .menu-item {
    border: none !important;
    border-bottom: 2px solid #eee !important;
    border-radius: 0 !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 15px 0 !important;
    margin-bottom: 8px !important;
  }

  .template-cafe .menu-item {
    background: #f9f9f9 !important;
    border: 3px dashed var(--accent-color) !important;
    border-radius: 15px !important;
    margin-bottom: 10px !important;
    padding: 8px !important;
  }

  .template-minimalist .menu-item {
    background: transparent !important;
    border: none !important;
    border-bottom: 2px solid #f5f5f5 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 12px 0 !important;
    margin-bottom: 6px !important;
  }

  .template-bold .menu-item {
    background: white !important;
    border: 4px solid var(--accent-color) !important;
    border-radius: 0 !important;
    box-shadow: 6px 6px 0 ${primaryColor} !important;
    margin-bottom: 12px !important;
    padding: 8px !important;
  }

  .template-professional .menu-item {
    border-left: 3px solid var(--accent-color) !important;
    border-radius: 0 !important;
    background: white !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    padding: 6px !important;
    margin-bottom: 4px !important;
  }

  .item-image {
    width: 50px !important;
    height: 50px !important;
    object-fit: cover !important;
    border-radius: 2px !important;
    flex-shrink: 0 !important;
  }

  .item-details {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: space-between !important;
  }

  .item-name {
    font-size: 13px !important;
    font-weight: 600 !important;
    color: #333 !important;
    margin-bottom: 2px !important;
    line-height: 1.2 !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    page-break-inside: avoid !important;
  }

  .item-description {
    font-size: 11px !important;
    color: #666 !important;
    line-height: 1.3 !important;
    flex: 1 !important;
    margin-bottom: 3px !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 1 !important;
    -webkit-box-orient: vertical !important;
    page-break-inside: avoid !important;
  }

  .item-price {
    font-size: 14px !important;
    font-weight: 700 !important;
    color: white !important;
    background: ${primaryColor} !important;
    border-radius: 6px !important;
    padding: 4px 8px !important;
    align-self: flex-end !important;
    min-width: 50px !important;
    text-align: center !important;
    page-break-inside: avoid !important;
  }

  /* Template-specific item name and price overrides for print */
  .template-fine-dining .item-name {
    font-family: 'Playfair Display', serif !important;
    font-size: 16px !important;
    font-weight: 500 !important;
  }

  .template-fine-dining .item-price {
    font-family: 'Playfair Display', serif !important;
    font-size: 15px !important;
    background: transparent !important;
    color: #333 !important;
    border-radius: 0 !important;
    padding: 0 !important;
  }

  .template-bold .item-name {
    font-weight: 900 !important;
    text-transform: uppercase !important;
    font-size: 15px !important;
  }

  .template-bold .item-price {
    background: var(--accent-color) !important;
    color: white !important;
    padding: 6px 12px !important;
    border-radius: 15px !important;
    font-weight: 900 !important;
  }

  .template-elegant .item-name {
    font-family: 'Georgia', serif !important;
    font-size: 15px !important;
    font-weight: 500 !important;
  }

  .template-cafe .item-name {
    font-size: 15px !important;
    font-weight: 600 !important;
  }

  .template-minimalist .item-name {
    font-size: 15px !important;
    font-weight: 500 !important;
    color: #333 !important;
  }

  .template-minimalist .item-price {
    background: transparent !important;
    color: ${primaryColor} !important;
    border-radius: 0 !important;
    padding: 0 !important;
    font-weight: 600 !important;
  }

  .template-professional .item-name {
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .template-professional .item-price {
    background: ${primaryColor} !important;
    color: white !important;
    padding: 3px 8px !important;
    border-radius: 4px !important;
    font-weight: 700 !important;
  }

  /* --- Item badges --- */
  .item-badges {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 2px !important;
  }

  .item-badge {
    background: #f8f9fa !important;
    color: #495057 !important;
    padding: 1px 4px !important;
    border-radius: 6px !important;
    font-size: 7px !important;
    font-weight: 600 !important;
    border: 1px solid #e9ecef !important;
    text-transform: uppercase !important;
    letter-spacing: 0.3px !important;
  }

  .item-badge.hot { background: #ff4444 !important; color: white !important; border-color: #ff6666 !important; }
  .item-badge.new { background: #4CAF50 !important; color: white !important; border-color: #66BB6A !important; }
  .item-badge.popular { background: #FF9800 !important; color: white !important; border-color: #FFB74D !important; }
  .item-badge.vegetarian { background: #8BC34A !important; color: white !important; border-color: #AED581 !important; }
  .item-badge.spicy { background: #E91E63 !important; color: white !important; border-color: #F06292 !important; }
  .item-badge.featured { background: #9C27B0 !important; color: white !important; border-color: #BA68C8 !important; }

  /* --- Featured badge --- */
  .featured-badge {
    position: absolute;
    top: 0px;
    right: 0px;
    background: linear-gradient(45deg, #ffd700, #ffed4e);
    color: #333;
    border-radius: 50%;
    width: 20px !important;
    height: 20px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(255, 215, 0, 0.4);
    z-index: 10;
  }

  /* --- Image handling --- */
  img {
    max-width: 100% !important;
    height: auto !important;
    page-break-inside: avoid !important;
  }

  /* --- Flow control to prevent large blank spaces --- */
  .menu-section + .menu-section {
    margin-top: 2px !important;
    page-break-before: auto !important;
  }

  /* --- Meal Period Section Flow Control --- */
  .meal-period-section + .meal-period-section {
    margin-top: 4px !important;
    page-break-before: auto !important;
  }

  /* --- Ensure meal period titles stay with content --- */
  .meal-period-section .meal-section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
    margin-bottom: 8px !important;
  }

  /* --- Ensure meal period content container stays with title --- */
  .meal-period-section .menu-grid {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Ensure section titles are never alone --- */
  .section-title + .menu-item:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Ensure meal section titles are never alone --- */
  .meal-section-title + .menu-grid .menu-section:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Prevent section titles from appearing alone at page bottom --- */
  .menu-section {
    page-break-inside: auto !important;
    break-inside: auto !important;
  }

  /* --- Ensure at least one menu item follows section title --- */
  .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  /* --- Prevent meal period sections from breaking if only title fits --- */
  .meal-period-section {
    page-break-inside: auto !important;
    break-inside: auto !important;
  }
	   .template-cafe .menu-header {
            background: linear-gradient(135deg, ${primaryColor}, var(--secondary-color)) !important;
            border-radius: 0 0 50% 50% / 0 0 30px 30px !important;
        }

        .template-cafe .section-title {
            background: ${primaryColor} !important;
            color: white !important;
            padding: 6px 20px !important;
            border-radius: 25px !important;
            display: inline-block !important;
            font-size: 18px !important;
            margin-bottom: 25px !important;
            border: none !important;
        }

        .template-cafe .menu-item {
            background: #f9f9f9 !important;
            border: 3px dashed var(--accent-color) !important;
            border-radius: 15px !important;
            margin-bottom: 20px !important;
        }

        .template-cafe .item-image {
            border: 4px solid var(--accent-color) !important;
            border-radius: 50% !important!important;
        }
			.section-title::before {
			font-size:1.4rem !important;
			}
  @page {
    size: Letter !important;
    margin: 0.3in !important;
    margin-top: 0.2in !important;
    margin-bottom: 0.2in !important;
  }
	.template-modern-minimal .section-title,
	.template-contemporary .section-title,
        .template-rustic .section-title, 
        .template-modern-minimal .section-title,
    .template-art-deco .section-title,
.template-industrial .section-title,
 .template-garden .section-title {
            color: white !important;

        }
				.template-mediterranean .section-title{
            color: ${primaryColor} !important;
				
				}

  /* --- Keep menu-header and menu-preview together --- */
  .menu-header {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .menu-content {
    page-break-before: avoid !important;
    break-before: avoid !important;
    page-break-inside: auto !important;
  }

  /* --- Keep section titles with their menu items --- */
  .meal-period-section {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    orphans: 2 !important;
    widows: 2 !important;
  }

  .meal-section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .menu-section {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    orphans: 2 !important;
    widows: 2 !important;
  }

  .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  /* --- Ensure section titles stay with their content --- */
  .meal-section-title + .menu-grid {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .section-title + .menu-items {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .section-title + .menu-grid {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Prevent orphaned section titles --- */
  .meal-section-title:only-child {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .section-title:only-child {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  /* --- Ensure at least one menu item follows section title --- */
  .meal-section-title + * {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .section-title + * {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Handle menu items in various containers --- */
  .menu-items {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .menu-grid {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Ensure meal period categories stay with their content --- */
  .meal-period-category {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .meal-period-category + .menu-grid {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Keep menu items together within sections --- */
  .menu-item {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    orphans: 1 !important;
    widows: 1 !important;
  }

  /* --- Prevent section titles from appearing alone --- */
  .meal-period-section:has(.meal-section-title:only-child) {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .menu-section:has(.section-title:only-child) {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  /* --- Force section titles to have at least one menu item --- */
  .meal-section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .meal-section-title + .menu-grid .menu-section:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .meal-section-title + .menu-grid .menu-section:first-child .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .meal-section-title + .menu-grid .menu-section:first-child .menu-item:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Ensure section titles are never alone --- */
  .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .section-title + .menu-item:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .section-title + .menu-items .menu-item:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .section-title + .menu-grid .menu-item:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Prevent orphaned meal period sections --- */
  .meal-period-section {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    min-height: 100px !important; /* Ensure minimum content */
  }

  /* --- Force meal period titles to stay with content --- */
  .meal-section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .meal-section-title + * {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Ensure at least 2 menu items follow section title --- */
  .section-title {
    orphans: 2 !important;
    widows: 2 !important;
  }

  .meal-section-title {
    orphans: 2 !important;
    widows: 2 !important;
  }

  /* --- Force sections to start on new page if title would be alone --- */
  .meal-period-section {
    page-break-before: auto !important;
    break-before: auto !important;
  }

  .menu-section {
    page-break-before: auto !important;
    break-before: auto !important;
  }

  /* --- Ensure section titles have minimum content following --- */
  .meal-section-title:last-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .section-title:last-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Force meal period sections to stay together --- */
  .meal-period-section .meal-section-title + .menu-grid {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .meal-period-section .meal-section-title + .menu-grid .menu-section:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Ensure menu sections have content --- */
  .menu-section:has(.section-title:only-child) {
    display: none !important; /* Hide empty sections */
  }

  .meal-period-section:has(.meal-section-title:only-child) {
    display: none !important; /* Hide empty sections */
  }

  /* --- AGGRESSIVE FIX: Force titles to never be alone --- */
  .meal-section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    orphans: 3 !important;
    widows: 3 !important;
  }

  .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    orphans: 3 !important;
    widows: 3 !important;
  }

  /* --- Force entire meal period sections to stay together --- */
  .meal-period-section {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-before: auto !important;
    break-before: auto !important;
    page-break-after: auto !important;
    break-after: auto !important;
  }

  /* --- Force entire menu sections to stay together --- */
  .menu-section {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
    page-break-before: auto !important;
    break-before: auto !important;
    page-break-after: auto !important;
    break-after: auto !important;
  }

  /* --- Ensure meal period titles are never alone --- */
  .meal-period-section .meal-section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .meal-period-section .meal-section-title + * {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .meal-period-section .meal-section-title + .menu-grid {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .meal-period-section .meal-section-title + .menu-grid .menu-section:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .meal-period-section .meal-section-title + .menu-grid .menu-section:first-child .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .meal-period-section .meal-section-title + .menu-grid .menu-section:first-child .menu-item:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Ensure section titles are never alone --- */
  .menu-section .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .menu-section .section-title + * {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .menu-section .section-title + .menu-items {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .menu-section .section-title + .menu-grid {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .menu-section .section-title + .menu-items .menu-item:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .menu-section .section-title + .menu-grid .menu-item:first-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Force minimum content with titles --- */
  .meal-section-title:last-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  .section-title:last-child {
    page-break-before: avoid !important;
    break-before: avoid !important;
  }

  /* --- Prevent any breaks within meal period sections --- */
  .meal-period-section * {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .meal-period-section .menu-item {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  /* --- Prevent any breaks within menu sections --- */
  .menu-section * {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  .menu-section .menu-item {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }

  /* --- NATURAL FLOW: Let sections flow naturally --- */
  .meal-period-section {
    page-break-before: auto !important;
    break-before: auto !important;
    page-break-inside: auto !important;
    break-inside: auto !important;
  }

  .menu-section {
    page-break-before: auto !important;
    break-before: auto !important;
    page-break-inside: auto !important;
    break-inside: auto !important;
  }

  /* --- Remove minimum height constraints to allow natural flow --- */
  .meal-period-section {
    min-height: auto !important;
  }

  .menu-section {
    min-height: auto !important;
  }

  /* --- Basic title protection --- */
  .meal-section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  /* --- Conservative page break logic: Allow natural flow --- */
  .meal-period-section {
    page-break-inside: auto !important;
    break-inside: auto !important;
    orphans: 1 !important;
    widows: 1 !important;
  }

  .menu-section {
    page-break-inside: auto !important;
    break-inside: auto !important;
    orphans: 1 !important;
    widows: 1 !important;
  }

  /* --- Minimal title protection --- */
  .meal-section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  .section-title {
    page-break-after: avoid !important;
    break-after: avoid !important;
  }

  /* --- Keep only essential rules --- */
  .menu-item {
    page-break-inside: avoid !important;
    break-inside: avoid !important;
  }
}
</style>

				</head>
				<body onload="window.print(); window.close();">
					<div class="container">
						${menuContent}
					</div>
				</body>
				</html>
			`;

			printWindow.document.write(printContent);
			printWindow.document.close();

			// Wait for document to be ready, then modify menu-grid classes
			const modifyMenuGridClasses = () => {
				const menuGridElements = printWindow.document.querySelectorAll('.menu-grid');
				if (menuGridElements && menuGridElements.length > 0) {
					const classesToRemove = [
						'cols-1',
						'cols-3',
						'grid-layout-left-wide',
						'grid-layout-right-wide',
						'grid-layout-1-2-1',
						'grid-layout-1-3-1',
						'grid-layout-2-1-2',
						'grid-layout-3-1-3',
						'grid-layout-wide-narrow'
					];
					
					menuGridElements.forEach((element: Element) => {
						// Remove specified grid-related classes
						classesToRemove.forEach(cls => {
							if (element.classList.contains(cls)) {
								element.classList.remove(cls);
								element.classList.add('cols-2');
							}
						});
						
						// Add cols-2 class
					});
				}
			};

			// Try immediately (in case document is already ready)
			modifyMenuGridClasses();

			// Also wait for DOMContentLoaded if not already fired
			printWindow.document.addEventListener('DOMContentLoaded', modifyMenuGridClasses);

			// Fallback with setTimeout in case DOMContentLoaded already fired
			setTimeout(modifyMenuGridClasses, 100);
		} catch (error) {
			console.error('Error accessing iframe content:', error);
			
			// Fallback: Open iframe src directly with print parameter
			const iframeSrc = iframe.src;
			const url = new URL(iframeSrc);
			url.searchParams.set('print', 'true');
			// url.searchParams.set('theme', encodeURIComponent(primaryColor));
			
			printWindow.location.href = url.toString();
		}
	}

	async frontend_printGrid(size) {
		// If size is 'Letter', open window immediately (before any async operations)
		// This ensures window.open() is called in direct response to user action
		if (size === 'Letter') {
			const storeUid = this.current_store_uid;
			if (!storeUid) {
				console.error('store_uid is not available');
				alert('Store UID not found. Cannot load grid editor.');
				return;
			}

			try {
				const origin = window.location.origin;

				// check current URL me print=true hai ya nahi
				const searchParams = new URLSearchParams(window.location.search);

				let randomGridUrl = '';

				if (searchParams.has('print') && searchParams.get('print') === 'true') {
					// agar print=true mila → print parameters use karo
					const layoutId = searchParams.get('layout_id');
					const storeId = searchParams.get('store_id');

					randomGridUrl = `${origin}/assets/random_grid.html?print=true&layout_id=${layoutId}&store_id=${storeId}`;
					if(searchParams.has('preview') && searchParams.get('preview') === 'true'){
					randomGridUrl = `${origin}/assets/random_grid.html?print=true&preview=true&layout_id=${layoutId}&store_id=${storeId}`;
					}
				} else{
					// default → store_uid pass karo
					// default → store_uid pass karo
					randomGridUrl = `${origin}/assets/random_grid.html?store_uid=${this.current_store_uid}&layout_id=${this.current_onsale_data[0].uid}`;
					if (searchParams.has('preview') && searchParams.get('preview') === 'true') {
						randomGridUrl = `${origin}/assets/random_grid.html?preview=true?store_uid=${this.current_store_uid}&layout_id=${this.current_onsale_data[0].uid}`;
					}
				}


				// Calculate screen dimensions for full screen
				const screenWidth = window.screen.availWidth || window.screen.width;
				const screenHeight = window.screen.availHeight || window.screen.height;

				// Open window immediately (must be in direct response to user click)
				var printWindow = window.open(
					randomGridUrl,
					"_blank",
					`width=${screenWidth},height=${screenHeight},left=0,top=0,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no`
				);

				if (!printWindow) {
					console.error('Failed to open window. Popup may be blocked.');
					alert('Failed to open window. Please allow popups for this site or check your browser settings.');
					return;
				}

				// Pass Firebase config to the child window securely
				// The child window will access this via window.opener.firebaseConfig
				(window as any).firebaseConfigForChild = environment.firebase;

				// Maximize the window
				printWindow.moveTo(0, 0);
				printWindow.resizeTo(screenWidth, screenHeight);

				// Exit early - don't continue with old HTML generation
				return;

			} catch (error) {
				console.error('Error opening random_grid.html:', error);
				alert('Error opening grid editor: ' + error.message);
				return;
			}
		} else if (size === 'Tabloid') {
			const storeUid = this.current_store_uid;

			if (!storeUid) {
				console.error('store_uid is not available');
				alert('Store UID not found. Cannot load grid editor.');
				return;
			}

			try {
				const origin = window.location.origin;

				// check current URL me print=true hai ya nahi
				const searchParams = new URLSearchParams(window.location.search);

				let randomGridUrl = '';

				if (searchParams.has('print') && searchParams.get('print') === 'true') {
					// agar print=true mila → print parameters use karo
					const layoutId = searchParams.get('layout_id');
					const storeId = searchParams.get('store_id');

					randomGridUrl = `${origin}/assets/random_grid_tabloid.html?print=true&layout_id=${layoutId}&store_id=${storeId}`;
					if (searchParams.has('preview') && searchParams.get('preview') === 'true') {
						randomGridUrl = `${origin}/assets/random_grid_tabloid.html?print=true&preview=true&layout_id=${layoutId}&store_id=${storeId}`;
					}
				} else {
					// default → store_uid pass karo
					randomGridUrl = `${origin}/assets/random_grid_tabloid.html?store_uid=${this.current_store_uid}&layout_id=${this.current_onsale_data[0].uid}`;
					if (searchParams.has('preview') && searchParams.get('preview') === 'true') {
						randomGridUrl = `${origin}/assets/random_grid_tabloid.html?preview=true?store_uid=${this.current_store_uid}&layout_id=${this.current_onsale_data[0].uid}`;
					}
				}



				// Calculate screen dimensions for full screen
				const screenWidth = window.screen.availWidth || window.screen.width;
				const screenHeight = window.screen.availHeight || window.screen.height;

				// Open window immediately (must be in direct response to user click)
				var printWindow = window.open(
					randomGridUrl,
					"_blank",
					`width=${screenWidth},height=${screenHeight},left=0,top=0,resizable=yes,scrollbars=yes,toolbar=no,menubar=no,location=no`
				);

				if (!printWindow) {
					console.error('Failed to open window. Popup may be blocked.');
					alert('Failed to open window. Please allow popups for this site or check your browser settings.');
					return;
				}
				(window as any).firebaseConfigForChild = environment.firebase;
				// Maximize the window
				printWindow.moveTo(0, 0);
				printWindow.resizeTo(screenWidth, screenHeight);

				// Exit early - don't continue with old HTML generation
				return;

			} catch (error) {
				console.error('Error opening random_grid.html:', error);
				alert('Error opening grid editor: ' + error.message);
				return;
			}
		}
	}
	open_print() {
		this.analytics.logEvent('@ShoppingList_print_click_count', {
			store_name: this.store_data[0]?.company_name,
			message: 'ShoppingList Print Button Clicked.'
		})
		if (this.store_data[0]?.googleMeasurementId) {
			(window as any).gtag('event', "@ShoppingList_print_click_count", {
				send_to: this.store_data[0]?.googleMeasurementId,
				store_name: this.store_data[0]?.company_name,
				message: 'ShoppingList Print Button Clicked.'
			});
		}
		$(".print-head").removeClass("show-logo");
		this.showLoader.emit(true)
		setTimeout(() => {
			let printContents, popupWin;
			printContents = document.querySelector(".listingData").innerHTML;
			popupWin = window.open("", "_blank", "top=0,left=0,height=100%,width=auto");
			popupWin.document.open();
			popupWin.document.write(`
			<html>
				<head>
				<style>
					.text-center {
					text-align: center!important;
					}
					.header_cart{
						display:none !important;
					 }

					.main-print .listingData {
		                height: auto;
						height: auto;
					}
					.mt-5, .my-5 {
						margin-top: 3rem!important;
					}
					.d-flex {
						display: flex!important;
					}
					.align-items-center {
						align-items: center!important;
					}
					.items-list{
						padding: 10px !important;
						border-bottom: 2px solid #ddd;
					}
					.main-print {
						width: 21cm;
						margin: 0 auto !important;
					}
					.print-listingData {
					background-color: white;
					}
					.print-itm-content {
					text-align: left;
					}
					.items-list.print-list {
					background-color: white;
					}
					.main-print .listingData {
	                height: auto;
					height: auto;
					}
					.main-print .cls-btn {
					justify-content: unset;
					}

					#print-div .product-list  div{
						justify-content:space-between !important;
					}
					#print-div .recipe-list   div{
						justify-content:space-between !important;
					}
					#print-div .coupen-list   div{
						justify-content:space-between !important;
					}
					.print-logo img {
						height: 90px;
						margin-top: 1rem;
					}
					.item-name{
						width:300px !important;
					}
					.print-head p {
					color: #6b6b6b;
						font-size: 14px;
						margin: 0;
					}
					.print-store-name {
					font-size: 1.17rem;
						margin: 10px 0px;
						color: #6b6b6b;
					}
					.item-img img, video,.select-all-with-checkbox span {
						padding-left: 10px;
						color: #fff;
						font-weight: 400;
						margin-left: 10px;
					}
					.item-img img {
		              height: 72px;
						width: 82px;
					}
					.item-img video{
						height: 72px;
						width: 82px;
					}
					img {
						vertical-align: middle;
						border-style: none;
					}
					.image-box {
						margin-right: 15px;
					}
					.item-img {
						display: flex;
						align-items: center;
					}
					.col-md-8{
						position: relative;
						width: 100%;
						height: 1px;
						padding-right: 15px;
						padding-left: 15px;
					}
					.item-name {
						align-items: flex-start;
						display: flex;
						flex-direction: column;
					}
					.item-title {
						font-size: 26px;
					}
					.item-content {
						color: #828282;
						font-size: small;
					}
					.print-itm-content {
						text-align: left;
					}
					.item-text-p {
						font-size: 20px !important;
					}
	                .item-content p {
                    margin: 5px 0 !important;
                    }
					.item-text-span {
						font-size: 20px !important;
					}
					.cls-btn, .current-item, .remove-btn {
						display: flex;
						align-content: center;
						align-items: center;
						justify-content: space-around !important;
					}
					.cls-btn{
						cursor: pointer;
					}
					.item-img input{
						display:none !important;
					}
					.d-none{
						display:none !important;
					}
					@page {
						size: A4 letter;
						margin: 10mm;
						margin-top: 12mm;
						@bottom-right {
							font-family: Arial, sans-serif;
							font-size: 12px;
							color: #949496;
							white-space: pre-line noWrap;
						}
						@bottom-left {
							font-family: Arial, sans-serif;
							font-size: 12px;
							color: #949496;
							white-space: pre-line;
						}
						#print-div .product-list  div{
							justify-content:space-between !important;
						}

						.item-name{
							width:300px !important;
						}
					}
				</style>
				</head>
            <body onload="window.print();" style='font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", "Liberation Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";'>
			<script>
			        window.onafterprint = function() { window.close(); };
			</script>
			<div class="main-print" id="print-div">${printContents}</div></body>
			</html>`);
			popupWin.document.close(
				this.closeDialog()
			);
		}, 2000);
	}

	closeDialog() {
		this.printCart = false;
		$(".print-head").addClass("show-logo");
		this.showLoader.emit(false)
	}

	async add_item_change(event) {
		let temp = []
		if (this.combinedData) {
			this.all_items.forEach(item => {
				const check = this.combinedData.some(l => l.id == item.uid)

				if (check) {
					item.isOnSale = true
					temp.push(item)
				} else {
					item.isMaster = true
					temp.push(item)
				}
			})
			this.all_items = temp
			this.filtered_items = this.all_items.filter(i => {
				let a = i?.product_description?.toLowerCase()
				return a?.includes(event?.target?.value?.toLowerCase())
			})
			if (event.target.value.length > 0 && this.filtered_items.length < 1) {
				this.no_content_display = true
			} else {
				this.no_content_display = false
			}
		} else {
			this.filtered_items = this.all_items.filter(i => {
				let a = i?.product_description.toLowerCase()
				return a.includes(event.target.value.toLowerCase())
			})
			if (event.target.value.length > 0 && this.filtered_items.length < 1) {
				this.no_content_display = true
			} else {
				this.no_content_display = false
			}
		}
	}

	createCart() {
		this.afs.collection('/list').add({ items: this.cartItem }).then(docRef => {
			const itemRefx2 = this.afs.doc('/list/' + docRef.id);
			itemRefx2.update({ uid: docRef.id });
			localStorage.setItem('list_id', docRef.id)
			let list_ids;
			if (localStorage.getItem('list_ids')) {
				list_ids = JSON.parse(localStorage.getItem('list_ids'))
				list_ids[this.store_name_slug] = docRef.id;
				localStorage.setItem('list_ids', JSON.stringify(list_ids))
			} else {
				list_ids = {
					[this.store_name_slug]: docRef.id
				}
				localStorage.setItem('list_ids', JSON.stringify(list_ids))
			}
			this.current_list_id = docRef.id
			this.qr_value = window.location.href + '/list/' + this.current_list_id;
		});
	}
	generateRandom16DigitNumber() {
		let min = 1000000000000000; // Minimum 16-digit number
		let max = 9999999999999999; // Maximum 16-digit number
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	async add_static() {
		let inpt: any = document.getElementById('addItem')
		if (inpt.value != '' && inpt.value != null) {
			let randomNumber = this.generateRandom16DigitNumber();
			let item = {
				product_description: inpt.value, // Assuming inpt.value contains the product name
				product_image: "https://firebasestorage.googleapis.com/v0/b/digital-menus-pro-6b7bd.appspot.com/o/uploads%2FPhoto%20Coming%20Soon.jpg?alt=media&token=9951c800-09c8-4642-b73f-3caee5455726",
				uid: randomNumber // Add the random number to the object
			}
			this.cartItem.push({ product: item, count: 1, static: true })
			if (this.current_list_id !== '') {
				await this.afs.doc('/list/' + this.current_list_id).set({ items: this.cartItem }, { merge: true }).then(docRef => {
				});
			}
			else {
				if (!this.createdCart) {
					this.createdCart = true;
					await this.createCart();
				}
			}
			this.filtered_items = []
			inpt.value = ''
			this.no_content_display = false
			this._snackBar.open('Item added in your list', '', {
				duration: 2000,
			});
		} else {
			this._snackBar.open('Please add Item Name', '', {
				duration: 2000,
			});
		}
	}

	toDataURL(url, callback) {
		var xhr = new XMLHttpRequest();
		xhr.onload = function () {
			var reader = new FileReader();
			reader.onloadend = function () {
				callback(reader.result);
			}
			reader.readAsDataURL(xhr.response);
		};
		xhr.open('GET', url);
		xhr.responseType = 'blob';
		xhr.send();
	}

	hendle_Add_item(type) {
		if (type === 'add') {
			this.show_add_item = true
		}
		if (type === 'close') {
			this.show_add_item = false
			this.filtered_items = []
		}
	}
	async remove_one_from_cart(i, type) {
		if (!this.serializedIds && this.serializedIds == undefined) {
			// this.serializedIds = this.combinedData.map(s => s.id)
			this.serializedIds = this.combinedData?.flatMap(s => {
				if (s?.subGridOpts?.children?.length) {
					return s.subGridOpts.children.map(child => child.id);
				} else {
					return [s.id];
				}
			});
		}
		if (type === 'one') {
			this.cartItem.splice(this.cartItem.indexOf(i), 1)
			if (!i.static && this.serializedIds.includes(i?.product?.uid) && !this.isCoupon && !this.isRecipe) {
				let main_item
				let title_bar
				let delete_icon
				let layout_product_qnt
				let layout_count_product: HTMLElement
				const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
				if (view == "listView" && window.innerWidth < 768) {
					if (i?.product?.isBundleProduct) {
						main_item = document.getElementById(i?.product?.uid)?.parentElement?.parentElement?.parentElement;
					} else {
						main_item = document.getElementById(i?.product?.uid)?.parentElement?.parentElement;
					}
					delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
					layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
				} else {
					if (i?.product?.isBundleProduct) {
						if (document.getElementById(i?.product?.uid)) {
							if (document.getElementById(i?.product?.uid).tagName != 'VIDEO') {
								if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
									main_item = document.getElementById(i?.product?.uid)?.parentElement
								} else {
									main_item = document.getElementById(i?.product?.uid)?.parentElement
								}
							} else {
								main_item = document.getElementById(i?.product?.uid)?.parentElement
							}
						}
					} else {
						if (document.getElementById(i?.product?.uid)) {
							if (document.getElementById(i?.product?.uid).tagName != 'VIDEO') {
								if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
									main_item = document.getElementById(i?.product?.uid)?.parentElement
								} else {
									main_item = document.getElementById(i?.product?.uid)
								}
							} else {
								main_item = document.getElementById(i?.product?.uid)?.parentElement
							}
						}
					}
					layout_product_qnt = main_item.parentElement.getElementsByClassName("layout_product_qnt")[0]
					layout_count_product = main_item.parentElement.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
					title_bar = main_item?.parentElement?.childNodes[1]
					title_bar?.classList?.remove("test")
				}
				if (layout_product_qnt?.innerHTML) {
					layout_product_qnt.innerHTML = ''
				}
				if (layout_count_product?.style?.visibility) {
					layout_count_product.style.visibility = 'hidden'
				}
				this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.uid), 1)
				if (delete_icon) {
					delete_icon.src = "../../../assets/imgs/plus.png"
				}
			} else if (!i.static && this.serializedIds.includes(i?.product?.id) && !this.isCoupon && !this.isRecipe) {
				let main_item
				let title_bar
				let delete_icon
				let layout_product_qnt
				let layout_count_product: HTMLElement
				const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
				if (view == "listView" && window.innerWidth < 768) {
					if (i?.product?.isBundleProduct) {
						main_item = document.getElementById(i?.product?.id)?.parentElement?.parentElement?.parentElement;
					} else {
						main_item = document.getElementById(i?.product?.id)?.parentElement?.parentElement;
					}
					delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
					layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
				} else {
					if (i?.product?.isBundleProduct) {
						if (document.getElementById(i?.product?.id)) {
							if (document.getElementById(i?.product?.id).tagName != 'VIDEO') {
								if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
									main_item = document.getElementById(i?.product?.id)?.parentElement
								} else {
									main_item = document.getElementById(i?.product?.id)?.parentElement
								}
							} else {
								main_item = document.getElementById(i?.product?.id)?.parentElement
							}
						}
					} else {
						if (document.getElementById(i?.product?.id)) {
							if (document.getElementById(i?.product?.id).tagName != 'VIDEO') {
								if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
									main_item = document.getElementById(i?.product?.id)?.parentElement
								} else {
									main_item = document.getElementById(i?.product?.id)
								}
							} else {
								main_item = document.getElementById(i?.product?.id)?.parentElement
							}
						}
					}

					layout_product_qnt = main_item?.parentElement?.getElementsByClassName("layout_product_qnt")[0]
					layout_count_product = main_item?.parentElement?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
					title_bar = main_item?.parentElement?.childNodes[1]
					title_bar?.classList?.remove("test")
				}
				if (layout_product_qnt) {
					layout_product_qnt.innerHTML = ''
				}
				if (layout_count_product?.style?.visibility) {
					layout_count_product.style.visibility = 'hidden'
				}
				this.cart_ids.splice(this.cart_ids.indexOf(i?.product?.id), 1)
				if (delete_icon) {
					delete_icon.src = "../../../assets/imgs/plus.png"
				}
			}
		}
		if (type == 'selected') {
			this.cartItem = this.cartItem?.filter(itm => {
				if (!this.selected_cart_items.includes(itm)) {
					return true
				} else {
					if (this.serializedIds.includes(itm?.product?.uid) && !this.isCoupon) {
						let main_item
						let title_bar
						let count_icon_plus: HTMLElement
						let count_icon_minus: HTMLElement
						let delete_icon
						let layout_product_qnt
						let layout_count_product: HTMLElement
						const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
						if (view == "listView" && window.innerWidth < 768) {
							if (itm?.product?.isBundleProduct) {
								main_item = document.getElementById(itm?.product?.uid)?.parentElement?.parentElement?.parentElement;
							} else {
								main_item = document.getElementById(itm?.product?.uid)?.parentElement?.parentElement;
							}
							delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
							layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
							layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
							count_icon_plus = main_item?.getElementsByClassName("count-products")[0]?.firstChild as HTMLElement;
							count_icon_minus = main_item?.getElementsByClassName("count-products")[0]?.lastChild as HTMLElement;
						} else {
							if (itm?.product?.isBundleProduct) {
								if (document.getElementById(itm?.product?.uid)) {
									if (document.getElementById(itm?.product?.uid).tagName != 'VIDEO') {
										if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
											main_item = document.getElementById(itm?.product?.uid)?.parentElement
										} else {
											main_item = document.getElementById(itm?.product?.uid)?.parentElement
										}
									} else {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									}
								}
							} else {
								if (document.getElementById(itm?.product?.uid)) {
									if (document.getElementById(itm?.product?.uid).tagName != 'VIDEO') {
										if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
											main_item = document.getElementById(itm?.product?.uid)?.parentElement
										} else {
											main_item = document.getElementById(itm?.product?.uid)
										}
									} else {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									}
								}
							}

							layout_product_qnt = main_item.parentElement.getElementsByClassName("layout_product_qnt")[0]
							layout_count_product = main_item.parentElement.getElementsByClassName("layout_count_product")[0] as HTMLElement;
							delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
							title_bar = main_item?.parentElement?.childNodes[1]
							title_bar?.classList.remove("test")
						}
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
						return false
					} else if (this.serializedIds.includes(itm?.product?.id) && !this.isCoupon) {
						let main_item
						let title_bar
						let count_icon_plus: HTMLElement
						let count_icon_minus: HTMLElement
						let delete_icon
						let layout_product_qnt
						let layout_count_product: HTMLElement
						const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
						if (view == "listView" && window.innerWidth < 768) {
							if (itm?.product?.isBundleProduct) {
								main_item = document.getElementById(itm?.product?.id)?.parentElement?.parentElement?.parentElement;
							} else {
								main_item = document.getElementById(itm?.product?.id)?.parentElement?.parentElement;
							}
							delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
							layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
							layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
							count_icon_plus = main_item?.getElementsByClassName("count-products")[0]?.firstChild as HTMLElement;
							count_icon_minus = main_item?.getElementsByClassName("count-products")[0]?.lastChild as HTMLElement;
						} else {
							if (itm?.product?.isBundleProduct) {
								if (document.getElementById(itm?.product?.id)) {
									if (document.getElementById(itm?.product?.id).tagName != 'VIDEO') {
										if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
											main_item = document.getElementById(itm?.product?.id)?.parentElement
										} else {
											main_item = document.getElementById(itm?.product?.id)?.parentElement
										}
									} else {
										main_item = document.getElementById(itm?.product?.id)?.parentElement
									}
								}
							} else {
								if (document.getElementById(itm?.product?.id)) {
									if (document.getElementById(itm?.product?.id).tagName != 'VIDEO') {
										if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
											main_item = document.getElementById(itm?.product?.id)?.parentElement
										} else {
											main_item = document.getElementById(itm?.product?.id)
										}
									} else {
										main_item = document.getElementById(itm?.product?.id)?.parentElement
									}
								}
							}
							layout_product_qnt = main_item.parentElement.getElementsByClassName("layout_product_qnt")[0]
							layout_count_product = main_item.parentElement.getElementsByClassName("layout_count_product")[0] as HTMLElement;
							delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
							title_bar = main_item?.parentElement?.childNodes[1]
							title_bar?.classList.remove("test")
						}
						if (layout_product_qnt?.innerHTML) {
							layout_product_qnt.innerHTML = ''
						}
						if (layout_count_product?.style?.visibility) {
							layout_count_product.style.visibility = 'hidden'
						}
						if (delete_icon) {
							delete_icon.src = "../../../assets/imgs/plus.png"
						}
						return false
					}
				}
			})
		}
		if (type === 'all') {
			this.cartItem.forEach(itm => {
				let main_item
				let title_bar
				let count_icon_plus: HTMLElement
				let count_icon_minus: HTMLElement
				let delete_icon
				let layout_product_qnt
				let layout_count_product: HTMLElement
				const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
				if (view == "listView" && window.innerWidth < 768) {
					if (itm?.product?.isBundleProduct) {
						if (itm?.product?.id) {
							main_item = document.getElementById(itm?.product?.id)?.parentElement?.parentElement?.parentElement;
						} else {
							main_item = document.getElementById(itm?.product?.uid)?.parentElement?.parentElement?.parentElement;
						}
					} else {
						if (itm?.product?.id) {
							main_item = document.getElementById(itm?.product?.id)?.parentElement?.parentElement;
						} else {
							main_item = document.getElementById(itm?.product?.uid)?.parentElement?.parentElement;
						}
					}
					delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
					layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
					count_icon_plus = main_item?.getElementsByClassName("count-products")[0]?.firstChild as HTMLElement;
					count_icon_minus = main_item?.getElementsByClassName("count-products")[0]?.lastChild as HTMLElement;
				} else {
					if (itm?.product?.isBundleProduct) {
						if (itm?.product?.id) {
							if (document.getElementById(itm?.product?.id)) {
								if (document.getElementById(itm?.product?.id).tagName != 'VIDEO') {
									if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
										main_item = document.getElementById(itm?.product?.id)?.parentElement
									} else {
										main_item = document.getElementById(itm?.product?.id)?.parentElement
									}
								} else {
									main_item = document.getElementById(itm?.product?.id)?.parentElement
								}
							}
						} else {
							if (document.getElementById(itm?.product?.uid)) {
								if (document.getElementById(itm?.product?.uid).tagName != 'VIDEO') {
									if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									} else {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									}
								} else {
									main_item = document.getElementById(itm?.product?.uid)?.parentElement
								}
							}
						}
					} else {
						if (itm?.product?.id) {
							if (document.getElementById(itm?.product?.id)) {
								if (document.getElementById(itm?.product?.id).tagName != 'VIDEO') {
									if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
										main_item = document.getElementById(itm?.product?.id)?.parentElement
									} else {
										main_item = document.getElementById(itm?.product?.id)
									}
								} else {
									main_item = document.getElementById(itm?.product?.id)?.parentElement
								}
							}
						} else {
							if (document.getElementById(itm?.product?.uid)) {
								if (document.getElementById(itm?.product?.uid).tagName != 'VIDEO') {
									if (itm?.product?.isVideo == 'youtube' || itm?.product?.isVideo == 'facebook') {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									} else {
										main_item = document.getElementById(itm?.product?.uid)
									}
								} else {
									main_item = document.getElementById(itm?.product?.uid)?.parentElement
								}
							}
						}
					}
					layout_product_qnt = main_item?.parentElement?.getElementsByClassName("layout_product_qnt")[0]
					layout_count_product = main_item?.parentElement?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
				}
				if (!itm.static && this.serializedIds.includes(itm?.product?.uid)) {
					let title_bar: any = main_item?.parentElement?.childNodes[1]
					title_bar?.classList?.remove("test")
					if (layout_product_qnt?.innerHTML) {
						layout_product_qnt.innerHTML = ''
					}
					if (layout_count_product?.style?.visibility) {
						layout_count_product.style.visibility = 'hidden'
					}
					this.cart_ids.splice(this.cart_ids.indexOf(itm?.product?.uid), 1)
					if (delete_icon) {
						delete_icon.src = "../../../assets/imgs/plus.png"
					}
					if (layout_product_qnt?.innerHTML) {
						layout_product_qnt.innerHTML = ''
					}
				} else if (!itm.static && this.serializedIds.includes(itm?.product?.id)) {
					let title_bar: any = main_item?.parentElement?.childNodes[1]
					title_bar?.classList?.remove("test")
					if (layout_product_qnt?.innerHTML) {
						layout_product_qnt.innerHTML = ''
					}
					if (layout_count_product?.style?.visibility) {
						layout_count_product.style.visibility = 'hidden'
					}
					this.cart_ids.splice(this.cart_ids.indexOf(itm?.product?.id), 1)
					if (delete_icon) {
						delete_icon.src = "../../../assets/imgs/plus.png"
					}
					if (layout_product_qnt?.innerHTML) {
						layout_product_qnt.innerHTML = ''
					}
				}

			})
			this.past_item?.forEach(itm => {
				let main_item
				let title_bar
				let count_icon_plus: HTMLElement
				let count_icon_minus: HTMLElement
				let delete_icon
				let layout_product_qnt
				let layout_count_product: HTMLElement
				const view = localStorage.getItem("view") ? localStorage.getItem("view") : "normalView"
				if (view == "listView" && window.innerWidth < 768) {
					if (itm?.product?.isBundleProduct) {
						if (itm?.product?.id) {
							main_item = document.getElementById(itm?.product?.id)?.parentElement?.parentElement?.parentElement;
						} else {
							main_item = document.getElementById(itm?.product?.uid)?.parentElement?.parentElement?.parentElement;
						}
					} else {
						if (itm?.product?.id) {
							main_item = document.getElementById(itm?.product?.id)?.parentElement?.parentElement;
						} else {
							main_item = document.getElementById(itm?.product?.uid)?.parentElement?.parentElement;
						}
					}
					delete_icon = main_item?.getElementsByClassName('deleteIconlistView')[0]
					layout_count_product = main_item?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					layout_product_qnt = main_item?.getElementsByClassName("layout_product_qnt")[0]
					count_icon_plus = main_item?.getElementsByClassName("count-products")[0]?.firstChild as HTMLElement;
					count_icon_minus = main_item?.getElementsByClassName("count-products")[0]?.lastChild as HTMLElement;
				} else {
					if (itm?.product?.isBundleProduct) {
						if (itm?.product?.id) {
							if (document.getElementById(itm?.product?.id)) {
								if (document.getElementById(itm?.product?.id).tagName != 'VIDEO') {
									if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
										main_item = document.getElementById(i?.product?.id)?.parentElement
									} else {
										main_item = document.getElementById(i?.product?.id)?.parentElement
									}
								} else {
									main_item = document.getElementById(itm?.product?.id)?.parentElement
								}
							}
						} else {
							if (document.getElementById(itm?.product?.uid)) {
								if (document.getElementById(itm?.product?.uid).tagName != 'VIDEO') {
									if (itm?.product?.isVideo == 'youtube' || itm?.product.isVideo == 'facebook') {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									} else {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									}
								} else {
									main_item = document.getElementById(itm?.product?.uid)?.parentElement
								}
							}
						}
					} else {
						if (itm?.product?.id) {
							if (document.getElementById(itm?.product?.id)) {
								if (document.getElementById(itm?.product?.id).tagName != 'VIDEO') {
									if (i?.product?.isVideo == 'youtube' || i?.product?.isVideo == 'facebook') {
										main_item = document.getElementById(i?.product?.id)?.parentElement
									} else {
										main_item = document.getElementById(i?.product?.id)
									}
								} else {
									main_item = document.getElementById(itm?.product?.id)?.parentElement
								}
							}
						} else {
							if (document.getElementById(itm?.product?.uid)) {
								if (document.getElementById(itm?.product?.uid).tagName != 'VIDEO') {
									if (itm?.product?.isVideo == 'youtube' || itm?.product.isVideo == 'facebook') {
										main_item = document.getElementById(itm?.product?.uid)?.parentElement
									} else {
										main_item = document.getElementById(itm?.product?.uid)
									}
								} else {
									main_item = document.getElementById(itm?.product?.uid)?.parentElement
								}
							}
						}
					}
					layout_product_qnt = main_item?.parentElement?.getElementsByClassName("layout_product_qnt")[0]
					layout_count_product = main_item?.parentElement?.getElementsByClassName("layout_count_product")[0] as HTMLElement;
					delete_icon = main_item?.parentElement?.getElementsByClassName('deleteicon')[0]
				}
				if (!itm?.static && this.serializedIds.includes(itm?.product?.uid)) {
					let title_bar: any = main_item?.parentElement?.childNodes[1]
					title_bar?.classList?.remove("test")
					if (layout_product_qnt?.innerHTML) {
						layout_product_qnt.innerHTML = ''
					}
					if (layout_count_product) {
						layout_count_product.style.visibility = 'hidden'
					}
					this.cart_ids.splice(this.cart_ids.indexOf(itm?.product?.uid), 1)
					if (delete_icon) {
						delete_icon.src = "../../../assets/imgs/plus.png"
					}
				} else if (!itm?.static && this.serializedIds.includes(itm?.product?.id)) {
					let title_bar: any = main_item?.parentElement?.childNodes[1]
					title_bar?.classList?.remove("test")
					if (layout_product_qnt?.innerHTML) {
						layout_product_qnt.innerHTML = ''
					}
					if (layout_count_product) {
						layout_count_product.style.visibility = 'hidden'
					}
					this.cart_ids.splice(this.cart_ids.indexOf(itm?.product?.id), 1)
					if (delete_icon) {
						delete_icon.src = "../../../assets/imgs/plus.png"
					}
				}

			})
			this.cartItem = []
			this.past_item = []
		}
		this.current_list_id = localStorage.getItem('list_id') ? localStorage.getItem('list_id') : ''
		const totalAmount = this.cartItem.reduce((total, item) => {
			// Remove the '$' symbol and convert to a floating-point number
			const amount = parseFloat(item.Amount) * item.count;
			return total + amount;;
		}, 0); // 
		this.totalAmount = totalAmount;
		await this.afs.doc('/list/' + this.current_list_id).set({ items: this.cartItem, past_items: this.past_item ? this.past_item : [] }, { merge: true });
		await this.afs.collection('/list', ref => ref.where('uid', '==', this.current_list_id)).snapshotChanges().subscribe((data: any) => {
			this.current_list_data = data.map(e => {
				return {
					uid: e.payload.doc.id,
					items: e.payload.doc.data().items ? e.payload.doc.data().items : [],
					past_items: e.payload.doc.data().past_items ? e.payload.doc.data().past_items : []
				};
			});
			this.current_list_data = this.current_list_data[0]
			this.cartItem = this.current_list_data.items
			this.past_item = this.current_list_data.past_items;
			this.cart_ids = []
			this.current_list_data.items.forEach(i => {
				if (i?.product?.id) {
					this.cart_ids.push(i?.product?.id)
				} else {
					this.cart_ids.push(i?.product?.uid)
				}
			});
		});

	}
	allSelection() {
		this.onlyCoupon = false
		$('.all-selection-btn a').addClass('current');
		$('.coupons-only-selection-btn a').removeClass('current');
		$('.recipes-only-selection-btn a').removeClass('current');
		$('.items-list').removeClass('d-none');
		$('.recipe-list').removeClass('d-none');
		$('.coupen-list').removeClass('d-none');
		$('.product-list').addClass('d-block');
	}
	couponSelection() {
		this.onlyCoupon = true
		$('.all-selection-btn a').removeClass('current');
		$('.coupons-only-selection-btn a').addClass('current');
		$('.recipes-only-selection-btn a').removeClass('current');
		$('.items-list').removeClass('d-none');
		$('.recipe-list').removeClass('d-block');
		$('.recipe-list').addClass('d-none');
		$('.coupen-list').removeClass('d-none');
		$('.coupen-list').addClass('d-block');
	}
	recipeSelection() {
		this.isCoupon = false
		$('.all-selection-btn a').removeClass('current');
		$('.coupons-only-selection-btn a').removeClass('current');
		$('.recipes-only-selection-btn a').addClass('current');
		$('.items-list').removeClass('d-none');
		$('.coupen-list').removeClass('d-block');
		$('.coupen-list').addClass('d-none');
		$('.recipe-list').removeClass('d-none');
		$('.recipe-list').addClass('d-block');
		$('.product-list').removeClass('d-block');
		$('.product-list').addClass('d-none');
	}
	bottomSliderDiv() {
		this.analytics.logEvent('@shoppingList_shareClick_count', {
			store_name: this.store_data[0]?.company_name,
			message: 'ShoppingList Share Button Clicked.'
		})
		if (this.store_data[0]?.googleMeasurementId) {
			(window as any).gtag('event', "@shoppingList_shareClick_count", {
				send_to: this.store_data[0]?.googleMeasurementId,
				store_name: this.store_data[0]?.company_name,
				message: 'ShoppingList Share Button Clicked.'
			});
		}
		$('.slider').toggleClass('close');
	}
	async ShowShoppingList() {
		if ($('.notification-container').hasClass('selected')) {
			$('.notification-container').removeClass('selected').addClass('dismiss');
			$("body").removeClass("OverlayBody");
			$(".sticky-nav").css("z-index", "1030");
		}
		$("#ShopDropdown").animate({
			right: "0"
		});
		$('.chervon-down-icon').addClass('d-none');
		$('.chervon-up-icon').removeClass('d-none');

		this.appTourService.cancelTour();

	}
	CloseShoppingList() {
		$("#ShopDropdown").animate({
			right: "-100%"
		});
		$('.chervon-up-icon').addClass('d-none');
		$('.chervon-down-icon').removeClass('d-none');
	}

	openHomePage() {
		const viewMode = localStorage.getItem('viewMode');
		if (viewMode !== 'null' && viewMode !== null) {
			if (this.is_list_view) {
				this.router.navigate(['/' + this.store_name_slug + '/list/' + this.current_list_id]);
			} else if (this.urlParam.has('preview') && this.urlParam.get('preview') === 'true' && viewMode !== 'undefined') {
				if (this.urlParam.has('type') && this.urlParam.get('type') === 'noad') {
					this.router.navigate(['/' + this.store_name_slug + '/' + viewMode], { queryParams: { preview: 'true', type: 'noad' } });
				} else {
					this.router.navigate(['/' + this.store_name_slug + '/' + viewMode], { queryParams: { preview: 'true' } });
				}
			} else {
				this.router.navigate(['/' + this.store_name_slug]);
			}
		} else {
			this.router.navigate(['/' + this.store_name_slug]);
		}
		this.removeFilter.emit();
	}

	@Output() checkoutClicked = new EventEmitter<void>();
	onCheckoutClick() {
		if (this.merchantId == '' || this.privateKey == '') {
			$('#paymentConfigModal').modal('show');
		} else {
			$('#checkoutModal').modal('show');
		}
		this.checkoutClicked.emit(); // Emit event to notify the modal component
	}

	openCircularPage() {
		const currentUrl = this.router.url;
		var viewMode = localStorage.getItem('viewMode');
		localStorage.setItem("printButton", 'Display')
		if (this.urlParam?.has('upcoming') && this.urlParam?.get('upcoming') === 'no') {
			localStorage.setItem('viewMode', 'upcoming');
			viewMode = localStorage.getItem('viewMode');
		}
		if (viewMode !== 'null' && viewMode !== null) {
			if (viewMode != 'upcoming') {
				localStorage.setItem('viewMode', this.current_onsale_data[0].uid);
				this.upcomingLink = false;
			} else {
				localStorage.setItem('viewMode', 'upcoming');
				this.upcomingLink = true;
			}
			viewMode = localStorage.getItem('viewMode');
			if (this.is_list_view) {
				this.router.navigate(['/' + this.store_name_slug + '/list/' + this.current_list_id]);
			} else if (this.urlParam.has('preview') && this.urlParam.get('preview') === 'true' && viewMode !== 'undefined') {
				if (this.urlParam.has('type') && (this.urlParam.get('type') === 'noad' || this.urlParam.get('type') === 'bundle' || this.urlParam.get('type') === 'menu' || this.urlParam.get('type') === 'coupon' || this.urlParam.get('type') === 'recipe')) {
					localStorage.setItem('viewMode', this.current_noad_layout_data[0].uid);
					viewMode = localStorage.getItem('viewMode');
					this.router.navigate(['/' + this.store_name_slug + '/' + viewMode], { queryParams: { preview: 'true', type: 'noad' } });
				} else {
					this.router.navigate(['/' + this.store_name_slug + '/' + viewMode], { queryParams: { preview: 'true' } });
				}
			}
			else {
				if (currentUrl.includes('/edit')) {
					this.router.navigate(['/' + this.store_name_slug + '/edit']);
				} else {
					this.router.navigate(['/' + this.store_name_slug]);
				}
			}
		} else {
			this.router.navigate(['/' + this.store_name_slug]);
		}
	}
	openBundlePage() {
		const currentUrl = this.router.url;
		var viewMode = localStorage.getItem('viewMode');
		localStorage.setItem("printButton", 'NotDisplay')
		if (viewMode !== 'null' && viewMode !== null) {
			if (viewMode == 'upcoming' || this.urlParam?.has('upcoming') && this.urlParam?.get('upcoming') === 'no') {
				this.upcomingLink = true;
			} else {
				this.upcomingLink = false;
			}

			localStorage.setItem('viewMode', this.current_bundle_data[0].uid);
			viewMode = localStorage.getItem('viewMode');
			if (this.is_list_view) {
				this.router.navigate(['/' + this.store_name_slug + '/bundles' + '/list/' + this.current_list_id]);
			} else if (this.urlParam.has('preview') && this.urlParam.get('preview') === 'true' && viewMode !== 'undefined') {
				if (this.urlParam.has('type') && (this.urlParam.get('type') === 'noad' || this.urlParam.get('type') === 'bundle' || this.urlParam.get('type') === 'menu' || this.urlParam.get('type') === 'coupon' || this.urlParam.get('type') === 'recipe')) {
					this.router.navigate(['/' + this.store_name_slug + '/bundles' + '/' + viewMode], { queryParams: { preview: 'true', type: 'bundle' } });
				} else {
					if (this.upcomingLink) {
						this.router.navigate(['/' + this.store_name_slug + '/bundles' + '/' + viewMode], { queryParams: { preview: 'true', upcoming: 'no' } });
					} else {
						this.router.navigate(['/' + this.store_name_slug + '/bundles' + '/' + viewMode], { queryParams: { preview: 'true' } });
					}
				}
			}
			else {
				if (currentUrl.includes('/edit')) {
					this.router.navigate(['/' + this.store_name_slug + '/bundles' + '/edit']);
				} else {
					this.router.navigate(['/' + this.store_name_slug + '/bundles']);
				}
			}
		} else {
			if (currentUrl.includes('/edit')) {
				this.router.navigate(['/' + this.store_name_slug + '/bundles' + '/edit']);
			} else {
				this.router.navigate(['/' + this.store_name_slug + '/bundles']);
			}
		}
	}
	openMenuPage() {
		const currentUrl = this.router.url;
		var viewMode = localStorage.getItem('viewMode');
		localStorage.setItem("printButton", 'NotDisplay')
		if (viewMode !== 'null' && viewMode !== null) {
			if (viewMode == 'upcoming' || this.urlParam?.has('upcoming') && this.urlParam?.get('upcoming') === 'no') {
				this.upcomingLink = true;
			} else {
				this.upcomingLink = false;
			}
			localStorage.setItem('viewMode', this.current_menu_data[0].uid);
			viewMode = localStorage.getItem('viewMode');
			if (this.is_list_view) {
				this.router.navigate(['/' + this.store_name_slug + '/menu' + '/list/' + this.current_list_id]);
			} else if (this.urlParam.has('preview') && this.urlParam.get('preview') === 'true' && viewMode !== 'undefined') {
				if (this.urlParam.has('type') && (this.urlParam.get('type') === 'noad' || this.urlParam.get('type') === 'bundle' || this.urlParam.get('type') === 'menu' || this.urlParam.get('type') === 'coupon' || this.urlParam.get('type') === 'recipe')) {
					this.router.navigate(['/' + this.store_name_slug + '/menu' + '/' + viewMode], { queryParams: { preview: 'true', type: 'menu' } });
				} else {
					if (this.upcomingLink) {
						this.router.navigate(['/' + this.store_name_slug + '/menu' + '/' + viewMode], { queryParams: { preview: 'true', upcoming: 'no' } });
					} else {
						this.router.navigate(['/' + this.store_name_slug + '/menu' + '/' + viewMode], { queryParams: { preview: 'true' } });
					}
				}
			}
			else {
				if (currentUrl.includes('/edit')) {
					this.router.navigate(['/' + this.store_name_slug + '/menu' + '/edit']);
				} else {
					this.router.navigate(['/' + this.store_name_slug + '/menu']);
				}
			}
		} else {
			if (currentUrl.includes('/edit')) {
				this.router.navigate(['/' + this.store_name_slug + '/menu' + '/edit']);
			} else {
				this.router.navigate(['/' + this.store_name_slug + '/menu']);
			}
		}
	}
	openCommunityPage() {
		const currentUrl = this.router.url;
		var viewMode = localStorage.getItem('viewMode');
		localStorage.setItem("printButton", 'NotDisplay')
		if (viewMode !== 'null' && viewMode !== null) {
			if (viewMode == 'upcoming' || this.urlParam?.has('upcoming') && this.urlParam?.get('upcoming') === 'no') {
				this.upcomingLink = true;
			} else {
				this.upcomingLink = false;
			}
			localStorage.setItem('viewMode', this.current_community_data[0].uid);
			viewMode = localStorage.getItem('viewMode');
			if (this.is_list_view) {
				this.router.navigate(['/' + this.store_name_slug + '/community' + '/list/' + this.current_list_id]);
			} else if (this.urlParam.has('preview') && this.urlParam.get('preview') === 'true' && viewMode !== 'undefined') {
				if (this.urlParam.has('type') && (this.urlParam.get('type') === 'noad' || this.urlParam.get('type') === 'bundle' || this.urlParam.get('type') === 'community' || this.urlParam.get('type') === 'coupon' || this.urlParam.get('type') === 'recipe')) {
					this.router.navigate(['/' + this.store_name_slug + '/community' + '/' + viewMode], { queryParams: { preview: 'true', type: 'community' } });
				} else {
					if (this.upcomingLink) {
						this.router.navigate(['/' + this.store_name_slug + '/community' + '/' + viewMode], { queryParams: { preview: 'true', upcoming: 'no' } });
					} else {
						this.router.navigate(['/' + this.store_name_slug + '/community' + '/' + viewMode], { queryParams: { preview: 'true' } });
					}
				}
			}
			else {
				if (currentUrl.includes('/edit')) {
					this.router.navigate(['/' + this.store_name_slug + '/community' + '/edit']);
				} else {
					this.router.navigate(['/' + this.store_name_slug + '/community']);
				}
			}
		} else {
			if (currentUrl.includes('/edit')) {
				this.router.navigate(['/' + this.store_name_slug + '/community' + '/edit']);
			} else {
				this.router.navigate(['/' + this.store_name_slug + '/community']);
			}
		}
	}
		openRestaurantPage() {
		const currentUrl = this.router.url;
		var viewMode = localStorage.getItem('viewMode');
		localStorage.setItem("printButton", 'Display')
		if (viewMode !== 'null' && viewMode !== null) {
			if (viewMode == 'upcoming' || this.urlParam?.has('upcoming') && this.urlParam?.get('upcoming') === 'no') {
				this.upcomingLink = true;
			} else {
				this.upcomingLink = false;
			}
			localStorage.setItem('viewMode', this.current_restaurant_data[0].uid);
			viewMode = localStorage.getItem('viewMode');
			if (this.is_list_view) {
				this.router.navigate(['/' + this.store_name_slug + '/restaurant' + '/list/' + this.current_list_id]);
			} else if (this.urlParam.has('preview') && this.urlParam.get('preview') === 'true' && viewMode !== 'undefined') {
				if (this.urlParam.has('type') && (this.urlParam.get('type') === 'noad' || this.urlParam.get('type') === 'bundle' || this.urlParam.get('type') === 'restaurant' || this.urlParam.get('type') === 'coupon' || this.urlParam.get('type') === 'recipe')) {
					this.router.navigate(['/' + this.store_name_slug + '/restaurant' + '/' + viewMode], { queryParams: { preview: 'true', type: 'restaurant' } });
				} else {
					if (this.upcomingLink) {
						this.router.navigate(['/' + this.store_name_slug + '/restaurant' + '/' + viewMode], { queryParams: { preview: 'true', upcoming: 'no' } });
					} else {
						this.router.navigate(['/' + this.store_name_slug + '/restaurant' + '/' + viewMode], { queryParams: { preview: 'true' } });
					}
				}
			}
			else {
				if (currentUrl.includes('/edit')) {
					this.router.navigate(['/' + this.store_name_slug + '/restaurant' + '/edit']);
				} else {
					this.router.navigate(['/' + this.store_name_slug + '/restaurant']);
				}
			}
		} else {
			if (currentUrl.includes('/edit')) {
				this.router.navigate(['/' + this.store_name_slug + '/restaurant' + '/edit']);
			} else {
				this.router.navigate(['/' + this.store_name_slug + '/restaurant']);
			}
		}
	}
	openCouponsPage() {
		const viewMode = localStorage.getItem('viewMode');
		localStorage.setItem("printButton", 'NotDisplay')
		if (viewMode !== 'null' && viewMode !== null) {
			if (viewMode == 'upcoming' || this.urlParam?.has('upcoming') && this.urlParam?.get('upcoming') === 'no') {
				this.upcomingLink = true;
			} else {
				this.upcomingLink = false;
			}
			if (this.is_list_view) {
				this.router.navigate(['/' + this.store_name_slug + '/coupons' + '/list/' + this.current_list_id]);
			} else if (this.urlParam.has('preview') && this.urlParam.get('preview') === 'true' && viewMode !== 'undefined') {
				if (this.urlParam.has('type') && (this.urlParam.get('type') === 'noad' || this.urlParam.get('type') === 'bundle' || this.urlParam.get('type') === 'menu' || this.urlParam.get('type') === 'coupon' || this.urlParam.get('type') === 'recipe')) {
					this.router.navigate(['/' + this.store_name_slug + '/coupons' + '/' + viewMode], { queryParams: { preview: 'true', type: 'coupon' } });
				} else {
					if (this.upcomingLink) {
						this.router.navigate(['/' + this.store_name_slug + '/coupons' + '/' + viewMode], { queryParams: { preview: 'true', upcoming: 'no' } });
					} else {
						this.router.navigate(['/' + this.store_name_slug + '/coupons' + '/' + viewMode], { queryParams: { preview: 'true' } });
					}
				}
			} else {
				this.router.navigate(['/' + this.store_name_slug + '/coupons']);
			}
		} else {
			this.router.navigate(['/' + this.store_name_slug + '/coupons']);
		}
	}

	openRecipesPage() {
		const viewMode = localStorage.getItem('viewMode');
		localStorage.setItem("printButton", 'NotDisplay')
		if (viewMode !== 'null' && viewMode !== null) {
			if (viewMode == 'upcoming' || this.urlParam?.has('upcoming') && this.urlParam?.get('upcoming') === 'no') {
				this.upcomingLink = true;
			} else {
				this.upcomingLink = false;
			}
			if (this.is_list_view) {
				this.router.navigate(['/' + this.store_name_slug + '/recipes' + '/list/' + this.current_list_id]);
			} else if (this.urlParam.has('preview') && this.urlParam.get('preview') === 'true' && viewMode !== 'undefined') {
				if (this.urlParam.has('type') && (this.urlParam.get('type') === 'noad' || this.urlParam.get('type') === 'bundle' || this.urlParam.get('type') === 'menu' || this.urlParam.get('type') === 'coupon' || this.urlParam.get('type') === 'recipe')) {
					this.router.navigate(['/' + this.store_name_slug + '/recipes' + '/' + viewMode], { queryParams: { preview: 'true', type: 'recipe' } });
				} else {
					if (this.upcomingLink) {
						this.router.navigate(['/' + this.store_name_slug + '/recipes' + '/' + viewMode], { queryParams: { preview: 'true', upcoming: 'no' } });
					} else {
						this.router.navigate(['/' + this.store_name_slug + '/recipes' + '/' + viewMode], { queryParams: { preview: 'true' } });
					}
				}
			}
			else {
				this.router.navigate(['/' + this.store_name_slug + '/recipes']);
			}
		} else {
			this.router.navigate(['/' + this.store_name_slug + '/recipes']);
		}
	}

	async ngOnChanges(changes: SimpleChanges): Promise<void> {
		if (changes['serializedData'] || changes['serializedData']?.currentValue || changes['serializedBundleData'] || changes['serializedBundleData']?.currentValue || changes['serializedMenuData'] || changes['serializedMenuData']?.currentValue || changes['serializedCommunityData'] || changes['serializedCommunityData']?.currentValue || changes['serializedRestaurantData'] || changes['serializedRestaurantData']?.currentValue) {
			if (this.serializedData?.length > 0 || this.serializedBundleData?.length > 0 || this.serializedMenuData?.length > 0 || this.serializedRestaurantData?.length > 0) {
				if (this.current_list_id !== '') {
					this.combinedData = []
					if (this.serializedData?.length > 0) {
						this.combinedData.push(...this.serializedData);
					}
					if (this.serializedBundleData?.length > 0) {
						this.combinedData.push(...this.serializedBundleData);
					}
					if (this.serializedMenuData?.length > 0) {
						this.combinedData.push(...this.serializedMenuData);
					}
					if (this.serializedCommunityData?.length > 0) {
						this.combinedData.push(...this.serializedCommunityData);
					}
					if (this.serializedRestaurantData?.length > 0) {
						this.combinedData.push(...this.serializedRestaurantData);
					}
					this.qr_value = window.location.href + '/list/' + this.current_list_id;

					try {
						const currentListSnapshot = await this.afs.collection('/list').doc(this.current_list_id).get().toPromise();
						const currentListData: any = currentListSnapshot.data();

						this.cartItem = currentListData?.items;
						let finalCurrentListData;
						if (currentListData?.past_items) {
							finalCurrentListData = [...currentListData?.items, ...currentListData?.past_items];
						} else {
							finalCurrentListData = currentListData?.items;
						}

						const commonItems = [];
						for (const storeItem of this.combinedData) {
							const storeItemUid = storeItem.id;
							if (storeItem?.id) {
								const isCommon = finalCurrentListData.some(cartItem => {
									return cartItem.product.id == storeItem.id || cartItem.product.uid == storeItem.id;
								});
								if (isCommon) {
									commonItems.push(storeItem);
								}
							}
						}
						for (const storeItem of this.store_item) {
							const storeItemUid = storeItem.id;
							if (storeItem?.uid) {
								const isCommon = finalCurrentListData.some(cartItem => {
									return cartItem.product.uid == storeItem.uid;
								});
								if (isCommon) {
									commonItems.push(storeItem);
								}
							}
						}

						this.past_item = [];
						this.cartItem = [];

						for (const currentCartItem of finalCurrentListData) {
							let storeItem
							if (currentCartItem.product.id) {
								storeItem = commonItems.find(item => item.id == currentCartItem.product.id);
							} else {
								storeItem = commonItems.find(item => item.uid == currentCartItem.product.uid);
							}
							if (storeItem && (
								currentCartItem?.product?.price_label_value1 !== storeItem?.price_label_value1 ||
								currentCartItem?.product?.price_label_value2 !== storeItem?.price_label_value2 ||
								currentCartItem?.product?.price_label_value3 !== storeItem?.price_label_value3 ||
								currentCartItem?.product?.sale_price_label_value1 !== storeItem?.sale_price_label_value1 ||
								currentCartItem?.product?.sale_price_label_value2 !== storeItem?.sale_price_label_value2 ||
								currentCartItem?.product?.sale_price_label_value3 !== storeItem?.sale_price_label_value3)

							) {
								this.past_item.push(currentCartItem);
							} else {
								this.cartItem.push(currentCartItem);
							}
						}
						await this.afs.collection('/list').doc(this.current_list_id).update({
							items: this.cartItem,
							past_items: this.past_item
						});
					} catch (error) {
						console.error("Error:", error);
					}
					if (this.current_list_id !== '') {
						this.afs.collection('/coupons', ref => ref.where('store_uid', '==', this.current_store_uid).where('is_publish', '==', true).orderBy('created_at', 'desc')).snapshotChanges().subscribe(async data => {
							this.coupons_list = data.map(e => {
								const validTillTimestamp = e.payload.doc.data()['valid_till'].seconds * 1000;
								const validTillDate = new Date(validTillTimestamp);
								validTillDate.setHours(0, 0, 0, 0);
								const currentDate = new Date();
								currentDate.setHours(0, 0, 0, 0);
								if (validTillDate >= currentDate) {
									return {
										uid: e.payload.doc.id,
										coupon_image: e.payload.doc.data()['coupon_image'] ? e.payload.doc.data()['coupon_image'] : "https://placehold.co/300x200/2e2e2e/2e2e2e",
										upc: e.payload.doc.data()['upc'],
										coupon_description: e.payload.doc.data()['coupon_description'],
										label: e.payload.doc.data()['label'],
										coupon_code: e.payload.doc.data()['coupon_code'],
										valid_from: e.payload.doc.data()['valid_from'],
										valid_till: e.payload.doc.data()['valid_till'],
									};
								} else {
									return {
										uid: e.payload.doc.id,
										valid_till: 'expired'
									}
								}
							});
							// this.serializedIds = this.combinedData.map(s => s.id)
							this.serializedIds = this.combinedData?.flatMap(s => {
								if (s?.subGridOpts?.children?.length) {
									return s.subGridOpts.children.map(child => child.id);
								} else {
									return [s.id];
								}
							});
							
							const currentListSnapshot = await this.afs.collection('/list').doc(this.current_list_id).get().toPromise();
							const currentListData: any = currentListSnapshot.data();
							if (currentListData?.items) {
								const updatedCartItems = [];
								const updatedPastItems = [];
								const CouponItems = currentListData.items.filter((a) => a.isCoupon == true)
								const RecipeItems = currentListData.items.filter((a) => a.isRecipe == true)
								const filterCartItems = currentListData.items.filter((a) => a.isRecipe != true && a.isCoupon != true);
								const filterPastItems = currentListData.past_items.filter((a) => a.isRecipe != true && a.isCoupon != true);
								updatedCartItems.push(...RecipeItems)
								CouponItems.forEach(currentCartItem => {
									if (currentCartItem.isCoupon) {
										this.coupons_list?.forEach(item => {
											if (item?.uid == currentCartItem?.product?.uid) {
												const validTillDate = new Date(currentCartItem.product.valid_till);
												validTillDate.setHours(0, 0, 0, 0);
												const currentDate = new Date();
												currentDate.setHours(0, 0, 0, 0);
												if (item.valid_till == 'expired' || validTillDate < currentDate) {
													currentCartItem.product = {
														...currentCartItem.product,
														isExpired: 'Yes'
													};
													updatedCartItems.push(currentCartItem)
												} else {
													currentCartItem.product = {
														...currentCartItem.product,
														isExpired: 'No'
													};
													updatedCartItems.push(currentCartItem)
												}
											}
										})

									}
								})
								for (const currentCartItem of filterCartItems) {
									if (currentCartItem.product.id) {
										if (!this.serializedIds.includes(currentCartItem.product.id) && !currentCartItem.static) {
											updatedPastItems.push(currentCartItem);
										} else {
											updatedCartItems.push(currentCartItem);
										}
									} else {
										if (!this.serializedIds.includes(currentCartItem.product.uid) && !currentCartItem.static) {
											updatedPastItems.push(currentCartItem);
										} else {
											updatedCartItems.push(currentCartItem);
										}
									}
								}
								for (const currentPastItem of filterPastItems) {
									updatedPastItems.push(currentPastItem);
								}
								this.past_item = updatedPastItems;
								this.cartItem = updatedCartItems
								const totalAmount = this.cartItem.reduce((total, item) => {
									// Remove the '$' symbol and convert to a floating-point number
									const amount = parseFloat(item.Amount) * item.count;
									return total + amount;;
								}, 0); // 
								this.totalAmount = totalAmount;
								await this.afs.collection('/list').doc(this.current_list_id).update({
									items: updatedCartItems,
									past_items: updatedPastItems
								});
							}
						});
					}
				}
			}
		}

	}
	async ngOnDestroy() {
		this.subscription.unsubscribe()
		if (this.authSubscription) {
			await this.authSubscription.unsubscribe();
		}
	}
}

@Component({
	selector: 'dialog-animations-example-dialog',
	templateUrl: 'dialog-animations-example-dialog.html',
})
export class DialogAnimationsExampleDialog {
	constructor(public dialogRef: MatDialogRef<DialogAnimationsExampleDialog>) { }
}
@Component({
	selector: 'dialog-animations-example-dialog',
	templateUrl: 'dialog-animations-example-dialog-android.html',
})
export class DialogAnimationsExampleDialogAndroid {
	constructor(public dialogRef: MatDialogRef<DialogAnimationsExampleDialogAndroid>) { }
}